//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkResetCodeExpireDate(body: CheckResetCodeExpireDateInput | undefined): Observable<CheckResetCodeExpireDateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/CheckResetCodeExpireDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckResetCodeExpireDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckResetCodeExpireDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckResetCodeExpireDateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckResetCodeExpireDateOutput>;
        }));
    }

    protected processCheckResetCodeExpireDate(response: HttpResponseBase): Observable<CheckResetCodeExpireDateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckResetCodeExpireDateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalInscritoEmpresa(body: TotalEmpresaRequestDto | undefined): Observable<TotalInscritoEmpresaResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalInscritoEmpresa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalInscritoEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalInscritoEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalInscritoEmpresaResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalInscritoEmpresaResponseDto[]>;
        }));
    }

    protected processTotalInscritoEmpresa(response: HttpResponseBase): Observable<TotalInscritoEmpresaResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TotalInscritoEmpresaResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalInscritoVagaAberta(body: FiltroMicrorregioesDto | undefined): Observable<TotalInscritoVagaAbertaResponse> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalInscritoVagaAberta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalInscritoVagaAberta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalInscritoVagaAberta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalInscritoVagaAbertaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalInscritoVagaAbertaResponse>;
        }));
    }

    protected processTotalInscritoVagaAberta(response: HttpResponseBase): Observable<TotalInscritoVagaAbertaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotalInscritoVagaAbertaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalVagas(body: FiltroMicrorregioesDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalVagas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalVagas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalVagas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalVagas(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalVagasNaoExcluidas(body: FiltroMicrorregioesDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalVagasNaoExcluidas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalVagasNaoExcluidas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalVagasNaoExcluidas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalVagasNaoExcluidas(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalEmpresas(body: FiltroMicrorregioesDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalEmpresas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalEmpresas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalEmpresas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalEmpresas(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalCandidatosCadastroIncompletos(body: FiltroMicrorregioesDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalCandidatosCadastroIncompletos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalCandidatosCadastroIncompletos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalCandidatosCadastroIncompletos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalCandidatosCadastroIncompletos(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filtroMensal (optional) 
     * @param body (optional) 
     * @return Success
     */
    totalSelecionadosEntrevista(filtroMensal: boolean | undefined, body: FiltroMicrorregioesDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalSelecionadosEntrevista?";
        if (filtroMensal === null)
            throw new Error("The parameter 'filtroMensal' cannot be null.");
        else if (filtroMensal !== undefined)
            url_ += "filtroMensal=" + encodeURIComponent("" + filtroMensal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalSelecionadosEntrevista(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalSelecionadosEntrevista(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalSelecionadosEntrevista(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filtroMensal (optional) 
     * @param body (optional) 
     * @return Success
     */
    totalContratados(filtroMensal: boolean | undefined, body: FiltroMicrorregioesDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalContratados?";
        if (filtroMensal === null)
            throw new Error("The parameter 'filtroMensal' cannot be null.");
        else if (filtroMensal !== undefined)
            url_ += "filtroMensal=" + encodeURIComponent("" + filtroMensal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalContratados(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalContratados(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalContratados(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filtroMensal (optional) 
     * @param body (optional) 
     * @return Success
     */
    totalInscritos(filtroMensal: boolean | undefined, body: FiltroMicrorregioesDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalInscritos?";
        if (filtroMensal === null)
            throw new Error("The parameter 'filtroMensal' cannot be null.");
        else if (filtroMensal !== undefined)
            url_ += "filtroMensal=" + encodeURIComponent("" + filtroMensal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalInscritos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalInscritos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalInscritos(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalVagaEmpresa(body: TotalEmpresaRequestDto | undefined): Observable<TotalVagaEmpresaResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalVagaEmpresa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalVagaEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalVagaEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalVagaEmpresaResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalVagaEmpresaResponseDto[]>;
        }));
    }

    protected processTotalVagaEmpresa(response: HttpResponseBase): Observable<TotalVagaEmpresaResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TotalVagaEmpresaResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalInscricaoCandidato(body: TotalInscricaoCandidatoRequestDto | undefined): Observable<TotalInscricaoCandidatoResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalInscricaoCandidato";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalInscricaoCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalInscricaoCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalInscricaoCandidatoResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalInscricaoCandidatoResponseDto[]>;
        }));
    }

    protected processTotalInscricaoCandidato(response: HttpResponseBase): Observable<TotalInscricaoCandidatoResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TotalInscricaoCandidatoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalContratadoNaoContratado(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalContratadoNaoContratado";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalContratadoNaoContratado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalContratadoNaoContratado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalContratadoNaoContratado(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalSelecionadoNaoSelecionadoEntrevista(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalSelecionadoNaoSelecionadoEntrevista";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalSelecionadoNaoSelecionadoEntrevista(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalSelecionadoNaoSelecionadoEntrevista(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalSelecionadoNaoSelecionadoEntrevista(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalBeneficiarioSuzanoSkillConecta(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalBeneficiarioSuzanoSkillConecta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalBeneficiarioSuzanoSkillConecta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalBeneficiarioSuzanoSkillConecta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalBeneficiarioSuzanoSkillConecta(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalRendaFamiliar(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalRendaFamiliar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalRendaFamiliar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalRendaFamiliar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalRendaFamiliar(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalComoConheceuCandidato(body: FiltroCandidatosDto | undefined): Observable<ComoConheceuCanditaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalComoConheceuCandidato";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalComoConheceuCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalComoConheceuCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComoConheceuCanditaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComoConheceuCanditaoDto[]>;
        }));
    }

    protected processTotalComoConheceuCandidato(response: HttpResponseBase): Observable<ComoConheceuCanditaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ComoConheceuCanditaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalMotivoEncerramento(body: FiltroMicrorregioesDto | undefined): Observable<MotivoEncerramentoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalMotivoEncerramento";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalMotivoEncerramento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalMotivoEncerramento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MotivoEncerramentoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MotivoEncerramentoDto[]>;
        }));
    }

    protected processTotalMotivoEncerramento(response: HttpResponseBase): Observable<MotivoEncerramentoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MotivoEncerramentoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalComoConheceuEmpresa(body: FiltroMicrorregioesDto | undefined): Observable<ComoConheceuEmpresaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalComoConheceuEmpresa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalComoConheceuEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalComoConheceuEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComoConheceuEmpresaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComoConheceuEmpresaDto[]>;
        }));
    }

    protected processTotalComoConheceuEmpresa(response: HttpResponseBase): Observable<ComoConheceuEmpresaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ComoConheceuEmpresaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalGeneroCandidatos(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalGeneroCandidatos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalGeneroCandidatos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalGeneroCandidatos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalGeneroCandidatos(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalCorRacaCandidatos(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalCorRacaCandidatos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalCorRacaCandidatos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalCorRacaCandidatos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalCorRacaCandidatos(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalCandidatosPCD(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalCandidatosPCD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalCandidatosPCD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalCandidatosPCD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalCandidatosPCD(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalQuantidadePessoasFamiliaCandidatos(body: FiltroCandidatosDto | undefined): Observable<DescricaoTotalResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalQuantidadePessoasFamiliaCandidatos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalQuantidadePessoasFamiliaCandidatos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalQuantidadePessoasFamiliaCandidatos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescricaoTotalResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescricaoTotalResponseDto[]>;
        }));
    }

    protected processTotalQuantidadePessoasFamiliaCandidatos(response: HttpResponseBase): Observable<DescricaoTotalResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DescricaoTotalResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalCadastros(body: TotalCadastroRequestDto | undefined): Observable<TotalPeriodoDescricaoResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalCadastros";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalCadastros(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalCadastros(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalPeriodoDescricaoResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalPeriodoDescricaoResponseDto[]>;
        }));
    }

    protected processTotalCadastros(response: HttpResponseBase): Observable<TotalPeriodoDescricaoResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TotalPeriodoDescricaoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    totalCadastrosV2_Antigo(body: TotalCadastroRequestDto | undefined): Observable<TotalPeriodoDescricaoResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalCadastrosV2_Antigo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalCadastrosV2_Antigo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalCadastrosV2_Antigo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalPeriodoDescricaoResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalPeriodoDescricaoResponseDto[]>;
        }));
    }

    protected processTotalCadastrosV2_Antigo(response: HttpResponseBase): Observable<TotalPeriodoDescricaoResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TotalPeriodoDescricaoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalInscritosSelecionadosContratadosV2(body: TotalCadastroRequestDto | undefined): Observable<TotalInscritosSelecionadosContratadosResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalInscritosSelecionadosContratadosV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalInscritosSelecionadosContratadosV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalInscritosSelecionadosContratadosV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalInscritosSelecionadosContratadosResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalInscritosSelecionadosContratadosResponseDto>;
        }));
    }

    protected processTotalInscritosSelecionadosContratadosV2(response: HttpResponseBase): Observable<TotalInscritosSelecionadosContratadosResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotalInscritosSelecionadosContratadosResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalCadastrosV2(body: TotalCadastroRequestDto | undefined): Observable<TotalPeriodoDescricaoResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/TotalCadastrosV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalCadastrosV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalCadastrosV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalPeriodoDescricaoResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalPeriodoDescricaoResponseDto[]>;
        }));
    }

    protected processTotalCadastrosV2(response: HttpResponseBase): Observable<TotalPeriodoDescricaoResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TotalPeriodoDescricaoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @param ano (optional) 
     * @return Success
     */
    getAcessosPorAno(microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined, ano: number | undefined): Observable<UserAccessDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/GetAcessosPorAno?";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        if (ano === null)
            throw new Error("The parameter 'ano' cannot be null.");
        else if (ano !== undefined)
            url_ += "ano=" + encodeURIComponent("" + ano) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcessosPorAno(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcessosPorAno(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessDashboardDto>;
        }));
    }

    protected processGetAcessosPorAno(response: HttpResponseBase): Observable<UserAccessDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @param mes (optional) 
     * @param ano (optional) 
     * @return Success
     */
    getAcessosPorMes(microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined, mes: number | undefined, ano: number | undefined): Observable<UserAccessDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/GetAcessosPorMes?";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        if (mes === null)
            throw new Error("The parameter 'mes' cannot be null.");
        else if (mes !== undefined)
            url_ += "mes=" + encodeURIComponent("" + mes) + "&";
        if (ano === null)
            throw new Error("The parameter 'ano' cannot be null.");
        else if (ano !== undefined)
            url_ += "ano=" + encodeURIComponent("" + ano) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcessosPorMes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcessosPorMes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessDashboardDto>;
        }));
    }

    protected processGetAcessosPorMes(response: HttpResponseBase): Observable<UserAccessDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @return Success
     */
    getComparativoAnualAcessos(microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined): Observable<UserAccessDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/GetComparativoAnualAcessos?";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComparativoAnualAcessos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComparativoAnualAcessos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessDashboardDto>;
        }));
    }

    protected processGetComparativoAnualAcessos(response: HttpResponseBase): Observable<UserAccessDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdministradorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAdministradorDto | undefined): Observable<AdministradorDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministradorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministradorDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdministradorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministradorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    createAfterPermission(userId: number | undefined): Observable<AdministradorDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/CreateAfterPermission?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAfterPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAfterPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministradorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministradorDto>;
        }));
    }

    protected processCreateAfterPermission(response: HttpResponseBase): Observable<AdministradorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministradorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AdministradorDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministradorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministradorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdministradorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministradorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @return Success
     */
    getAcessosAll(microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined): Observable<UserAccessDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetAcessosAll?";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcessosAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcessosAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessDashboardDto>;
        }));
    }

    protected processGetAcessosAll(response: HttpResponseBase): Observable<UserAccessDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @return Success
     */
    getAcessosYear(year: number | undefined, microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined): Observable<UserAccessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetAcessosYear?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcessosYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcessosYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessDto[]>;
        }));
    }

    protected processGetAcessosYear(response: HttpResponseBase): Observable<UserAccessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserAccessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ano (optional) 
     * @param mes (optional) 
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @return Success
     */
    getAcessosDistintosDia(ano: number | undefined, mes: number | undefined, microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined): Observable<UserAccessDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetAcessosDistintosDia?";
        if (ano === null)
            throw new Error("The parameter 'ano' cannot be null.");
        else if (ano !== undefined)
            url_ += "ano=" + encodeURIComponent("" + ano) + "&";
        if (mes === null)
            throw new Error("The parameter 'mes' cannot be null.");
        else if (mes !== undefined)
            url_ += "mes=" + encodeURIComponent("" + mes) + "&";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcessosDistintosDia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcessosDistintosDia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessDto>;
        }));
    }

    protected processGetAcessosDistintosDia(response: HttpResponseBase): Observable<UserAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ano (optional) 
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @return Success
     */
    getAcessosDistintosMes(ano: number | undefined, microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined): Observable<UserAccessDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetAcessosDistintosMes?";
        if (ano === null)
            throw new Error("The parameter 'ano' cannot be null.");
        else if (ano !== undefined)
            url_ += "ano=" + encodeURIComponent("" + ano) + "&";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcessosDistintosMes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcessosDistintosMes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessDto>;
        }));
    }

    protected processGetAcessosDistintosMes(response: HttpResponseBase): Observable<UserAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAbp(): Observable<AdministradorDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetAbp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAbp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAbp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministradorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministradorDto>;
        }));
    }

    protected processGetAbp(response: HttpResponseBase): Observable<AdministradorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministradorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFotoPerfil(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetFotoPerfil";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFotoPerfil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFotoPerfil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFotoPerfil(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAdministradores(): Observable<AdministradorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetAdministradores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdministradores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdministradores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministradorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministradorDto[]>;
        }));
    }

    protected processGetAdministradores(response: HttpResponseBase): Observable<AdministradorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AdministradorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param nome (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(cpf: string | null | undefined, nome: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AdministradorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetAll?";
        if (cpf !== undefined && cpf !== null)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministradorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministradorDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AdministradorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministradorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAdministradorDto | undefined): Observable<AdministradorDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministradorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministradorDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AdministradorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministradorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAdministradorAfterLostPermission(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/DeleteAdministradorAfterLostPermission?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAdministradorAfterLostPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAdministradorAfterLostPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAdministradorAfterLostPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertLogoEmpresas(body: CreateLogoEmpresasDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/InsertLogoEmpresas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertLogoEmpresas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertLogoEmpresas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertLogoEmpresas(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getLogoEmpresasPagedResult(maxResultCount: number | undefined, skipCount: number | undefined): Observable<LogoEmpresaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetLogoEmpresasPagedResult?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogoEmpresasPagedResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogoEmpresasPagedResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogoEmpresaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogoEmpresaDtoPagedResultDto>;
        }));
    }

    protected processGetLogoEmpresasPagedResult(response: HttpResponseBase): Observable<LogoEmpresaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogoEmpresaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLogoEmpresa(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/DeleteLogoEmpresa?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLogoEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogoEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLogoEmpresa(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLogoEmpresas(): Observable<LogoEmpresaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/GetLogoEmpresas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogoEmpresas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogoEmpresas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogoEmpresaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogoEmpresaDto[]>;
        }));
    }

    protected processGetLogoEmpresas(response: HttpResponseBase): Observable<LogoEmpresaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LogoEmpresaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enviarEmailContato(body: EmailContatoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administrador/EnviarEmailContato";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarEmailContato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarEmailContato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnviarEmailContato(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AvaliacaoRequisitoVagaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AvaliacaoRequisitoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/AvaliacaoRequisitoVaga/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvaliacaoRequisitoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvaliacaoRequisitoVagaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AvaliacaoRequisitoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvaliacaoRequisitoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idAvaliacao (optional) 
     * @return Success
     */
    getRespostasAvaliacao(idAvaliacao: string | undefined): Observable<RespostaAvaliacaoRequisitoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AvaliacaoRequisitoVaga/GetRespostasAvaliacao?";
        if (idAvaliacao === null)
            throw new Error("The parameter 'idAvaliacao' cannot be null.");
        else if (idAvaliacao !== undefined)
            url_ += "idAvaliacao=" + encodeURIComponent("" + idAvaliacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRespostasAvaliacao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRespostasAvaliacao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RespostaAvaliacaoRequisitoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RespostaAvaliacaoRequisitoDto[]>;
        }));
    }

    protected processGetRespostasAvaliacao(response: HttpResponseBase): Observable<RespostaAvaliacaoRequisitoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RespostaAvaliacaoRequisitoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAvaliacaoRequisitoVagaDto | undefined): Observable<AvaliacaoRequisitoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/AvaliacaoRequisitoVaga/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvaliacaoRequisitoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvaliacaoRequisitoVagaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AvaliacaoRequisitoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvaliacaoRequisitoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAvaliacaoRequisitoVagaDto | undefined): Observable<AvaliacaoRequisitoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/AvaliacaoRequisitoVaga/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvaliacaoRequisitoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvaliacaoRequisitoVagaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AvaliacaoRequisitoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvaliacaoRequisitoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<AvaliacaoRequisitoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AvaliacaoRequisitoVaga/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvaliacaoRequisitoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvaliacaoRequisitoVagaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AvaliacaoRequisitoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AvaliacaoRequisitoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CandidatoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLoggedCandidato(): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/GetLoggedCandidato";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoggedCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processGetLoggedCandidato(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCandidatoDto | undefined): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cadastrarCandidatoViaPortalAdmin(body: CreateCandidatoAdminDto | undefined): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/CadastrarCandidatoViaPortalAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCadastrarCandidatoViaPortalAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCadastrarCandidatoViaPortalAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processCadastrarCandidatoViaPortalAdmin(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAbp(): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/GetAbp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAbp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAbp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processGetAbp(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFotoPerfil(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/GetFotoPerfil";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFotoPerfil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFotoPerfil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFotoPerfil(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    validarCandidatoCadastradoPeloAdmin(email: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/ValidarCandidatoCadastradoPeloAdmin?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidarCandidatoCadastradoPeloAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidarCandidatoCadastradoPeloAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processValidarCandidatoCadastradoPeloAdmin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCandidatos(): Observable<CandidatoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/GetCandidatos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto[]>;
        }));
    }

    protected processGetCandidatos(response: HttpResponseBase): Observable<CandidatoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    obterDataUltimaExibicaoLembrete(candidatoId: string | undefined): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/ObterDataUltimaExibicaoLembrete?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObterDataUltimaExibicaoLembrete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObterDataUltimaExibicaoLembrete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processObterDataUltimaExibicaoLembrete(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    atualizarDataExibicaoLembrete(candidatoId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/AtualizarDataExibicaoLembrete?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtualizarDataExibicaoLembrete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtualizarDataExibicaoLembrete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAtualizarDataExibicaoLembrete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param nome (optional) 
     * @param dataCadastroInicial (optional) 
     * @param dataCadastroFinal (optional) 
     * @param empresaId (optional) 
     * @param pcd (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param microrregioes (optional) 
     * @param status (optional) 
     * @param prestadoraSuzano (optional) 
     * @param dataContratacaoInicial (optional) 
     * @param dataContratacaoFinal (optional) 
     * @param tituloVaga (optional) 
     * @param candidatoExcluido (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(cpf: string | null | undefined, nome: string | null | undefined, dataCadastroInicial: string | null | undefined, dataCadastroFinal: string | null | undefined, empresaId: string | null | undefined, pcd: boolean | undefined, cidade: string | null | undefined, bairro: string | null | undefined, microrregioes: string[] | null | undefined, status: number | null | undefined, prestadoraSuzano: boolean | null | undefined, dataContratacaoInicial: string | null | undefined, dataContratacaoFinal: string | null | undefined, tituloVaga: string | null | undefined, candidatoExcluido: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/GetAll?";
        if (cpf !== undefined && cpf !== null)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (dataCadastroInicial !== undefined && dataCadastroInicial !== null)
            url_ += "DataCadastroInicial=" + encodeURIComponent("" + dataCadastroInicial) + "&";
        if (dataCadastroFinal !== undefined && dataCadastroFinal !== null)
            url_ += "DataCadastroFinal=" + encodeURIComponent("" + dataCadastroFinal) + "&";
        if (empresaId !== undefined && empresaId !== null)
            url_ += "EmpresaId=" + encodeURIComponent("" + empresaId) + "&";
        if (pcd === null)
            throw new Error("The parameter 'pcd' cannot be null.");
        else if (pcd !== undefined)
            url_ += "Pcd=" + encodeURIComponent("" + pcd) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (microrregioes !== undefined && microrregioes !== null)
            microrregioes && microrregioes.forEach(item => { url_ += "Microrregioes=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (prestadoraSuzano !== undefined && prestadoraSuzano !== null)
            url_ += "PrestadoraSuzano=" + encodeURIComponent("" + prestadoraSuzano) + "&";
        if (dataContratacaoInicial !== undefined && dataContratacaoInicial !== null)
            url_ += "DataContratacaoInicial=" + encodeURIComponent("" + dataContratacaoInicial) + "&";
        if (dataContratacaoFinal !== undefined && dataContratacaoFinal !== null)
            url_ += "DataContratacaoFinal=" + encodeURIComponent("" + dataContratacaoFinal) + "&";
        if (tituloVaga !== undefined && tituloVaga !== null)
            url_ += "TituloVaga=" + encodeURIComponent("" + tituloVaga) + "&";
        if (candidatoExcluido === null)
            throw new Error("The parameter 'candidatoExcluido' cannot be null.");
        else if (candidatoExcluido !== undefined)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CandidatoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCandidatoDto | undefined): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetCurriculo(body: CurriculoDadoPessoal | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/ResetCurriculo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetCurriculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetCurriculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetCurriculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    usuarioCandidatoExiste(email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/UsuarioCandidatoExiste?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsuarioCandidatoExiste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsuarioCandidatoExiste(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUsuarioCandidatoExiste(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @param favorito (optional) 
     * @param recentes (optional) 
     * @param contratado (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCandidatosVaga(vagaId: string | undefined, favorito: boolean | null | undefined, recentes: boolean | null | undefined, contratado: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaEspecialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/GetCandidatosVaga?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "VagaId=" + encodeURIComponent("" + vagaId) + "&";
        if (favorito !== undefined && favorito !== null)
            url_ += "Favorito=" + encodeURIComponent("" + favorito) + "&";
        if (recentes !== undefined && recentes !== null)
            url_ += "Recentes=" + encodeURIComponent("" + recentes) + "&";
        if (contratado === null)
            throw new Error("The parameter 'contratado' cannot be null.");
        else if (contratado !== undefined)
            url_ += "Contratado=" + encodeURIComponent("" + contratado) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatosVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatosVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaEspecialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaEspecialDtoPagedResultDto>;
        }));
    }

    protected processGetCandidatosVaga(response: HttpResponseBase): Observable<CandidatoVagaEspecialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaEspecialDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    relatorioCandidatosCadastrados(body: FiltroRelatorioCandidatosCadastradosDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/RelatorioCandidatosCadastrados";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelatorioCandidatosCadastrados(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelatorioCandidatosCadastrados(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRelatorioCandidatosCadastrados(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usuarioId (optional) 
     * @return Success
     */
    exportarPdfCurriculo(usuarioId: number | null | undefined): Observable<ReportCurriculoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/ExportarPdfCurriculo?";
        if (usuarioId !== undefined && usuarioId !== null)
            url_ += "usuarioId=" + encodeURIComponent("" + usuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportarPdfCurriculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportarPdfCurriculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportCurriculoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportCurriculoDto>;
        }));
    }

    protected processExportarPdfCurriculo(response: HttpResponseBase): Observable<ReportCurriculoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportCurriculoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idVaga (optional) 
     * @return Success
     */
    tentativaCandidatarVaga(idVaga: string | undefined): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/TentativaCandidatarVaga?";
        if (idVaga === null)
            throw new Error("The parameter 'idVaga' cannot be null.");
        else if (idVaga !== undefined)
            url_ += "idVaga=" + encodeURIComponent("" + idVaga) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTentativaCandidatarVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTentativaCandidatarVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processTentativaCandidatarVaga(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    limparTentativaCandidatarVaga(): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/LimparTentativaCandidatarVaga";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLimparTentativaCandidatarVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLimparTentativaCandidatarVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processLimparTentativaCandidatarVaga(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    desabilitarEmailNovaVaga(candidatoId: string | undefined): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/DesabilitarEmailNovaVaga?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesabilitarEmailNovaVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesabilitarEmailNovaVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processDesabilitarEmailNovaVaga(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nome (optional) 
     * @param id (optional) 
     * @return Success
     */
    getCandidatosByComunidade(nome: string | null | undefined, id: string | undefined): Observable<CandidatoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/GetCandidatosByComunidade?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatosByComunidade(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatosByComunidade(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto[]>;
        }));
    }

    protected processGetCandidatosByComunidade(response: HttpResponseBase): Observable<CandidatoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCandidatosFromExcel(body: ImportTableDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidato/CreateCandidatosFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCandidatosFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCandidatosFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCandidatosFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CandidatoFormacaoAcademicaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCandidatoFormacaoAcademicaDto | undefined): Observable<CandidatoFormacaoAcademicaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoFormacaoAcademica/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoFormacaoAcademicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoFormacaoAcademicaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CandidatoFormacaoAcademicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoFormacaoAcademicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CandidatoFormacaoAcademicaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoFormacaoAcademica/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoFormacaoAcademicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoFormacaoAcademicaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CandidatoFormacaoAcademicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoFormacaoAcademicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CandidatoFormacaoAcademicaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoFormacaoAcademica/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoFormacaoAcademicaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoFormacaoAcademicaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CandidatoFormacaoAcademicaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoFormacaoAcademicaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<CandidatoFormacaoAcademicaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoFormacaoAcademica/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoFormacaoAcademicaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoFormacaoAcademicaDto[]>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<CandidatoFormacaoAcademicaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoFormacaoAcademicaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(candidatoId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoFormacaoAcademicaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoFormacaoAcademica/GetAllPaged?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoFormacaoAcademicaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoFormacaoAcademicaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<CandidatoFormacaoAcademicaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoFormacaoAcademicaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCandidatoFormacaoAcademicaDto | undefined): Observable<CandidatoFormacaoAcademicaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoFormacaoAcademica/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoFormacaoAcademicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoFormacaoAcademicaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CandidatoFormacaoAcademicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoFormacaoAcademicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoFormacaoAcademica/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CandidatoIdiomaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCandidatoIdiomaDto | undefined): Observable<CandidatoIdiomaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoIdioma/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoIdiomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoIdiomaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CandidatoIdiomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoIdiomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CandidatoIdiomaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoIdioma/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoIdiomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoIdiomaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CandidatoIdiomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoIdiomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CandidatoIdiomaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoIdioma/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoIdiomaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoIdiomaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CandidatoIdiomaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoIdiomaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<CandidatoIdiomaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoIdioma/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoIdiomaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoIdiomaDto[]>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<CandidatoIdiomaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoIdiomaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCandidatoIdiomaDto | undefined): Observable<CandidatoIdiomaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoIdioma/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoIdiomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoIdiomaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CandidatoIdiomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoIdiomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param idiomaId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(candidatoId: string | null | undefined, idiomaId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoIdiomaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoIdioma/GetAllPaged?";
        if (candidatoId !== undefined && candidatoId !== null)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (idiomaId !== undefined && idiomaId !== null)
            url_ += "IdiomaId=" + encodeURIComponent("" + idiomaId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoIdiomaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoIdiomaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<CandidatoIdiomaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoIdiomaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoIdioma/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CandidatoVagaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param cadastroViaAdmin (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(cadastroViaAdmin: boolean | undefined, body: CreateCandidatoVagaDto | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/Create?";
        if (cadastroViaAdmin === null)
            throw new Error("The parameter 'cadastroViaAdmin' cannot be null.");
        else if (cadastroViaAdmin !== undefined)
            url_ += "cadastroViaAdmin=" + encodeURIComponent("" + cadastroViaAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCandidaturaVagaEspecial(body: CreateCandidatoVagaDto | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/CreateCandidaturaVagaEspecial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCandidaturaVagaEspecial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCandidaturaVagaEspecial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processCreateCandidaturaVagaEspecial(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CandidatoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CandidatoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nomeCandidato (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCandidatosVagaEncerrada(vagaId: string, nomeCandidato: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetCandidatosVagaEncerrada?";
        if (vagaId === undefined || vagaId === null)
            throw new Error("The parameter 'vagaId' must be defined and cannot be null.");
        else
            url_ += "VagaId=" + encodeURIComponent("" + vagaId) + "&";
        if (nomeCandidato !== undefined && nomeCandidato !== null)
            url_ += "NomeCandidato=" + encodeURIComponent("" + nomeCandidato) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatosVagaEncerrada(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatosVagaEncerrada(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDtoPagedResultDto>;
        }));
    }

    protected processGetCandidatosVagaEncerrada(response: HttpResponseBase): Observable<CandidatoVagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param vagaId (optional) 
     * @param naoVisualizado (optional) 
     * @param favorito (optional) 
     * @param recentes (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(candidatoId: string | null | undefined, vagaId: string | null | undefined, naoVisualizado: boolean | null | undefined, favorito: boolean | null | undefined, recentes: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAllPaged?";
        if (candidatoId !== undefined && candidatoId !== null)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (vagaId !== undefined && vagaId !== null)
            url_ += "VagaId=" + encodeURIComponent("" + vagaId) + "&";
        if (naoVisualizado !== undefined && naoVisualizado !== null)
            url_ += "NaoVisualizado=" + encodeURIComponent("" + naoVisualizado) + "&";
        if (favorito !== undefined && favorito !== null)
            url_ += "Favorito=" + encodeURIComponent("" + favorito) + "&";
        if (recentes !== undefined && recentes !== null)
            url_ += "Recentes=" + encodeURIComponent("" + recentes) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<CandidatoVagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param vagaId (optional) 
     * @param naoVisualizado (optional) 
     * @param favorito (optional) 
     * @param recentes (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllKanban(candidatoId: string | null | undefined, vagaId: string | null | undefined, naoVisualizado: boolean | null | undefined, favorito: boolean | null | undefined, recentes: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaKanbanDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAllKanban?";
        if (candidatoId !== undefined && candidatoId !== null)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (vagaId !== undefined && vagaId !== null)
            url_ += "VagaId=" + encodeURIComponent("" + vagaId) + "&";
        if (naoVisualizado !== undefined && naoVisualizado !== null)
            url_ += "NaoVisualizado=" + encodeURIComponent("" + naoVisualizado) + "&";
        if (favorito !== undefined && favorito !== null)
            url_ += "Favorito=" + encodeURIComponent("" + favorito) + "&";
        if (recentes !== undefined && recentes !== null)
            url_ += "Recentes=" + encodeURIComponent("" + recentes) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllKanban(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllKanban(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaKanbanDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaKanbanDto[]>;
        }));
    }

    protected processGetAllKanban(response: HttpResponseBase): Observable<CandidatoVagaKanbanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaKanbanDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param nome (optional) 
     * @param dataCadastroInicial (optional) 
     * @param dataCadastroFinal (optional) 
     * @param empresaId (optional) 
     * @param pcd (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param microrregioes (optional) 
     * @param prestadoraSuzano (optional) 
     * @param dataContratacaoInicial (optional) 
     * @param dataContratacaoFinal (optional) 
     * @param tituloVaga (optional) 
     * @param mes (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     * @deprecated
     */
    getAllListaContratadosAdmin(cpf: string | null | undefined, nome: string | null | undefined, dataCadastroInicial: string | null | undefined, dataCadastroFinal: string | null | undefined, empresaId: string | null | undefined, pcd: boolean | undefined, cidade: string | null | undefined, bairro: string | null | undefined, microrregioes: string[] | null | undefined, prestadoraSuzano: boolean | null | undefined, dataContratacaoInicial: string | null | undefined, dataContratacaoFinal: string | null | undefined, tituloVaga: string | null | undefined, ano: number, tipoFiltroGraficoTotalCadastroEnum: TipoFiltroGraficoTotalCadastro, mes: number | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAllListaContratadosAdmin?";
        if (cpf !== undefined && cpf !== null)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (dataCadastroInicial !== undefined && dataCadastroInicial !== null)
            url_ += "DataCadastroInicial=" + encodeURIComponent("" + dataCadastroInicial) + "&";
        if (dataCadastroFinal !== undefined && dataCadastroFinal !== null)
            url_ += "DataCadastroFinal=" + encodeURIComponent("" + dataCadastroFinal) + "&";
        if (empresaId !== undefined && empresaId !== null)
            url_ += "EmpresaId=" + encodeURIComponent("" + empresaId) + "&";
        if (pcd === null)
            throw new Error("The parameter 'pcd' cannot be null.");
        else if (pcd !== undefined)
            url_ += "Pcd=" + encodeURIComponent("" + pcd) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (microrregioes !== undefined && microrregioes !== null)
            microrregioes && microrregioes.forEach(item => { url_ += "Microrregioes=" + encodeURIComponent("" + item) + "&"; });
        if (prestadoraSuzano !== undefined && prestadoraSuzano !== null)
            url_ += "PrestadoraSuzano=" + encodeURIComponent("" + prestadoraSuzano) + "&";
        if (dataContratacaoInicial !== undefined && dataContratacaoInicial !== null)
            url_ += "DataContratacaoInicial=" + encodeURIComponent("" + dataContratacaoInicial) + "&";
        if (dataContratacaoFinal !== undefined && dataContratacaoFinal !== null)
            url_ += "DataContratacaoFinal=" + encodeURIComponent("" + dataContratacaoFinal) + "&";
        if (tituloVaga !== undefined && tituloVaga !== null)
            url_ += "TituloVaga=" + encodeURIComponent("" + tituloVaga) + "&";
        if (ano === undefined || ano === null)
            throw new Error("The parameter 'ano' must be defined and cannot be null.");
        else
            url_ += "Ano=" + encodeURIComponent("" + ano) + "&";
        if (tipoFiltroGraficoTotalCadastroEnum === undefined || tipoFiltroGraficoTotalCadastroEnum === null)
            throw new Error("The parameter 'tipoFiltroGraficoTotalCadastroEnum' must be defined and cannot be null.");
        else
            url_ += "TipoFiltroGraficoTotalCadastroEnum=" + encodeURIComponent("" + tipoFiltroGraficoTotalCadastroEnum) + "&";
        if (mes !== undefined && mes !== null)
            url_ += "Mes=" + encodeURIComponent("" + mes) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllListaContratadosAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllListaContratadosAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDtoPagedResultDto>;
        }));
    }

    protected processGetAllListaContratadosAdmin(response: HttpResponseBase): Observable<CandidatoVagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param nome (optional) 
     * @param dataCadastroInicial (optional) 
     * @param dataCadastroFinal (optional) 
     * @param empresaId (optional) 
     * @param pcd (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param microrregioes (optional) 
     * @param prestadoraSuzano (optional) 
     * @param dataContratacaoInicial (optional) 
     * @param dataContratacaoFinal (optional) 
     * @param tituloVaga (optional) 
     * @param mes (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllListaContratadosAdminV2(cpf: string | null | undefined, nome: string | null | undefined, dataCadastroInicial: string | null | undefined, dataCadastroFinal: string | null | undefined, empresaId: string | null | undefined, pcd: boolean | undefined, cidade: string | null | undefined, bairro: string | null | undefined, microrregioes: string[] | null | undefined, prestadoraSuzano: boolean | null | undefined, dataContratacaoInicial: string | null | undefined, dataContratacaoFinal: string | null | undefined, tituloVaga: string | null | undefined, ano: number, tipoFiltroGraficoTotalCadastroEnum: TipoFiltroGraficoTotalCadastro, mes: number | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAllListaContratadosAdminV2?";
        if (cpf !== undefined && cpf !== null)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (dataCadastroInicial !== undefined && dataCadastroInicial !== null)
            url_ += "DataCadastroInicial=" + encodeURIComponent("" + dataCadastroInicial) + "&";
        if (dataCadastroFinal !== undefined && dataCadastroFinal !== null)
            url_ += "DataCadastroFinal=" + encodeURIComponent("" + dataCadastroFinal) + "&";
        if (empresaId !== undefined && empresaId !== null)
            url_ += "EmpresaId=" + encodeURIComponent("" + empresaId) + "&";
        if (pcd === null)
            throw new Error("The parameter 'pcd' cannot be null.");
        else if (pcd !== undefined)
            url_ += "Pcd=" + encodeURIComponent("" + pcd) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (microrregioes !== undefined && microrregioes !== null)
            microrregioes && microrregioes.forEach(item => { url_ += "Microrregioes=" + encodeURIComponent("" + item) + "&"; });
        if (prestadoraSuzano !== undefined && prestadoraSuzano !== null)
            url_ += "PrestadoraSuzano=" + encodeURIComponent("" + prestadoraSuzano) + "&";
        if (dataContratacaoInicial !== undefined && dataContratacaoInicial !== null)
            url_ += "DataContratacaoInicial=" + encodeURIComponent("" + dataContratacaoInicial) + "&";
        if (dataContratacaoFinal !== undefined && dataContratacaoFinal !== null)
            url_ += "DataContratacaoFinal=" + encodeURIComponent("" + dataContratacaoFinal) + "&";
        if (tituloVaga !== undefined && tituloVaga !== null)
            url_ += "TituloVaga=" + encodeURIComponent("" + tituloVaga) + "&";
        if (ano === undefined || ano === null)
            throw new Error("The parameter 'ano' must be defined and cannot be null.");
        else
            url_ += "Ano=" + encodeURIComponent("" + ano) + "&";
        if (tipoFiltroGraficoTotalCadastroEnum === undefined || tipoFiltroGraficoTotalCadastroEnum === null)
            throw new Error("The parameter 'tipoFiltroGraficoTotalCadastroEnum' must be defined and cannot be null.");
        else
            url_ += "TipoFiltroGraficoTotalCadastroEnum=" + encodeURIComponent("" + tipoFiltroGraficoTotalCadastroEnum) + "&";
        if (mes !== undefined && mes !== null)
            url_ += "Mes=" + encodeURIComponent("" + mes) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllListaContratadosAdminV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllListaContratadosAdminV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple>;
        }));
    }

    protected processGetAllListaContratadosAdminV2(response: HttpResponseBase): Observable<CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @return Success
     */
    exportarAnotacoes(candidatoVagaId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/ExportarAnotacoes?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportarAnotacoes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportarAnotacoes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportarAnotacoes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    relatorioCandidatosContratados(body: FiltroRelatorioCandidatosContratadosDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/RelatorioCandidatosContratados";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelatorioCandidatosContratados(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelatorioCandidatosContratados(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRelatorioCandidatosContratados(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param vagaId (optional) 
     * @param naoVisualizado (optional) 
     * @param favorito (optional) 
     * @param recentes (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllByCandidatoId(candidatoId: string | null | undefined, vagaId: string | null | undefined, naoVisualizado: boolean | null | undefined, favorito: boolean | null | undefined, recentes: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAllByCandidatoId?";
        if (candidatoId !== undefined && candidatoId !== null)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (vagaId !== undefined && vagaId !== null)
            url_ += "VagaId=" + encodeURIComponent("" + vagaId) + "&";
        if (naoVisualizado !== undefined && naoVisualizado !== null)
            url_ += "NaoVisualizado=" + encodeURIComponent("" + naoVisualizado) + "&";
        if (favorito !== undefined && favorito !== null)
            url_ += "Favorito=" + encodeURIComponent("" + favorito) + "&";
        if (recentes !== undefined && recentes !== null)
            url_ += "Recentes=" + encodeURIComponent("" + recentes) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByCandidatoId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByCandidatoId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDtoPagedResultDto>;
        }));
    }

    protected processGetAllByCandidatoId(response: HttpResponseBase): Observable<CandidatoVagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAllByVagaId(id: string | undefined): Observable<CandidatoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAllByVagaId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByVagaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByVagaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto[]>;
        }));
    }

    protected processGetAllByVagaId(response: HttpResponseBase): Observable<CandidatoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getCandidatoVagaInativaPorTrintaDias(candidatoId: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<CandidatoVagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetCandidatoVagaInativaPorTrintaDias?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatoVagaInativaPorTrintaDias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatoVagaInativaPorTrintaDias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDtoPagedResultDto>;
        }));
    }

    protected processGetCandidatoVagaInativaPorTrintaDias(response: HttpResponseBase): Observable<CandidatoVagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllByUserLogado(): Observable<InscricaoCandidatoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetAllByUserLogado";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByUserLogado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByUserLogado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InscricaoCandidatoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InscricaoCandidatoDtoPagedResultDto>;
        }));
    }

    protected processGetAllByUserLogado(response: HttpResponseBase): Observable<InscricaoCandidatoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InscricaoCandidatoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @return Success
     */
    relatorioCandidatosVaga(vagaId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/RelatorioCandidatosVaga?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelatorioCandidatosVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelatorioCandidatosVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRelatorioCandidatosVaga(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @return Success
     */
    relatorioCandidatosSelecionadosVagaAdmin(vagaId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/RelatorioCandidatosSelecionadosVagaAdmin?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelatorioCandidatosSelecionadosVagaAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelatorioCandidatosSelecionadosVagaAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRelatorioCandidatosSelecionadosVagaAdmin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    selecionarCandidatoVaga(body: SelecionarCandidatoVagaRequestDto | undefined): Observable<CandidatoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/SelecionarCandidatoVaga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelecionarCandidatoVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelecionarCandidatoVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto[]>;
        }));
    }

    protected processSelecionarCandidatoVaga(response: HttpResponseBase): Observable<CandidatoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contratarCandidatos(body: SelecionarCandidatoVagaRequestDto | undefined): Observable<CandidatoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/ContratarCandidatos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContratarCandidatos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContratarCandidatos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto[]>;
        }));
    }

    protected processContratarCandidatos(response: HttpResponseBase): Observable<CandidatoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCandidatoSelecionadoVaga(candidatoId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetCandidatoSelecionadoVaga?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatoSelecionadoVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatoSelecionadoVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDtoPagedResultDto>;
        }));
    }

    protected processGetCandidatoSelecionadoVaga(response: HttpResponseBase): Observable<CandidatoVagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInscricoesCandidatoAdmin(candidatoId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaResultDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetInscricoesCandidatoAdmin?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInscricoesCandidatoAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInscricoesCandidatoAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaResultDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaResultDtoPagedResultDto>;
        }));
    }

    protected processGetInscricoesCandidatoAdmin(response: HttpResponseBase): Observable<CandidatoVagaResultDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaResultDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @param autoContratacao (optional) 
     * @param contratadoPorAdmin (optional) 
     * @return Success
     */
    contratarCandidato(candidatoVagaId: string | undefined, autoContratacao: boolean | undefined, contratadoPorAdmin: boolean | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/ContratarCandidato?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        if (autoContratacao === null)
            throw new Error("The parameter 'autoContratacao' cannot be null.");
        else if (autoContratacao !== undefined)
            url_ += "autoContratacao=" + encodeURIComponent("" + autoContratacao) + "&";
        if (contratadoPorAdmin === null)
            throw new Error("The parameter 'contratadoPorAdmin' cannot be null.");
        else if (contratadoPorAdmin !== undefined)
            url_ += "contratadoPorAdmin=" + encodeURIComponent("" + contratadoPorAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContratarCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContratarCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processContratarCandidato(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @return Success
     */
    descontratarCandidato(candidatoVagaId: string | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/DescontratarCandidato?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDescontratarCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDescontratarCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processDescontratarCandidato(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @return Success
     */
    selecionarCandidato(candidatoVagaId: string | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/SelecionarCandidato?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelecionarCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelecionarCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processSelecionarCandidato(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    atualizarStatusVaga(id: string | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/AtualizarStatusVaga?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtualizarStatusVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtualizarStatusVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processAtualizarStatusVaga(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @param body (optional) 
     * @return Success
     */
    moverCandidatoTriagem(candidatoVagaId: string | undefined, body: EstagioTriagem | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/MoverCandidatoTriagem?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoverCandidatoTriagem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoverCandidatoTriagem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processMoverCandidatoTriagem(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCandidatoVagaDto | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param canditadoVagaId (optional) 
     * @return Success
     */
    enviarEmailCanditado(canditadoVagaId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/EnviarEmailCanditado?";
        if (canditadoVagaId === null)
            throw new Error("The parameter 'canditadoVagaId' cannot be null.");
        else if (canditadoVagaId !== undefined)
            url_ += "canditadoVagaId=" + encodeURIComponent("" + canditadoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarEmailCanditado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarEmailCanditado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEnviarEmailCanditado(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @return Success
     */
    enviarEmailGestor(vagaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/EnviarEmailGestor?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarEmailGestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarEmailGestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnviarEmailGestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idCanditado (optional) 
     * @return Success
     */
    getInscricoesCanditado(idCanditado: string | undefined): Observable<CandidatoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetInscricoesCanditado?";
        if (idCanditado === null)
            throw new Error("The parameter 'idCanditado' cannot be null.");
        else if (idCanditado !== undefined)
            url_ += "idCanditado=" + encodeURIComponent("" + idCanditado) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInscricoesCanditado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInscricoesCanditado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto[]>;
        }));
    }

    protected processGetInscricoesCanditado(response: HttpResponseBase): Observable<CandidatoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idVaga (optional) 
     * @return Success
     */
    getNumeroInscritos(idVaga: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetNumeroInscritos?";
        if (idVaga === null)
            throw new Error("The parameter 'idVaga' cannot be null.");
        else if (idVaga !== undefined)
            url_ += "idVaga=" + encodeURIComponent("" + idVaga) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumeroInscritos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumeroInscritos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumeroInscritos(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @param vagaId (optional) 
     * @param naoVisualizado (optional) 
     * @param favorito (optional) 
     * @param recentes (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCandidatoVagaResumido(candidatoId: string | null | undefined, vagaId: string | null | undefined, naoVisualizado: boolean | null | undefined, favorito: boolean | null | undefined, recentes: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaResumoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/GetCandidatoVagaResumido?";
        if (candidatoId !== undefined && candidatoId !== null)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (vagaId !== undefined && vagaId !== null)
            url_ += "VagaId=" + encodeURIComponent("" + vagaId) + "&";
        if (naoVisualizado !== undefined && naoVisualizado !== null)
            url_ += "NaoVisualizado=" + encodeURIComponent("" + naoVisualizado) + "&";
        if (favorito !== undefined && favorito !== null)
            url_ += "Favorito=" + encodeURIComponent("" + favorito) + "&";
        if (recentes !== undefined && recentes !== null)
            url_ += "Recentes=" + encodeURIComponent("" + recentes) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatoVagaResumido(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatoVagaResumido(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaResumoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaResumoDtoPagedResultDto>;
        }));
    }

    protected processGetCandidatoVagaResumido(response: HttpResponseBase): Observable<CandidatoVagaResumoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaResumoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inscricaoId (optional) 
     * @return Success
     */
    setFavorito(inscricaoId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/SetFavorito?";
        if (inscricaoId === null)
            throw new Error("The parameter 'inscricaoId' cannot be null.");
        else if (inscricaoId !== undefined)
            url_ += "inscricaoId=" + encodeURIComponent("" + inscricaoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFavorito(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFavorito(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetFavorito(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inscricaoId (optional) 
     * @return Success
     */
    setVisualizado(inscricaoId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/SetVisualizado?";
        if (inscricaoId === null)
            throw new Error("The parameter 'inscricaoId' cannot be null.");
        else if (inscricaoId !== undefined)
            url_ += "inscricaoId=" + encodeURIComponent("" + inscricaoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetVisualizado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetVisualizado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetVisualizado(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @return Success
     */
    desclassificarCandidato(candidatoVagaId: string | undefined): Observable<CandidatoVagaDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/DesclassificarCandidato?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesclassificarCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesclassificarCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto>;
        }));
    }

    protected processDesclassificarCandidato(response: HttpResponseBase): Observable<CandidatoVagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @return Success
     */
    listarCandidatosPorVaga(vagaId: string | undefined): Observable<CandidatoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVaga/ListarCandidatosPorVaga?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListarCandidatosPorVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListarCandidatosPorVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaDto[]>;
        }));
    }

    protected processListarCandidatosPorVaga(response: HttpResponseBase): Observable<CandidatoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CandidatoVagaAnexoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCandidatoVagaAnexoDto[] | null | undefined): Observable<CandidatoVagaAnexoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAnexo/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAnexoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAnexoDto[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CandidatoVagaAnexoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaAnexoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<CandidatoVagaAnexoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAnexo/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAnexoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAnexoDto[]>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CandidatoVagaAnexoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaAnexoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CandidatoVagaAnotacaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CandidatoVagaAnotacaoDto | undefined): Observable<CandidatoVagaAnotacaoDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAnotacao/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAnotacaoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAnotacaoDto>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<CandidatoVagaAnotacaoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaAnotacaoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @return Success
     */
    getCandidatoVagaAnotacoes(candidatoVagaId: string | undefined): Observable<CandidatoVagaAnotacaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAnotacao/GetCandidatoVagaAnotacoes?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatoVagaAnotacoes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatoVagaAnotacoes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAnotacaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAnotacaoDto[]>;
        }));
    }

    protected processGetCandidatoVagaAnotacoes(response: HttpResponseBase): Observable<CandidatoVagaAnotacaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaAnotacaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaAnotacaoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAnotacao/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAnotacaoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAnotacaoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CandidatoVagaAnotacaoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaAnotacaoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAnotacao/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CandidatoVagaAvaliacaoRequisitoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCandidatoVagaAvaliacaoRequisitoDto | undefined): Observable<CandidatoVagaAvaliacaoRequisitoDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAvaliacaoRequisito/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAvaliacaoRequisitoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAvaliacaoRequisitoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CandidatoVagaAvaliacaoRequisitoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaAvaliacaoRequisitoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoVagaId (optional) 
     * @return Success
     */
    getCandidatoVagaAnotacoes(candidatoVagaId: string | undefined): Observable<CandidatoVagaAvaliacaoRequisitoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAvaliacaoRequisito/GetCandidatoVagaAnotacoes?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatoVagaAnotacoes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatoVagaAnotacoes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAvaliacaoRequisitoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAvaliacaoRequisitoDto[]>;
        }));
    }

    protected processGetCandidatoVagaAnotacoes(response: HttpResponseBase): Observable<CandidatoVagaAvaliacaoRequisitoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CandidatoVagaAvaliacaoRequisitoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAvaliacaoRequisito/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidatoVagaAvaliacaoRequisito/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CargoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CargoDto> {
        let url_ = this.baseUrl + "/api/services/app/Cargo/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CargoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CargoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CargoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CargoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCargoDto | undefined): Observable<CargoDto> {
        let url_ = this.baseUrl + "/api/services/app/Cargo/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CargoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CargoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CargoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CargoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCargoDto | undefined): Observable<CargoDto> {
        let url_ = this.baseUrl + "/api/services/app/Cargo/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CargoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CargoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CargoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CargoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CargoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cargo/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CargoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CargoDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CargoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CargoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nome (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(nome: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CargoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cargo/GetAllPaged?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CargoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CargoDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<CargoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CargoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CidadeMicrorregiaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCidades(): Observable<CidadeMicrorregiaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CidadeMicrorregiao/GetCidades";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCidades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCidades(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidadeMicrorregiaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidadeMicrorregiaoDto[]>;
        }));
    }

    protected processGetCidades(response: HttpResponseBase): Observable<CidadeMicrorregiaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CidadeMicrorregiaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param estado (optional) 
     * @return Success
     */
    getCidadesEstado(estado: string | null | undefined): Observable<CidadeMicrorregiaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CidadeMicrorregiao/GetCidadesEstado?";
        if (estado !== undefined && estado !== null)
            url_ += "estado=" + encodeURIComponent("" + estado) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCidadesEstado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCidadesEstado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidadeMicrorregiaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidadeMicrorregiaoDto[]>;
        }));
    }

    protected processGetCidadesEstado(response: HttpResponseBase): Observable<CidadeMicrorregiaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CidadeMicrorregiaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ibgeId (optional) 
     * @return Success
     */
    getCidadeIBGE(ibgeId: string | null | undefined): Observable<CidadeMicrorregiaoDto> {
        let url_ = this.baseUrl + "/api/services/app/CidadeMicrorregiao/GetCidadeIBGE?";
        if (ibgeId !== undefined && ibgeId !== null)
            url_ += "ibgeId=" + encodeURIComponent("" + ibgeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCidadeIBGE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCidadeIBGE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidadeMicrorregiaoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidadeMicrorregiaoDto>;
        }));
    }

    protected processGetCidadeIBGE(response: HttpResponseBase): Observable<CidadeMicrorregiaoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CidadeMicrorregiaoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEstados(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/CidadeMicrorregiao/GetEstados";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstados(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstados(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetEstados(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRegiaoGeralId(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CidadeMicrorregiao/GetRegiaoGeralId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegiaoGeralId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegiaoGeralId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRegiaoGeralId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompetenciaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CompetenciaDto> {
        let url_ = this.baseUrl + "/api/services/app/Competencia/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompetenciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompetenciaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompetenciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetenciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCompetenciaDto | undefined): Observable<CompetenciaDto> {
        let url_ = this.baseUrl + "/api/services/app/Competencia/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompetenciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompetenciaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompetenciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetenciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCompetenciaDto | undefined): Observable<CompetenciaDto> {
        let url_ = this.baseUrl + "/api/services/app/Competencia/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompetenciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompetenciaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompetenciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetenciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CompetenciaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Competencia/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompetenciaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompetenciaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompetenciaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompetenciaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nome (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(nome: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompetenciaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Competencia/GetAllPaged?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompetenciaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompetenciaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<CompetenciaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetenciaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ComunidadeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateComunidadeDto[] | null | undefined): Observable<ComunidadeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Comunidade/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComunidadeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComunidadeDto[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ComunidadeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ComunidadeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<ComunidadeDto> {
        let url_ = this.baseUrl + "/api/services/app/Comunidade/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComunidadeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComunidadeDto>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ComunidadeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComunidadeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ComunidadeDto> {
        let url_ = this.baseUrl + "/api/services/app/Comunidade/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComunidadeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComunidadeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ComunidadeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComunidadeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ComunidadeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Comunidade/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComunidadeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComunidadeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ComunidadeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ComunidadeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nome (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(nome: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ComunidadeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Comunidade/GetAllPaged?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComunidadeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComunidadeDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<ComunidadeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComunidadeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateComunidadeDto | undefined): Observable<ComunidadeDto> {
        let url_ = this.baseUrl + "/api/services/app/Comunidade/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComunidadeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComunidadeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ComunidadeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComunidadeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CurriculoCompetenciaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CurriculoCompetenciaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoCompetenciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoCompetenciaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurriculoCompetenciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoCompetenciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<CurriculoCompetenciaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoCompetenciaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoCompetenciaDto[]>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<CurriculoCompetenciaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoCompetenciaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param competenciaId (optional) 
     * @return Success
     */
    getByCompetencia(competenciaId: string | undefined): Observable<CurriculoCompetenciaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/GetByCompetencia?";
        if (competenciaId === null)
            throw new Error("The parameter 'competenciaId' cannot be null.");
        else if (competenciaId !== undefined)
            url_ += "competenciaId=" + encodeURIComponent("" + competenciaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCompetencia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCompetencia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoCompetenciaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoCompetenciaDto[]>;
        }));
    }

    protected processGetByCompetencia(response: HttpResponseBase): Observable<CurriculoCompetenciaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoCompetenciaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CurriculoCompetenciaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoCompetenciaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoCompetenciaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurriculoCompetenciaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoCompetenciaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param competenciaId (optional) 
     * @param candidatoId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(competenciaId: string | null | undefined, candidatoId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CurriculoCompetenciaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/GetAllPaged?";
        if (competenciaId !== undefined && competenciaId !== null)
            url_ += "CompetenciaId=" + encodeURIComponent("" + competenciaId) + "&";
        if (candidatoId !== undefined && candidatoId !== null)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoCompetenciaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoCompetenciaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<CurriculoCompetenciaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoCompetenciaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCurriculoCompetenciaDto | undefined): Observable<CurriculoCompetenciaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoCompetenciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoCompetenciaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurriculoCompetenciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoCompetenciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCurriculoCompetenciaDto | undefined): Observable<CurriculoCompetenciaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoCompetenciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoCompetenciaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurriculoCompetenciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoCompetenciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoCompetencia/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CurriculoDadoPessoalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDadosCandidato(): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoal/GetDadosCandidato";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDadosCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDadosCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processGetDadosCandidato(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurriculoByLoggedUser(): Observable<CurriculoDadoPessoalDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoal/GetCurriculoByLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurriculoByLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurriculoByLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalDto>;
        }));
    }

    protected processGetCurriculoByLoggedUser(response: HttpResponseBase): Observable<CurriculoDadoPessoalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CurriculoDadoPessoalDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoal/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurriculoDadoPessoalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<CurriculoDadoPessoalDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoal/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalDto>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<CurriculoDadoPessoalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CurriculoDadoPessoalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoal/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurriculoDadoPessoalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoDadoPessoalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCurriculoDadoPessoalDto | undefined): Observable<CurriculoDadoPessoalDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoal/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurriculoDadoPessoalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCurriculoDadoPessoalDto | undefined): Observable<CurriculoDadoPessoalDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoal/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurriculoDadoPessoalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CurriculoDadoPessoalAnexoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurriculoAnexoByLoggedUser(): Observable<CurriculoDadoPessoalAnexoDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoalAnexo/GetCurriculoAnexoByLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurriculoAnexoByLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurriculoAnexoByLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalAnexoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalAnexoDto>;
        }));
    }

    protected processGetCurriculoAnexoByLoggedUser(response: HttpResponseBase): Observable<CurriculoDadoPessoalAnexoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalAnexoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CurriculoDadoPessoalAnexoDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoalAnexo/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalAnexoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalAnexoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurriculoDadoPessoalAnexoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalAnexoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<CurriculoDadoPessoalAnexoDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoalAnexo/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalAnexoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalAnexoDto>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<CurriculoDadoPessoalAnexoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalAnexoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCurriculoDadoPessoalAnexoDto | undefined): Observable<CurriculoDadoPessoalAnexoDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoalAnexo/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalAnexoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalAnexoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurriculoDadoPessoalAnexoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalAnexoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCurriculoDadoPessoalAnexoDto | undefined): Observable<CurriculoDadoPessoalAnexoDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoalAnexo/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoDadoPessoalAnexoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoDadoPessoalAnexoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurriculoDadoPessoalAnexoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoDadoPessoalAnexoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoDadoPessoalAnexo/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CurriculoExperienciaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CurriculoExperienciaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoExperienciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoExperienciaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurriculoExperienciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoExperienciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIdCanditato(): Observable<CandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/GetIdCanditato";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdCanditato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdCanditato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidatoDto>;
        }));
    }

    protected processGetIdCanditato(response: HttpResponseBase): Observable<CandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByLoggedUser(): Observable<CurriculoExperienciaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/GetByLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoExperienciaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoExperienciaDto[]>;
        }));
    }

    protected processGetByLoggedUser(response: HttpResponseBase): Observable<CurriculoExperienciaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoExperienciaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<CurriculoExperienciaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoExperienciaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoExperienciaDto[]>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<CurriculoExperienciaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoExperienciaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param experienciaId (optional) 
     * @return Success
     */
    delete(experienciaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/Delete?";
        if (experienciaId === null)
            throw new Error("The parameter 'experienciaId' cannot be null.");
        else if (experienciaId !== undefined)
            url_ += "experienciaId=" + encodeURIComponent("" + experienciaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CurriculoExperienciaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoExperienciaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoExperienciaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurriculoExperienciaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoExperienciaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CurriculoExperienciaDto | undefined): Observable<CurriculoExperienciaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoExperienciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoExperienciaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurriculoExperienciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoExperienciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCurriculoExperienciaDto | undefined): Observable<CurriculoExperienciaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoExperiencia/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoExperienciaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoExperienciaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurriculoExperienciaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoExperienciaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CurriculoSkillConectaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CurriculoSkillConectaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoSkillConecta/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoSkillConectaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoSkillConectaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurriculoSkillConectaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoSkillConectaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<CurriculoSkillConectaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoSkillConecta/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoSkillConectaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoSkillConectaDto[]>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<CurriculoSkillConectaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoSkillConectaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skillConectaId (optional) 
     * @return Success
     */
    getBySkillConecta(skillConectaId: string | undefined): Observable<CurriculoSkillConectaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoSkillConecta/GetBySkillConecta?";
        if (skillConectaId === null)
            throw new Error("The parameter 'skillConectaId' cannot be null.");
        else if (skillConectaId !== undefined)
            url_ += "skillConectaId=" + encodeURIComponent("" + skillConectaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySkillConecta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySkillConecta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoSkillConectaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoSkillConectaDto[]>;
        }));
    }

    protected processGetBySkillConecta(response: HttpResponseBase): Observable<CurriculoSkillConectaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoSkillConectaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CurriculoSkillConectaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoSkillConecta/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoSkillConectaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoSkillConectaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurriculoSkillConectaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurriculoSkillConectaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skillConectaId (optional) 
     * @param candidatoId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(skillConectaId: string | null | undefined, candidatoId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CurriculoSkillConectaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoSkillConecta/GetAllPaged?";
        if (skillConectaId !== undefined && skillConectaId !== null)
            url_ += "SkillConectaId=" + encodeURIComponent("" + skillConectaId) + "&";
        if (candidatoId !== undefined && candidatoId !== null)
            url_ += "CandidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoSkillConectaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoSkillConectaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<CurriculoSkillConectaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoSkillConectaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCurriculoSkillConectaDto | undefined): Observable<CurriculoSkillConectaDto> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoSkillConecta/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurriculoSkillConectaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurriculoSkillConectaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurriculoSkillConectaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurriculoSkillConectaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CurriculoSkillConecta/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmpresaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEmpresaDto | undefined): Observable<EmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmpresaEspecial(body: CreateEmpresaEspecialDto | undefined): Observable<EmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/CreateEmpresaEspecial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmpresaEspecial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmpresaEspecial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto>;
        }));
    }

    protected processCreateEmpresaEspecial(response: HttpResponseBase): Observable<EmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<EmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAbp(): Observable<EmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetAbp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAbp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAbp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto>;
        }));
    }

    protected processGetAbp(response: HttpResponseBase): Observable<EmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getFotoPerfil(input: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetFotoPerfil?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFotoPerfil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFotoPerfil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFotoPerfil(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @return Success
     */
    obterDataUltimaExibicaoLembrete(empresaId: string | undefined): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/ObterDataUltimaExibicaoLembrete?";
        if (empresaId === null)
            throw new Error("The parameter 'empresaId' cannot be null.");
        else if (empresaId !== undefined)
            url_ += "empresaId=" + encodeURIComponent("" + empresaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObterDataUltimaExibicaoLembrete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObterDataUltimaExibicaoLembrete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processObterDataUltimaExibicaoLembrete(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @return Success
     */
    atualizarDataExibicaoLembrete(empresaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/AtualizarDataExibicaoLembrete?";
        if (empresaId === null)
            throw new Error("The parameter 'empresaId' cannot be null.");
        else if (empresaId !== undefined)
            url_ += "empresaId=" + encodeURIComponent("" + empresaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtualizarDataExibicaoLembrete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtualizarDataExibicaoLembrete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAtualizarDataExibicaoLembrete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @return Success
     */
    getEmpresas(microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined): Observable<EmpresaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetEmpresas?";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmpresas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmpresas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto[]>;
        }));
    }

    protected processGetEmpresas(response: HttpResponseBase): Observable<EmpresaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmpresaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param microrregioesId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param vagaAberta (optional) 
     * @param vagasEncerradas (optional) 
     * @param candidatoExcluido (optional) 
     * @param candidatoPcd (optional) 
     * @param vagaParaPcd (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param cPF (optional) 
     * @param cNPJ (optional) 
     * @param cidade (optional) 
     * @param bairro (optional) 
     * @param nomeDaEmpresa (optional) 
     * @param nomeDoCandidato (optional) 
     * @param areaAtuacao (optional) 
     * @return Success
     */
    getEmpresasPorTipo(microrregioesId: string[] | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, empresaPrestadoraDeServico: boolean | null | undefined, vagaAberta: boolean | null | undefined, vagasEncerradas: boolean | null | undefined, candidatoExcluido: boolean | null | undefined, candidatoPcd: boolean | null | undefined, vagaParaPcd: boolean | null | undefined, empresaEspecial: boolean | null | undefined, empresaExcluida: boolean | null | undefined, cPF: string | null | undefined, cNPJ: string | null | undefined, cidade: string | null | undefined, bairro: string | null | undefined, nomeDaEmpresa: string | null | undefined, nomeDoCandidato: string | null | undefined, areaAtuacao: AreaAtuacaoEmpresaEnum | undefined): Observable<EmpresaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetEmpresasPorTipo?";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (empresaPrestadoraDeServico !== undefined && empresaPrestadoraDeServico !== null)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (vagaAberta !== undefined && vagaAberta !== null)
            url_ += "VagaAberta=" + encodeURIComponent("" + vagaAberta) + "&";
        if (vagasEncerradas !== undefined && vagasEncerradas !== null)
            url_ += "VagasEncerradas=" + encodeURIComponent("" + vagasEncerradas) + "&";
        if (candidatoExcluido !== undefined && candidatoExcluido !== null)
            url_ += "CandidatoExcluido=" + encodeURIComponent("" + candidatoExcluido) + "&";
        if (candidatoPcd !== undefined && candidatoPcd !== null)
            url_ += "CandidatoPcd=" + encodeURIComponent("" + candidatoPcd) + "&";
        if (vagaParaPcd !== undefined && vagaParaPcd !== null)
            url_ += "VagaParaPcd=" + encodeURIComponent("" + vagaParaPcd) + "&";
        if (empresaEspecial !== undefined && empresaEspecial !== null)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida !== undefined && empresaExcluida !== null)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        if (cNPJ !== undefined && cNPJ !== null)
            url_ += "CNPJ=" + encodeURIComponent("" + cNPJ) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (bairro !== undefined && bairro !== null)
            url_ += "Bairro=" + encodeURIComponent("" + bairro) + "&";
        if (nomeDaEmpresa !== undefined && nomeDaEmpresa !== null)
            url_ += "NomeDaEmpresa=" + encodeURIComponent("" + nomeDaEmpresa) + "&";
        if (nomeDoCandidato !== undefined && nomeDoCandidato !== null)
            url_ += "NomeDoCandidato=" + encodeURIComponent("" + nomeDoCandidato) + "&";
        if (areaAtuacao === null)
            throw new Error("The parameter 'areaAtuacao' cannot be null.");
        else if (areaAtuacao !== undefined)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmpresasPorTipo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmpresasPorTipo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto[]>;
        }));
    }

    protected processGetEmpresasPorTipo(response: HttpResponseBase): Observable<EmpresaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmpresaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmpresasLista(): Observable<EmpresaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetEmpresasLista";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmpresasLista(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmpresasLista(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto[]>;
        }));
    }

    protected processGetEmpresasLista(response: HttpResponseBase): Observable<EmpresaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmpresaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cnpj (optional) 
     * @param razaoSocial (optional) 
     * @param dataCadastroInicial (optional) 
     * @param dataCadastroFinal (optional) 
     * @param prestadoraServicoSuzano (optional) 
     * @param areaAtuacao (optional) 
     * @param empresaEspecial (optional) 
     * @param empresaExcluida (optional) 
     * @param microrregioesId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(cnpj: string | null | undefined, razaoSocial: string | null | undefined, dataCadastroInicial: string | null | undefined, dataCadastroFinal: string | null | undefined, prestadoraServicoSuzano: boolean | undefined, areaAtuacao: number | null | undefined, empresaEspecial: boolean | undefined, empresaExcluida: boolean | undefined, microrregioesId: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmpresaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetAll?";
        if (cnpj !== undefined && cnpj !== null)
            url_ += "Cnpj=" + encodeURIComponent("" + cnpj) + "&";
        if (razaoSocial !== undefined && razaoSocial !== null)
            url_ += "RazaoSocial=" + encodeURIComponent("" + razaoSocial) + "&";
        if (dataCadastroInicial !== undefined && dataCadastroInicial !== null)
            url_ += "DataCadastroInicial=" + encodeURIComponent("" + dataCadastroInicial) + "&";
        if (dataCadastroFinal !== undefined && dataCadastroFinal !== null)
            url_ += "DataCadastroFinal=" + encodeURIComponent("" + dataCadastroFinal) + "&";
        if (prestadoraServicoSuzano === null)
            throw new Error("The parameter 'prestadoraServicoSuzano' cannot be null.");
        else if (prestadoraServicoSuzano !== undefined)
            url_ += "PrestadoraServicoSuzano=" + encodeURIComponent("" + prestadoraServicoSuzano) + "&";
        if (areaAtuacao !== undefined && areaAtuacao !== null)
            url_ += "AreaAtuacao=" + encodeURIComponent("" + areaAtuacao) + "&";
        if (empresaEspecial === null)
            throw new Error("The parameter 'empresaEspecial' cannot be null.");
        else if (empresaEspecial !== undefined)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        if (empresaExcluida === null)
            throw new Error("The parameter 'empresaExcluida' cannot be null.");
        else if (empresaExcluida !== undefined)
            url_ += "EmpresaExcluida=" + encodeURIComponent("" + empresaExcluida) + "&";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmpresaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmpresaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @param dataInicial (optional) 
     * @param dataFinal (optional) 
     * @param microrregioesId (optional) 
     * @param top5 (optional) 
     * @param empresaEspecial (optional) 
     * @return Success
     */
    getTotalVagasEmpresas(empresaId: string | null | undefined, dataInicial: moment.Moment | null | undefined, dataFinal: moment.Moment | null | undefined, microrregioesId: string[] | null | undefined, top5: boolean | undefined, empresaEspecial: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetTotalVagasEmpresas?";
        if (empresaId !== undefined && empresaId !== null)
            url_ += "EmpresaId=" + encodeURIComponent("" + empresaId) + "&";
        if (dataInicial !== undefined && dataInicial !== null)
            url_ += "DataInicial=" + encodeURIComponent(dataInicial ? "" + dataInicial.toISOString() : "") + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent(dataFinal ? "" + dataFinal.toISOString() : "") + "&";
        if (microrregioesId !== undefined && microrregioesId !== null)
            microrregioesId && microrregioesId.forEach(item => { url_ += "MicrorregioesId=" + encodeURIComponent("" + item) + "&"; });
        if (top5 === null)
            throw new Error("The parameter 'top5' cannot be null.");
        else if (top5 !== undefined)
            url_ += "Top5=" + encodeURIComponent("" + top5) + "&";
        if (empresaEspecial === null)
            throw new Error("The parameter 'empresaEspecial' cannot be null.");
        else if (empresaEspecial !== undefined)
            url_ += "EmpresaEspecial=" + encodeURIComponent("" + empresaEspecial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalVagasEmpresas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalVagasEmpresas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalVagasEmpresas(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEmpresaDto | undefined): Observable<EmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmpresaEspecial(body: UpdateEmpresaEspecialDto | undefined): Observable<EmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/UpdateEmpresaEspecial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmpresaEspecial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmpresaEspecial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaDto>;
        }));
    }

    protected processUpdateEmpresaEspecial(response: HttpResponseBase): Observable<EmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    usuarioEmpresaExiste(email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/UsuarioEmpresaExiste?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsuarioEmpresaExiste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsuarioEmpresaExiste(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUsuarioEmpresaExiste(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    relatorioEmpresasCadastradas(body: FiltroRelatorioEmpresasCadastradasDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/RelatorioEmpresasCadastradas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelatorioEmpresasCadastradas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelatorioEmpresasCadastradas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRelatorioEmpresasCadastradas(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getList(keyword: string | null | undefined): Observable<EmpresaListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetList?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpresaListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpresaListDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<EmpresaListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmpresaListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cnpj (optional) 
     * @return Success
     */
    getInformacoesEmpresa(cnpj: string | null | undefined): Observable<CreateEmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Empresa/GetInformacoesEmpresa?";
        if (cnpj !== undefined && cnpj !== null)
            url_ += "cnpj=" + encodeURIComponent("" + cnpj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacoesEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacoesEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateEmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateEmpresaDto>;
        }));
    }

    protected processGetInformacoesEmpresa(response: HttpResponseBase): Observable<CreateEmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateEmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EnumServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param enumName (optional) 
     * @return Success
     */
    getByEnumName(enumName: string | null | undefined): Observable<EnumDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Enum/GetByEnumName?";
        if (enumName !== undefined && enumName !== null)
            url_ += "enumName=" + encodeURIComponent("" + enumName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEnumName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEnumName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDtoListResultDto>;
        }));
    }

    protected processGetByEnumName(response: HttpResponseBase): Observable<EnumDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnumDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HistoricoCandidatoVagaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param candidatoVagaId (optional) 
     * @return Success
     */
    getHistorico(candidatoVagaId: string | undefined): Observable<HistoricoCandidatoVagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HistoricoCandidatoVaga/GetHistorico?";
        if (candidatoVagaId === null)
            throw new Error("The parameter 'candidatoVagaId' cannot be null.");
        else if (candidatoVagaId !== undefined)
            url_ += "candidatoVagaId=" + encodeURIComponent("" + candidatoVagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistorico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistorico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricoCandidatoVagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricoCandidatoVagaDto[]>;
        }));
    }

    protected processGetHistorico(response: HttpResponseBase): Observable<HistoricoCandidatoVagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HistoricoCandidatoVagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IdiomaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<IdiomaDto> {
        let url_ = this.baseUrl + "/api/services/app/Idioma/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdiomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdiomaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IdiomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdiomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateIdiomaDto | undefined): Observable<IdiomaDto> {
        let url_ = this.baseUrl + "/api/services/app/Idioma/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdiomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdiomaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IdiomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdiomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateIdiomaDto | undefined): Observable<IdiomaDto> {
        let url_ = this.baseUrl + "/api/services/app/Idioma/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdiomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdiomaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IdiomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdiomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<IdiomaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Idioma/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdiomaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdiomaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IdiomaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IdiomaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nome (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(nome: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IdiomaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Idioma/GetAllPaged?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdiomaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdiomaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<IdiomaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdiomaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LaudoMedicoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLaudoMedicoByLoggedUser(): Observable<LaudoMedicoDto> {
        let url_ = this.baseUrl + "/api/services/app/LaudoMedico/GetLaudoMedicoByLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaudoMedicoByLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaudoMedicoByLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaudoMedicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaudoMedicoDto>;
        }));
    }

    protected processGetLaudoMedicoByLoggedUser(response: HttpResponseBase): Observable<LaudoMedicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaudoMedicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<LaudoMedicoDto> {
        let url_ = this.baseUrl + "/api/services/app/LaudoMedico/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaudoMedicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaudoMedicoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LaudoMedicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaudoMedicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param candidatoId (optional) 
     * @return Success
     */
    getByCandidato(candidatoId: string | undefined): Observable<LaudoMedicoDto> {
        let url_ = this.baseUrl + "/api/services/app/LaudoMedico/GetByCandidato?";
        if (candidatoId === null)
            throw new Error("The parameter 'candidatoId' cannot be null.");
        else if (candidatoId !== undefined)
            url_ += "candidatoId=" + encodeURIComponent("" + candidatoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaudoMedicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaudoMedicoDto>;
        }));
    }

    protected processGetByCandidato(response: HttpResponseBase): Observable<LaudoMedicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaudoMedicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateLaudoMedicoDto | undefined): Observable<LaudoMedicoDto> {
        let url_ = this.baseUrl + "/api/services/app/LaudoMedico/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaudoMedicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaudoMedicoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LaudoMedicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaudoMedicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateLaudoMedicoDto | undefined): Observable<LaudoMedicoDto> {
        let url_ = this.baseUrl + "/api/services/app/LaudoMedico/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaudoMedicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaudoMedicoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LaudoMedicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaudoMedicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param laudoId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLaudo(laudoId: string | null | undefined, body: UpdateLaudoMedicoDto | undefined): Observable<LaudoMedicoDto> {
        let url_ = this.baseUrl + "/api/services/app/LaudoMedico/CreateOrUpdateLaudo?";
        if (laudoId !== undefined && laudoId !== null)
            url_ += "laudoId=" + encodeURIComponent("" + laudoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLaudo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLaudo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaudoMedicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaudoMedicoDto>;
        }));
    }

    protected processCreateOrUpdateLaudo(response: HttpResponseBase): Observable<LaudoMedicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaudoMedicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaudoMedico/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MicrorregiaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<MicrorregiaoDto> {
        let url_ = this.baseUrl + "/api/services/app/Microrregiao/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MicrorregiaoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MicrorregiaoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MicrorregiaoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MicrorregiaoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<MicrorregiaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Microrregiao/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MicrorregiaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MicrorregiaoDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MicrorregiaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MicrorregiaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OnboardingCandidatoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOnboardingCandidatoDto | undefined): Observable<OnboardingCandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingCandidato/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingCandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingCandidatoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OnboardingCandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnboardingCandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOnboardingCandidatoDto | undefined): Observable<OnboardingCandidatoDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingCandidato/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingCandidatoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingCandidatoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OnboardingCandidatoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnboardingCandidatoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    candidatoTemOnboarding(id: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingCandidato/CandidatoTemOnboarding?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidatoTemOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidatoTemOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCandidatoTemOnboarding(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RegiaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRegioes(): Observable<RegiaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Regiao/GetRegioes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegioes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegioes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegiaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegiaoDto[]>;
        }));
    }

    protected processGetRegioes(response: HttpResponseBase): Observable<RegiaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RegiaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetMyRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetMyRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SkillConectaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<SkillConectaDto> {
        let url_ = this.baseUrl + "/api/services/app/SkillConecta/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillConectaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillConectaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SkillConectaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillConectaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSkillConectaDto | undefined): Observable<SkillConectaDto> {
        let url_ = this.baseUrl + "/api/services/app/SkillConecta/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillConectaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillConectaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SkillConectaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillConectaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSkillConectaDto | undefined): Observable<SkillConectaDto> {
        let url_ = this.baseUrl + "/api/services/app/SkillConecta/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillConectaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillConectaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SkillConectaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillConectaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<SkillConectaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SkillConecta/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillConectaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillConectaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SkillConectaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SkillConectaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nome (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaged(nome: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SkillConectaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SkillConecta/GetAllPaged?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillConectaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillConectaDtoPagedResultDto>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<SkillConectaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillConectaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TermosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTermoDto | undefined): Observable<TermoDto> {
        let url_ = this.baseUrl + "/api/services/app/Termos/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TermoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<TermoDto> {
        let url_ = this.baseUrl + "/api/services/app/Termos/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TermoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tipo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(tipo: TipoTermoEnum | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TermoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Termos/GetAll?";
        if (tipo === null)
            throw new Error("The parameter 'tipo' cannot be null.");
        else if (tipo !== undefined)
            url_ += "Tipo=" + encodeURIComponent("" + tipo) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TermoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLatestTermo(tipo: TipoTermoEnum): Observable<TermoDto> {
        let url_ = this.baseUrl + "/api/services/app/Termos/GetLatestTermo?";
        if (tipo === undefined || tipo === null)
            throw new Error("The parameter 'tipo' must be defined and cannot be null.");
        else
            url_ += "Tipo=" + encodeURIComponent("" + tipo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestTermo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestTermo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermoDto>;
        }));
    }

    protected processGetLatestTermo(response: HttpResponseBase): Observable<TermoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    acceptLast(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Termos/AcceptLast";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptLast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptLast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptLast(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    verifyAcceptance(): Observable<{ [key: string]: boolean; }> {
        let url_ = this.baseUrl + "/api/services/app/Termos/VerifyAcceptance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyAcceptance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAcceptance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: boolean; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: boolean; }>;
        }));
    }

    protected processVerifyAcceptance(response: HttpResponseBase): Observable<{ [key: string]: boolean; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permissionName (optional) 
     * @return Success
     */
    hasPermission(permissionName: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/HasPermission?";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "permissionName=" + encodeURIComponent("" + permissionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasPermission(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VagaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getVagaInativaPorTrintaDias(empresaId: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<VagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetVagaInativaPorTrintaDias?";
        if (empresaId === null)
            throw new Error("The parameter 'empresaId' cannot be null.");
        else if (empresaId !== undefined)
            url_ += "empresaId=" + encodeURIComponent("" + empresaId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVagaInativaPorTrintaDias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVagaInativaPorTrintaDias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDtoPagedResultDto>;
        }));
    }

    protected processGetVagaInativaPorTrintaDias(response: HttpResponseBase): Observable<VagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    atualizarStatusVaga(id: string | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/AtualizarStatusVaga?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtualizarStatusVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtualizarStatusVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processAtualizarStatusVaga(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVagaDto | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRascunho(body: CreateRascunhoDto | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/CreateRascunho";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRascunho(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRascunho(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processCreateRascunho(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRascunho(body: UpdateRascunhoDto | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/UpdateRascunho";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRascunho(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRascunho(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processUpdateRascunho(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVagaEspecial(body: CreateVagaEspecialDto | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/CreateVagaEspecial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVagaEspecial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVagaEspecial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processCreateVagaEspecial(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVagaDto | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVagaEspecial(body: UpdateVagaEspecialDto | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/UpdateVagaEspecial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVagaEspecial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVagaEspecial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processUpdateVagaEspecial(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param nomeEmpresa (optional) 
     * @param pcd (optional) 
     * @param estado (optional) 
     * @param cidade (optional) 
     * @param modeloTrabalho (optional) 
     * @param salario (optional) 
     * @param cargosId (optional) 
     * @param microrregiaoId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getVagasVitrine(keyword: string | null | undefined, nomeEmpresa: string | null | undefined, pcd: boolean | undefined, estado: string | null | undefined, cidade: string | null | undefined, modeloTrabalho: ModeloTrabalho | undefined, salario: number | undefined, cargosId: string[] | null | undefined, microrregiaoId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VagasVitrineDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetVagasVitrine?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (nomeEmpresa !== undefined && nomeEmpresa !== null)
            url_ += "NomeEmpresa=" + encodeURIComponent("" + nomeEmpresa) + "&";
        if (pcd === null)
            throw new Error("The parameter 'pcd' cannot be null.");
        else if (pcd !== undefined)
            url_ += "Pcd=" + encodeURIComponent("" + pcd) + "&";
        if (estado !== undefined && estado !== null)
            url_ += "Estado=" + encodeURIComponent("" + estado) + "&";
        if (cidade !== undefined && cidade !== null)
            url_ += "Cidade=" + encodeURIComponent("" + cidade) + "&";
        if (modeloTrabalho === null)
            throw new Error("The parameter 'modeloTrabalho' cannot be null.");
        else if (modeloTrabalho !== undefined)
            url_ += "ModeloTrabalho=" + encodeURIComponent("" + modeloTrabalho) + "&";
        if (salario === null)
            throw new Error("The parameter 'salario' cannot be null.");
        else if (salario !== undefined)
            url_ += "Salario=" + encodeURIComponent("" + salario) + "&";
        if (cargosId !== undefined && cargosId !== null)
            cargosId && cargosId.forEach(item => { url_ += "CargosId=" + encodeURIComponent("" + item) + "&"; });
        if (microrregiaoId !== undefined && microrregiaoId !== null)
            url_ += "MicrorregiaoId=" + encodeURIComponent("" + microrregiaoId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVagasVitrine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVagasVitrine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagasVitrineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagasVitrineDto>;
        }));
    }

    protected processGetVagasVitrine(response: HttpResponseBase): Observable<VagasVitrineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagasVitrineDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllVagasNaoExcluidas(): Observable<VagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetAllVagasNaoExcluidas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVagasNaoExcluidas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVagasNaoExcluidas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto[]>;
        }));
    }

    protected processGetAllVagasNaoExcluidas(response: HttpResponseBase): Observable<VagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @param encerrada (optional) 
     * @param modeloTrabalho (optional) 
     * @param nomeVaga (optional) 
     * @param ordenacao (optional) 
     * @param statusVaga (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getVagasFiltradasEmpresa(empresaId: string | undefined, encerrada: boolean | undefined, modeloTrabalho: ModeloTrabalho | undefined, nomeVaga: string | null | undefined, ordenacao: string | null | undefined, statusVaga: StatusVaga | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetVagasFiltradasEmpresa?";
        if (empresaId === null)
            throw new Error("The parameter 'empresaId' cannot be null.");
        else if (empresaId !== undefined)
            url_ += "EmpresaId=" + encodeURIComponent("" + empresaId) + "&";
        if (encerrada === null)
            throw new Error("The parameter 'encerrada' cannot be null.");
        else if (encerrada !== undefined)
            url_ += "Encerrada=" + encodeURIComponent("" + encerrada) + "&";
        if (modeloTrabalho === null)
            throw new Error("The parameter 'modeloTrabalho' cannot be null.");
        else if (modeloTrabalho !== undefined)
            url_ += "ModeloTrabalho=" + encodeURIComponent("" + modeloTrabalho) + "&";
        if (nomeVaga !== undefined && nomeVaga !== null)
            url_ += "NomeVaga=" + encodeURIComponent("" + nomeVaga) + "&";
        if (ordenacao !== undefined && ordenacao !== null)
            url_ += "Ordenacao=" + encodeURIComponent("" + ordenacao) + "&";
        if (statusVaga === null)
            throw new Error("The parameter 'statusVaga' cannot be null.");
        else if (statusVaga !== undefined)
            url_ += "StatusVaga=" + encodeURIComponent("" + statusVaga) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVagasFiltradasEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVagasFiltradasEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDtoPagedResultDto>;
        }));
    }

    protected processGetVagasFiltradasEmpresa(response: HttpResponseBase): Observable<VagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @param encerrada (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getVagasEmpresa(empresaId: string | undefined, encerrada: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetVagasEmpresa?";
        if (empresaId === null)
            throw new Error("The parameter 'empresaId' cannot be null.");
        else if (empresaId !== undefined)
            url_ += "EmpresaId=" + encodeURIComponent("" + empresaId) + "&";
        if (encerrada === null)
            throw new Error("The parameter 'encerrada' cannot be null.");
        else if (encerrada !== undefined)
            url_ += "Encerrada=" + encodeURIComponent("" + encerrada) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVagasEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVagasEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDtoPagedResultDto>;
        }));
    }

    protected processGetVagasEmpresa(response: HttpResponseBase): Observable<VagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pcd (optional) 
     * @param encerrada (optional) 
     * @param naoIniciada (optional) 
     * @param nomeEmpresa (optional) 
     * @param cnpjEmpresa (optional) 
     * @param empresaPrestadoraDeServico (optional) 
     * @param microrregioes (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getVagasAdministrador(pcd: boolean | undefined, encerrada: boolean | undefined, naoIniciada: boolean | undefined, nomeEmpresa: string | null | undefined, cnpjEmpresa: string | null | undefined, empresaPrestadoraDeServico: boolean | undefined, microrregioes: string[] | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VagaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetVagasAdministrador?";
        if (pcd === null)
            throw new Error("The parameter 'pcd' cannot be null.");
        else if (pcd !== undefined)
            url_ += "Pcd=" + encodeURIComponent("" + pcd) + "&";
        if (encerrada === null)
            throw new Error("The parameter 'encerrada' cannot be null.");
        else if (encerrada !== undefined)
            url_ += "Encerrada=" + encodeURIComponent("" + encerrada) + "&";
        if (naoIniciada === null)
            throw new Error("The parameter 'naoIniciada' cannot be null.");
        else if (naoIniciada !== undefined)
            url_ += "NaoIniciada=" + encodeURIComponent("" + naoIniciada) + "&";
        if (nomeEmpresa !== undefined && nomeEmpresa !== null)
            url_ += "NomeEmpresa=" + encodeURIComponent("" + nomeEmpresa) + "&";
        if (cnpjEmpresa !== undefined && cnpjEmpresa !== null)
            url_ += "CnpjEmpresa=" + encodeURIComponent("" + cnpjEmpresa) + "&";
        if (empresaPrestadoraDeServico === null)
            throw new Error("The parameter 'empresaPrestadoraDeServico' cannot be null.");
        else if (empresaPrestadoraDeServico !== undefined)
            url_ += "EmpresaPrestadoraDeServico=" + encodeURIComponent("" + empresaPrestadoraDeServico) + "&";
        if (microrregioes !== undefined && microrregioes !== null)
            microrregioes && microrregioes.forEach(item => { url_ += "Microrregioes=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVagasAdministrador(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVagasAdministrador(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDtoPagedResultDto>;
        }));
    }

    protected processGetVagasAdministrador(response: HttpResponseBase): Observable<VagaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @return Success
     */
    listVagasEmpresa(empresaId: string | undefined): Observable<VagaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/ListVagasEmpresa?";
        if (empresaId === null)
            throw new Error("The parameter 'empresaId' cannot be null.");
        else if (empresaId !== undefined)
            url_ += "empresaId=" + encodeURIComponent("" + empresaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListVagasEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListVagasEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto[]>;
        }));
    }

    protected processListVagasEmpresa(response: HttpResponseBase): Observable<VagaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VagaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSalarioMaisAlto(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetSalarioMaisAlto";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalarioMaisAlto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalarioMaisAlto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSalarioMaisAlto(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    encerrarVaga(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/EncerrarVaga?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEncerrarVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEncerrarVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEncerrarVaga(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @return Success
     */
    finalizarVaga(vagaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/FinalizarVaga?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizarVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizarVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinalizarVaga(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @return Success
     */
    deletarVaga(vagaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/DeletarVaga?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletarVaga(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reabrirVaga(body: ReaberturaVagaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/ReabrirVaga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReabrirVaga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReabrirVaga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReabrirVaga(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param vagaId (optional) 
     * @return Success
     */
    setEmailGestor(email: string | null | undefined, vagaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/SetEmailGestor?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEmailGestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEmailGestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetEmailGestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empresaId (optional) 
     * @return Success
     */
    getEmailsGestores(empresaId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/GetEmailsGestores?";
        if (empresaId === null)
            throw new Error("The parameter 'empresaId' cannot be null.");
        else if (empresaId !== undefined)
            url_ += "empresaId=" + encodeURIComponent("" + empresaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailsGestores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailsGestores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetEmailsGestores(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vagaId (optional) 
     * @return Success
     */
    enviarEmailCandidato(vagaId: string | undefined): Observable<VagaDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaga/EnviarEmailCandidato?";
        if (vagaId === null)
            throw new Error("The parameter 'vagaId' cannot be null.");
        else if (vagaId !== undefined)
            url_ += "vagaId=" + encodeURIComponent("" + vagaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarEmailCandidato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarEmailCandidato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VagaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VagaDto>;
        }));
    }

    protected processEnviarEmailCandidato(response: HttpResponseBase): Observable<VagaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VagaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ForgotPasswordInput implements IForgotPasswordInput {
    emailAddress: string;

    constructor(data?: IForgotPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ForgotPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ForgotPasswordInput {
        const json = this.toJSON();
        let result = new ForgotPasswordInput();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordInput {
    emailAddress: string;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId: number;
    newPassword: string;
    resetCode: string;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
            this.resetCode = _data["resetCode"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        data["resetCode"] = this.resetCode;
        return data;
    }

    clone(): ResetPasswordInput {
        const json = this.toJSON();
        let result = new ResetPasswordInput();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordInput {
    userId: number;
    newPassword: string;
    resetCode: string;
}

export class CheckResetCodeExpireDateInput implements ICheckResetCodeExpireDateInput {
    userId: number;
    resetCode: string;

    constructor(data?: ICheckResetCodeExpireDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
        }
    }

    static fromJS(data: any): CheckResetCodeExpireDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResetCodeExpireDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        return data;
    }

    clone(): CheckResetCodeExpireDateInput {
        const json = this.toJSON();
        let result = new CheckResetCodeExpireDateInput();
        result.init(json);
        return result;
    }
}

export interface ICheckResetCodeExpireDateInput {
    userId: number;
    resetCode: string;
}

export class CheckResetCodeExpireDateOutput implements ICheckResetCodeExpireDateOutput {
    isExpired: boolean;
    emailAddress: string | undefined;

    constructor(data?: ICheckResetCodeExpireDateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExpired = _data["isExpired"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): CheckResetCodeExpireDateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResetCodeExpireDateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExpired"] = this.isExpired;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): CheckResetCodeExpireDateOutput {
        const json = this.toJSON();
        let result = new CheckResetCodeExpireDateOutput();
        result.init(json);
        return result;
    }
}

export interface ICheckResetCodeExpireDateOutput {
    isExpired: boolean;
    emailAddress: string | undefined;
}

export class TotalEmpresaRequestDto implements ITotalEmpresaRequestDto {
    empresaId: string | undefined;
    dataInicial: moment.Moment | undefined;
    dataFinal: moment.Moment | undefined;
    microrregioesId: string[] | undefined;
    top5: boolean;
    empresaEspecial: boolean;

    constructor(data?: ITotalEmpresaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresaId = _data["empresaId"];
            this.dataInicial = _data["dataInicial"] ? moment(_data["dataInicial"].toString()) : <any>undefined;
            this.dataFinal = _data["dataFinal"] ? moment(_data["dataFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["microrregioesId"])) {
                this.microrregioesId = [] as any;
                for (let item of _data["microrregioesId"])
                    this.microrregioesId.push(item);
            }
            this.top5 = _data["top5"];
            this.empresaEspecial = _data["empresaEspecial"];
        }
    }

    static fromJS(data: any): TotalEmpresaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalEmpresaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresaId"] = this.empresaId;
        data["dataInicial"] = this.dataInicial ? this.dataInicial.toISOString() : <any>undefined;
        data["dataFinal"] = this.dataFinal ? this.dataFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.microrregioesId)) {
            data["microrregioesId"] = [];
            for (let item of this.microrregioesId)
                data["microrregioesId"].push(item);
        }
        data["top5"] = this.top5;
        data["empresaEspecial"] = this.empresaEspecial;
        return data;
    }

    clone(): TotalEmpresaRequestDto {
        const json = this.toJSON();
        let result = new TotalEmpresaRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITotalEmpresaRequestDto {
    empresaId: string | undefined;
    dataInicial: moment.Moment | undefined;
    dataFinal: moment.Moment | undefined;
    microrregioesId: string[] | undefined;
    top5: boolean;
    empresaEspecial: boolean;
}

export class TotalInscritoEmpresaResponseDto implements ITotalInscritoEmpresaResponseDto {
    empresa: string | undefined;
    totalInscrito: number;

    constructor(data?: ITotalInscritoEmpresaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresa = _data["empresa"];
            this.totalInscrito = _data["totalInscrito"];
        }
    }

    static fromJS(data: any): TotalInscritoEmpresaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalInscritoEmpresaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresa"] = this.empresa;
        data["totalInscrito"] = this.totalInscrito;
        return data;
    }

    clone(): TotalInscritoEmpresaResponseDto {
        const json = this.toJSON();
        let result = new TotalInscritoEmpresaResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITotalInscritoEmpresaResponseDto {
    empresa: string | undefined;
    totalInscrito: number;
}

export enum AreaAtuacaoEmpresaEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class FiltroMicrorregioesDto implements IFiltroMicrorregioesDto {
    microrregioesId: string[] | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    empresaPrestadoraDeServico: boolean | undefined;
    vagaAberta: boolean | undefined;
    vagasEncerradas: boolean | undefined;
    candidatoExcluido: boolean | undefined;
    candidatoPcd: boolean | undefined;
    vagaParaPcd: boolean | undefined;
    empresaEspecial: boolean | undefined;
    empresaExcluida: boolean | undefined;
    cpf: string | undefined;
    cnpj: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    nomeDaEmpresa: string | undefined;
    nomeDoCandidato: string | undefined;
    areaAtuacao: AreaAtuacaoEmpresaEnum;

    constructor(data?: IFiltroMicrorregioesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["microrregioesId"])) {
                this.microrregioesId = [] as any;
                for (let item of _data["microrregioesId"])
                    this.microrregioesId.push(item);
            }
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.empresaPrestadoraDeServico = _data["empresaPrestadoraDeServico"];
            this.vagaAberta = _data["vagaAberta"];
            this.vagasEncerradas = _data["vagasEncerradas"];
            this.candidatoExcluido = _data["candidatoExcluido"];
            this.candidatoPcd = _data["candidatoPcd"];
            this.vagaParaPcd = _data["vagaParaPcd"];
            this.empresaEspecial = _data["empresaEspecial"];
            this.empresaExcluida = _data["empresaExcluida"];
            this.cpf = _data["cpf"];
            this.cnpj = _data["cnpj"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.nomeDaEmpresa = _data["nomeDaEmpresa"];
            this.nomeDoCandidato = _data["nomeDoCandidato"];
            this.areaAtuacao = _data["areaAtuacao"];
        }
    }

    static fromJS(data: any): FiltroMicrorregioesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiltroMicrorregioesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.microrregioesId)) {
            data["microrregioesId"] = [];
            for (let item of this.microrregioesId)
                data["microrregioesId"].push(item);
        }
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["empresaPrestadoraDeServico"] = this.empresaPrestadoraDeServico;
        data["vagaAberta"] = this.vagaAberta;
        data["vagasEncerradas"] = this.vagasEncerradas;
        data["candidatoExcluido"] = this.candidatoExcluido;
        data["candidatoPcd"] = this.candidatoPcd;
        data["vagaParaPcd"] = this.vagaParaPcd;
        data["empresaEspecial"] = this.empresaEspecial;
        data["empresaExcluida"] = this.empresaExcluida;
        data["cpf"] = this.cpf;
        data["cnpj"] = this.cnpj;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["nomeDaEmpresa"] = this.nomeDaEmpresa;
        data["nomeDoCandidato"] = this.nomeDoCandidato;
        data["areaAtuacao"] = this.areaAtuacao;
        return data;
    }

    clone(): FiltroMicrorregioesDto {
        const json = this.toJSON();
        let result = new FiltroMicrorregioesDto();
        result.init(json);
        return result;
    }
}

export interface IFiltroMicrorregioesDto {
    microrregioesId: string[] | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    empresaPrestadoraDeServico: boolean | undefined;
    vagaAberta: boolean | undefined;
    vagasEncerradas: boolean | undefined;
    candidatoExcluido: boolean | undefined;
    candidatoPcd: boolean | undefined;
    vagaParaPcd: boolean | undefined;
    empresaEspecial: boolean | undefined;
    empresaExcluida: boolean | undefined;
    cpf: string | undefined;
    cnpj: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    nomeDaEmpresa: string | undefined;
    nomeDoCandidato: string | undefined;
    areaAtuacao: AreaAtuacaoEmpresaEnum;
}

export class TotalInscritoVagaAbertaResponse implements ITotalInscritoVagaAbertaResponse {
    totalVaga: number;
    totalInscrito: number;

    constructor(data?: ITotalInscritoVagaAbertaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalVaga = _data["totalVaga"];
            this.totalInscrito = _data["totalInscrito"];
        }
    }

    static fromJS(data: any): TotalInscritoVagaAbertaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TotalInscritoVagaAbertaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalVaga"] = this.totalVaga;
        data["totalInscrito"] = this.totalInscrito;
        return data;
    }

    clone(): TotalInscritoVagaAbertaResponse {
        const json = this.toJSON();
        let result = new TotalInscritoVagaAbertaResponse();
        result.init(json);
        return result;
    }
}

export interface ITotalInscritoVagaAbertaResponse {
    totalVaga: number;
    totalInscrito: number;
}

export class TotalVagaEmpresaResponseDto implements ITotalVagaEmpresaResponseDto {
    empresa: string | undefined;
    totalVaga: number;

    constructor(data?: ITotalVagaEmpresaResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresa = _data["empresa"];
            this.totalVaga = _data["totalVaga"];
        }
    }

    static fromJS(data: any): TotalVagaEmpresaResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalVagaEmpresaResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresa"] = this.empresa;
        data["totalVaga"] = this.totalVaga;
        return data;
    }

    clone(): TotalVagaEmpresaResponseDto {
        const json = this.toJSON();
        let result = new TotalVagaEmpresaResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITotalVagaEmpresaResponseDto {
    empresa: string | undefined;
    totalVaga: number;
}

export class TotalInscricaoCandidatoRequestDto implements ITotalInscricaoCandidatoRequestDto {
    dataInicial: moment.Moment | undefined;
    dataFinal: moment.Moment | undefined;
    microrregioesId: string[] | undefined;

    constructor(data?: ITotalInscricaoCandidatoRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataInicial = _data["dataInicial"] ? moment(_data["dataInicial"].toString()) : <any>undefined;
            this.dataFinal = _data["dataFinal"] ? moment(_data["dataFinal"].toString()) : <any>undefined;
            if (Array.isArray(_data["microrregioesId"])) {
                this.microrregioesId = [] as any;
                for (let item of _data["microrregioesId"])
                    this.microrregioesId.push(item);
            }
        }
    }

    static fromJS(data: any): TotalInscricaoCandidatoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalInscricaoCandidatoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataInicial"] = this.dataInicial ? this.dataInicial.toISOString() : <any>undefined;
        data["dataFinal"] = this.dataFinal ? this.dataFinal.toISOString() : <any>undefined;
        if (Array.isArray(this.microrregioesId)) {
            data["microrregioesId"] = [];
            for (let item of this.microrregioesId)
                data["microrregioesId"].push(item);
        }
        return data;
    }

    clone(): TotalInscricaoCandidatoRequestDto {
        const json = this.toJSON();
        let result = new TotalInscricaoCandidatoRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITotalInscricaoCandidatoRequestDto {
    dataInicial: moment.Moment | undefined;
    dataFinal: moment.Moment | undefined;
    microrregioesId: string[] | undefined;
}

export class TotalInscricaoCandidatoResponseDto implements ITotalInscricaoCandidatoResponseDto {
    nomeCandidato: string | undefined;
    totalInscricao: number;

    constructor(data?: ITotalInscricaoCandidatoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeCandidato = _data["nomeCandidato"];
            this.totalInscricao = _data["totalInscricao"];
        }
    }

    static fromJS(data: any): TotalInscricaoCandidatoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalInscricaoCandidatoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeCandidato"] = this.nomeCandidato;
        data["totalInscricao"] = this.totalInscricao;
        return data;
    }

    clone(): TotalInscricaoCandidatoResponseDto {
        const json = this.toJSON();
        let result = new TotalInscricaoCandidatoResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITotalInscricaoCandidatoResponseDto {
    nomeCandidato: string | undefined;
    totalInscricao: number;
}

export class FiltroCandidatosDto implements IFiltroCandidatosDto {
    microrregioesId: string[] | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    candidatoExcluido: boolean | undefined;
    candidatoPcd: boolean | undefined;

    constructor(data?: IFiltroCandidatosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["microrregioesId"])) {
                this.microrregioesId = [] as any;
                for (let item of _data["microrregioesId"])
                    this.microrregioesId.push(item);
            }
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.candidatoExcluido = _data["candidatoExcluido"];
            this.candidatoPcd = _data["candidatoPcd"];
        }
    }

    static fromJS(data: any): FiltroCandidatosDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiltroCandidatosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.microrregioesId)) {
            data["microrregioesId"] = [];
            for (let item of this.microrregioesId)
                data["microrregioesId"].push(item);
        }
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["candidatoExcluido"] = this.candidatoExcluido;
        data["candidatoPcd"] = this.candidatoPcd;
        return data;
    }

    clone(): FiltroCandidatosDto {
        const json = this.toJSON();
        let result = new FiltroCandidatosDto();
        result.init(json);
        return result;
    }
}

export interface IFiltroCandidatosDto {
    microrregioesId: string[] | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    candidatoExcluido: boolean | undefined;
    candidatoPcd: boolean | undefined;
}

export class DescricaoTotalResponseDto implements IDescricaoTotalResponseDto {
    descricao: string | undefined;
    total: number;

    constructor(data?: IDescricaoTotalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): DescricaoTotalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DescricaoTotalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["total"] = this.total;
        return data;
    }

    clone(): DescricaoTotalResponseDto {
        const json = this.toJSON();
        let result = new DescricaoTotalResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDescricaoTotalResponseDto {
    descricao: string | undefined;
    total: number;
}

export class ComoConheceuCanditaoDto implements IComoConheceuCanditaoDto {
    descricao: string | undefined;
    total: number;

    constructor(data?: IComoConheceuCanditaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ComoConheceuCanditaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComoConheceuCanditaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["total"] = this.total;
        return data;
    }

    clone(): ComoConheceuCanditaoDto {
        const json = this.toJSON();
        let result = new ComoConheceuCanditaoDto();
        result.init(json);
        return result;
    }
}

export interface IComoConheceuCanditaoDto {
    descricao: string | undefined;
    total: number;
}

export class MotivoEncerramentoDto implements IMotivoEncerramentoDto {
    motivo: string | undefined;
    quantidade: number;

    constructor(data?: IMotivoEncerramentoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.motivo = _data["motivo"];
            this.quantidade = _data["quantidade"];
        }
    }

    static fromJS(data: any): MotivoEncerramentoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotivoEncerramentoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motivo"] = this.motivo;
        data["quantidade"] = this.quantidade;
        return data;
    }

    clone(): MotivoEncerramentoDto {
        const json = this.toJSON();
        let result = new MotivoEncerramentoDto();
        result.init(json);
        return result;
    }
}

export interface IMotivoEncerramentoDto {
    motivo: string | undefined;
    quantidade: number;
}

export class ComoConheceuEmpresaDto implements IComoConheceuEmpresaDto {
    descricao: string | undefined;
    total: number;

    constructor(data?: IComoConheceuEmpresaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ComoConheceuEmpresaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComoConheceuEmpresaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["total"] = this.total;
        return data;
    }

    clone(): ComoConheceuEmpresaDto {
        const json = this.toJSON();
        let result = new ComoConheceuEmpresaDto();
        result.init(json);
        return result;
    }
}

export interface IComoConheceuEmpresaDto {
    descricao: string | undefined;
    total: number;
}

export enum TipoFiltroGraficoTotalCadastro {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class TotalCadastroRequestDto implements ITotalCadastroRequestDto {
    ano: number;
    tipoFiltroGraficoTotalCadastroEnum: TipoFiltroGraficoTotalCadastro;
    mes: number | undefined;
    microrregioesId: string[] | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    eps: boolean | undefined;
    vagaAberta: boolean | undefined;

    constructor(data?: ITotalCadastroRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ano = _data["ano"];
            this.tipoFiltroGraficoTotalCadastroEnum = _data["tipoFiltroGraficoTotalCadastroEnum"];
            this.mes = _data["mes"];
            if (Array.isArray(_data["microrregioesId"])) {
                this.microrregioesId = [] as any;
                for (let item of _data["microrregioesId"])
                    this.microrregioesId.push(item);
            }
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.eps = _data["eps"];
            this.vagaAberta = _data["vagaAberta"];
        }
    }

    static fromJS(data: any): TotalCadastroRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalCadastroRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ano"] = this.ano;
        data["tipoFiltroGraficoTotalCadastroEnum"] = this.tipoFiltroGraficoTotalCadastroEnum;
        data["mes"] = this.mes;
        if (Array.isArray(this.microrregioesId)) {
            data["microrregioesId"] = [];
            for (let item of this.microrregioesId)
                data["microrregioesId"].push(item);
        }
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["eps"] = this.eps;
        data["vagaAberta"] = this.vagaAberta;
        return data;
    }

    clone(): TotalCadastroRequestDto {
        const json = this.toJSON();
        let result = new TotalCadastroRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITotalCadastroRequestDto {
    ano: number;
    tipoFiltroGraficoTotalCadastroEnum: TipoFiltroGraficoTotalCadastro;
    mes: number | undefined;
    microrregioesId: string[] | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    eps: boolean | undefined;
    vagaAberta: boolean | undefined;
}

export class TotalPeriodoDto implements ITotalPeriodoDto {
    total: number;
    periodo: number;
    periodoString: string | undefined;

    constructor(data?: ITotalPeriodoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.periodo = _data["periodo"];
            this.periodoString = _data["periodoString"];
        }
    }

    static fromJS(data: any): TotalPeriodoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalPeriodoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["periodo"] = this.periodo;
        data["periodoString"] = this.periodoString;
        return data;
    }

    clone(): TotalPeriodoDto {
        const json = this.toJSON();
        let result = new TotalPeriodoDto();
        result.init(json);
        return result;
    }
}

export interface ITotalPeriodoDto {
    total: number;
    periodo: number;
    periodoString: string | undefined;
}

export class TotalPeriodoDescricaoResponseDto implements ITotalPeriodoDescricaoResponseDto {
    readonly descricao: string | undefined;
    totalPeriodos: TotalPeriodoDto[] | undefined;

    constructor(data?: ITotalPeriodoDescricaoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).descricao = _data["descricao"];
            if (Array.isArray(_data["totalPeriodos"])) {
                this.totalPeriodos = [] as any;
                for (let item of _data["totalPeriodos"])
                    this.totalPeriodos.push(TotalPeriodoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TotalPeriodoDescricaoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalPeriodoDescricaoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        if (Array.isArray(this.totalPeriodos)) {
            data["totalPeriodos"] = [];
            for (let item of this.totalPeriodos)
                data["totalPeriodos"].push(item.toJSON());
        }
        return data;
    }

    clone(): TotalPeriodoDescricaoResponseDto {
        const json = this.toJSON();
        let result = new TotalPeriodoDescricaoResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITotalPeriodoDescricaoResponseDto {
    descricao: string | undefined;
    totalPeriodos: TotalPeriodoDto[] | undefined;
}

export class TotalInscritosSelecionadosContratadosResponseDto implements ITotalInscritosSelecionadosContratadosResponseDto {
    totalInscritos: number;
    totalSelecionados: number;
    totalContratados: number;

    constructor(data?: ITotalInscritosSelecionadosContratadosResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalInscritos = _data["totalInscritos"];
            this.totalSelecionados = _data["totalSelecionados"];
            this.totalContratados = _data["totalContratados"];
        }
    }

    static fromJS(data: any): TotalInscritosSelecionadosContratadosResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalInscritosSelecionadosContratadosResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInscritos"] = this.totalInscritos;
        data["totalSelecionados"] = this.totalSelecionados;
        data["totalContratados"] = this.totalContratados;
        return data;
    }

    clone(): TotalInscritosSelecionadosContratadosResponseDto {
        const json = this.toJSON();
        let result = new TotalInscritosSelecionadosContratadosResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITotalInscritosSelecionadosContratadosResponseDto {
    totalInscritos: number;
    totalSelecionados: number;
    totalContratados: number;
}

export class UserAccessDto implements IUserAccessDto {
    candidatos: number | undefined;
    empresas: number | undefined;
    administradores: number | undefined;
    notLoggedIn: number | undefined;
    data: moment.Moment;
    microrregiaoId: string | undefined;

    constructor(data?: IUserAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatos = _data["candidatos"];
            this.empresas = _data["empresas"];
            this.administradores = _data["administradores"];
            this.notLoggedIn = _data["notLoggedIn"];
            this.data = _data["data"] ? moment(_data["data"].toString()) : <any>undefined;
            this.microrregiaoId = _data["microrregiaoId"];
        }
    }

    static fromJS(data: any): UserAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatos"] = this.candidatos;
        data["empresas"] = this.empresas;
        data["administradores"] = this.administradores;
        data["notLoggedIn"] = this.notLoggedIn;
        data["data"] = this.data ? this.data.toISOString() : <any>undefined;
        data["microrregiaoId"] = this.microrregiaoId;
        return data;
    }

    clone(): UserAccessDto {
        const json = this.toJSON();
        let result = new UserAccessDto();
        result.init(json);
        return result;
    }
}

export interface IUserAccessDto {
    candidatos: number | undefined;
    empresas: number | undefined;
    administradores: number | undefined;
    notLoggedIn: number | undefined;
    data: moment.Moment;
    microrregiaoId: string | undefined;
}

export class UserAccessDashboardDto implements IUserAccessDashboardDto {
    quantidadeCandidatos: number | undefined;
    quantidadeEmpresas: number | undefined;
    quantidadeAdministradores: number | undefined;
    quantidadeNotLoggedIn: number | undefined;
    quantidadeCandidatosDistinct: number | undefined;
    quantidadeEmpresasDistinct: number | undefined;
    quantidadeAdministradoresDistinct: number | undefined;
    quantidadeNotLoggedInDistinct: number | undefined;
    userAccesses: UserAccessDto[] | undefined;
    acessosCandidatos: number[] | undefined;
    acessosEmpresas: number[] | undefined;
    acessosAdministradores: number[] | undefined;
    acessosNotLoggedIn: number[] | undefined;
    dataUltimoRegistro: moment.Moment | undefined;

    constructor(data?: IUserAccessDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantidadeCandidatos = _data["quantidadeCandidatos"];
            this.quantidadeEmpresas = _data["quantidadeEmpresas"];
            this.quantidadeAdministradores = _data["quantidadeAdministradores"];
            this.quantidadeNotLoggedIn = _data["quantidadeNotLoggedIn"];
            this.quantidadeCandidatosDistinct = _data["quantidadeCandidatosDistinct"];
            this.quantidadeEmpresasDistinct = _data["quantidadeEmpresasDistinct"];
            this.quantidadeAdministradoresDistinct = _data["quantidadeAdministradoresDistinct"];
            this.quantidadeNotLoggedInDistinct = _data["quantidadeNotLoggedInDistinct"];
            if (Array.isArray(_data["userAccesses"])) {
                this.userAccesses = [] as any;
                for (let item of _data["userAccesses"])
                    this.userAccesses.push(UserAccessDto.fromJS(item));
            }
            if (Array.isArray(_data["acessosCandidatos"])) {
                this.acessosCandidatos = [] as any;
                for (let item of _data["acessosCandidatos"])
                    this.acessosCandidatos.push(item);
            }
            if (Array.isArray(_data["acessosEmpresas"])) {
                this.acessosEmpresas = [] as any;
                for (let item of _data["acessosEmpresas"])
                    this.acessosEmpresas.push(item);
            }
            if (Array.isArray(_data["acessosAdministradores"])) {
                this.acessosAdministradores = [] as any;
                for (let item of _data["acessosAdministradores"])
                    this.acessosAdministradores.push(item);
            }
            if (Array.isArray(_data["acessosNotLoggedIn"])) {
                this.acessosNotLoggedIn = [] as any;
                for (let item of _data["acessosNotLoggedIn"])
                    this.acessosNotLoggedIn.push(item);
            }
            this.dataUltimoRegistro = _data["dataUltimoRegistro"] ? moment(_data["dataUltimoRegistro"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAccessDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantidadeCandidatos"] = this.quantidadeCandidatos;
        data["quantidadeEmpresas"] = this.quantidadeEmpresas;
        data["quantidadeAdministradores"] = this.quantidadeAdministradores;
        data["quantidadeNotLoggedIn"] = this.quantidadeNotLoggedIn;
        data["quantidadeCandidatosDistinct"] = this.quantidadeCandidatosDistinct;
        data["quantidadeEmpresasDistinct"] = this.quantidadeEmpresasDistinct;
        data["quantidadeAdministradoresDistinct"] = this.quantidadeAdministradoresDistinct;
        data["quantidadeNotLoggedInDistinct"] = this.quantidadeNotLoggedInDistinct;
        if (Array.isArray(this.userAccesses)) {
            data["userAccesses"] = [];
            for (let item of this.userAccesses)
                data["userAccesses"].push(item.toJSON());
        }
        if (Array.isArray(this.acessosCandidatos)) {
            data["acessosCandidatos"] = [];
            for (let item of this.acessosCandidatos)
                data["acessosCandidatos"].push(item);
        }
        if (Array.isArray(this.acessosEmpresas)) {
            data["acessosEmpresas"] = [];
            for (let item of this.acessosEmpresas)
                data["acessosEmpresas"].push(item);
        }
        if (Array.isArray(this.acessosAdministradores)) {
            data["acessosAdministradores"] = [];
            for (let item of this.acessosAdministradores)
                data["acessosAdministradores"].push(item);
        }
        if (Array.isArray(this.acessosNotLoggedIn)) {
            data["acessosNotLoggedIn"] = [];
            for (let item of this.acessosNotLoggedIn)
                data["acessosNotLoggedIn"].push(item);
        }
        data["dataUltimoRegistro"] = this.dataUltimoRegistro ? this.dataUltimoRegistro.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserAccessDashboardDto {
        const json = this.toJSON();
        let result = new UserAccessDashboardDto();
        result.init(json);
        return result;
    }
}

export interface IUserAccessDashboardDto {
    quantidadeCandidatos: number | undefined;
    quantidadeEmpresas: number | undefined;
    quantidadeAdministradores: number | undefined;
    quantidadeNotLoggedIn: number | undefined;
    quantidadeCandidatosDistinct: number | undefined;
    quantidadeEmpresasDistinct: number | undefined;
    quantidadeAdministradoresDistinct: number | undefined;
    quantidadeNotLoggedInDistinct: number | undefined;
    userAccesses: UserAccessDto[] | undefined;
    acessosCandidatos: number[] | undefined;
    acessosEmpresas: number[] | undefined;
    acessosAdministradores: number[] | undefined;
    acessosNotLoggedIn: number[] | undefined;
    dataUltimoRegistro: moment.Moment | undefined;
}

export class CreateAdministradorDto implements ICreateAdministradorDto {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;
    senha: string;
    roleNames: string[];

    constructor(data?: ICreateAdministradorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.senha = _data["senha"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAdministradorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdministradorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["senha"] = this.senha;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): CreateAdministradorDto {
        const json = this.toJSON();
        let result = new CreateAdministradorDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAdministradorDto {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;
    senha: string;
    roleNames: string[];
}

export class UserDto implements IUserDto {
    userName: string;
    name: string;
    surname: string | undefined;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string | undefined;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;
}

export class AdministradorDto implements IAdministradorDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    urlFotoPerfil: string | undefined;
    id: string;

    constructor(data?: IAdministradorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.urlFotoPerfil = _data["urlFotoPerfil"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdministradorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdministradorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        data["id"] = this.id;
        return data;
    }

    clone(): AdministradorDto {
        const json = this.toJSON();
        let result = new AdministradorDto();
        result.init(json);
        return result;
    }
}

export interface IAdministradorDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    urlFotoPerfil: string | undefined;
    id: string;
}

export class AdministradorDtoPagedResultDto implements IAdministradorDtoPagedResultDto {
    totalCount: number;
    items: AdministradorDto[] | undefined;

    constructor(data?: IAdministradorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AdministradorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdministradorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdministradorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AdministradorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdministradorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdministradorDtoPagedResultDto {
    totalCount: number;
    items: AdministradorDto[] | undefined;
}

export class UpdateAdministradorDto implements IUpdateAdministradorDto {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    urlFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    id: string;

    constructor(data?: IUpdateAdministradorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.nomeFotoPerfil = _data["nomeFotoPerfil"];
            this.extensaoFotoPerfil = _data["extensaoFotoPerfil"];
            this.urlFotoPerfil = _data["urlFotoPerfil"];
            this.base64FotoPerfil = _data["base64FotoPerfil"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAdministradorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdministradorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["nomeFotoPerfil"] = this.nomeFotoPerfil;
        data["extensaoFotoPerfil"] = this.extensaoFotoPerfil;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        data["base64FotoPerfil"] = this.base64FotoPerfil;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateAdministradorDto {
        const json = this.toJSON();
        let result = new UpdateAdministradorDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAdministradorDto {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    urlFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    id: string;
}

export class LogoEmpresaDto implements ILogoEmpresaDto {
    fotoBase64: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    fotoUrl: string | undefined;
    id: string;

    constructor(data?: ILogoEmpresaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fotoBase64 = _data["fotoBase64"];
            this.nomeArquivo = _data["nomeArquivo"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.fotoUrl = _data["fotoUrl"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LogoEmpresaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogoEmpresaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fotoBase64"] = this.fotoBase64;
        data["nomeArquivo"] = this.nomeArquivo;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["fotoUrl"] = this.fotoUrl;
        data["id"] = this.id;
        return data;
    }

    clone(): LogoEmpresaDto {
        const json = this.toJSON();
        let result = new LogoEmpresaDto();
        result.init(json);
        return result;
    }
}

export interface ILogoEmpresaDto {
    fotoBase64: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    fotoUrl: string | undefined;
    id: string;
}

export class CreateLogoEmpresasDto implements ICreateLogoEmpresasDto {
    logos: LogoEmpresaDto[] | undefined;

    constructor(data?: ICreateLogoEmpresasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logos"])) {
                this.logos = [] as any;
                for (let item of _data["logos"])
                    this.logos.push(LogoEmpresaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateLogoEmpresasDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLogoEmpresasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logos)) {
            data["logos"] = [];
            for (let item of this.logos)
                data["logos"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateLogoEmpresasDto {
        const json = this.toJSON();
        let result = new CreateLogoEmpresasDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLogoEmpresasDto {
    logos: LogoEmpresaDto[] | undefined;
}

export class LogoEmpresaDtoPagedResultDto implements ILogoEmpresaDtoPagedResultDto {
    totalCount: number;
    items: LogoEmpresaDto[] | undefined;

    constructor(data?: ILogoEmpresaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LogoEmpresaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogoEmpresaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogoEmpresaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): LogoEmpresaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LogoEmpresaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILogoEmpresaDtoPagedResultDto {
    totalCount: number;
    items: LogoEmpresaDto[] | undefined;
}

export class EmailContatoDto implements IEmailContatoDto {
    email: string;
    nome: string;
    telefone: string;
    empresa: string;

    constructor(data?: IEmailContatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.nome = _data["nome"];
            this.telefone = _data["telefone"];
            this.empresa = _data["empresa"];
        }
    }

    static fromJS(data: any): EmailContatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailContatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["nome"] = this.nome;
        data["telefone"] = this.telefone;
        data["empresa"] = this.empresa;
        return data;
    }

    clone(): EmailContatoDto {
        const json = this.toJSON();
        let result = new EmailContatoDto();
        result.init(json);
        return result;
    }
}

export interface IEmailContatoDto {
    email: string;
    nome: string;
    telefone: string;
    empresa: string;
}

export class RespostaAvaliacaoRequisitoDto implements IRespostaAvaliacaoRequisitoDto {
    resposta: string | undefined;
    avaliacaoRequisitoVagaId: string;
    id: string;

    constructor(data?: IRespostaAvaliacaoRequisitoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resposta = _data["resposta"];
            this.avaliacaoRequisitoVagaId = _data["avaliacaoRequisitoVagaId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RespostaAvaliacaoRequisitoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RespostaAvaliacaoRequisitoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resposta"] = this.resposta;
        data["avaliacaoRequisitoVagaId"] = this.avaliacaoRequisitoVagaId;
        data["id"] = this.id;
        return data;
    }

    clone(): RespostaAvaliacaoRequisitoDto {
        const json = this.toJSON();
        let result = new RespostaAvaliacaoRequisitoDto();
        result.init(json);
        return result;
    }
}

export interface IRespostaAvaliacaoRequisitoDto {
    resposta: string | undefined;
    avaliacaoRequisitoVagaId: string;
    id: string;
}

export class AvaliacaoRequisitoVagaDto implements IAvaliacaoRequisitoVagaDto {
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisitoDto[] | undefined;
    id: string;

    constructor(data?: IAvaliacaoRequisitoVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avaliacao = _data["avaliacao"];
            if (Array.isArray(_data["possiveisRespostasAvaliacaoRequisito"])) {
                this.possiveisRespostasAvaliacaoRequisito = [] as any;
                for (let item of _data["possiveisRespostasAvaliacaoRequisito"])
                    this.possiveisRespostasAvaliacaoRequisito.push(RespostaAvaliacaoRequisitoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AvaliacaoRequisitoVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvaliacaoRequisitoVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avaliacao"] = this.avaliacao;
        if (Array.isArray(this.possiveisRespostasAvaliacaoRequisito)) {
            data["possiveisRespostasAvaliacaoRequisito"] = [];
            for (let item of this.possiveisRespostasAvaliacaoRequisito)
                data["possiveisRespostasAvaliacaoRequisito"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): AvaliacaoRequisitoVagaDto {
        const json = this.toJSON();
        let result = new AvaliacaoRequisitoVagaDto();
        result.init(json);
        return result;
    }
}

export interface IAvaliacaoRequisitoVagaDto {
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisitoDto[] | undefined;
    id: string;
}

export class CreateAvaliacaoRequisitoVagaDto implements ICreateAvaliacaoRequisitoVagaDto {
    vagaId: string;
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisitoDto[] | undefined;
    id: string;

    constructor(data?: ICreateAvaliacaoRequisitoVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vagaId = _data["vagaId"];
            this.avaliacao = _data["avaliacao"];
            if (Array.isArray(_data["possiveisRespostasAvaliacaoRequisito"])) {
                this.possiveisRespostasAvaliacaoRequisito = [] as any;
                for (let item of _data["possiveisRespostasAvaliacaoRequisito"])
                    this.possiveisRespostasAvaliacaoRequisito.push(RespostaAvaliacaoRequisitoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAvaliacaoRequisitoVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAvaliacaoRequisitoVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vagaId"] = this.vagaId;
        data["avaliacao"] = this.avaliacao;
        if (Array.isArray(this.possiveisRespostasAvaliacaoRequisito)) {
            data["possiveisRespostasAvaliacaoRequisito"] = [];
            for (let item of this.possiveisRespostasAvaliacaoRequisito)
                data["possiveisRespostasAvaliacaoRequisito"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CreateAvaliacaoRequisitoVagaDto {
        const json = this.toJSON();
        let result = new CreateAvaliacaoRequisitoVagaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAvaliacaoRequisitoVagaDto {
    vagaId: string;
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisitoDto[] | undefined;
    id: string;
}

export class UpdateAvaliacaoRequisitoVagaDto implements IUpdateAvaliacaoRequisitoVagaDto {
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisitoDto[] | undefined;
    id: string;

    constructor(data?: IUpdateAvaliacaoRequisitoVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avaliacao = _data["avaliacao"];
            if (Array.isArray(_data["possiveisRespostasAvaliacaoRequisito"])) {
                this.possiveisRespostasAvaliacaoRequisito = [] as any;
                for (let item of _data["possiveisRespostasAvaliacaoRequisito"])
                    this.possiveisRespostasAvaliacaoRequisito.push(RespostaAvaliacaoRequisitoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAvaliacaoRequisitoVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAvaliacaoRequisitoVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avaliacao"] = this.avaliacao;
        if (Array.isArray(this.possiveisRespostasAvaliacaoRequisito)) {
            data["possiveisRespostasAvaliacaoRequisito"] = [];
            for (let item of this.possiveisRespostasAvaliacaoRequisito)
                data["possiveisRespostasAvaliacaoRequisito"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateAvaliacaoRequisitoVagaDto {
        const json = this.toJSON();
        let result = new UpdateAvaliacaoRequisitoVagaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAvaliacaoRequisitoVagaDto {
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisitoDto[] | undefined;
    id: string;
}

export enum Genero {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CorRacaEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ComunidadeDto implements IComunidadeDto {
    nome: string | undefined;
    id: string;

    constructor(data?: IComunidadeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ComunidadeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComunidadeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): ComunidadeDto {
        const json = this.toJSON();
        let result = new ComunidadeDto();
        result.init(json);
        return result;
    }
}

export interface IComunidadeDto {
    nome: string | undefined;
    id: string;
}

export class EnderecoDto implements IEnderecoDto {
    logradouro: string | undefined;
    bairro: string | undefined;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    microrregiaoId: string;
    id: string;

    constructor(data?: IEnderecoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logradouro = _data["logradouro"];
            this.bairro = _data["bairro"];
            this.complemento = _data["complemento"];
            this.numero = _data["numero"];
            this.cep = _data["cep"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EnderecoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnderecoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradouro"] = this.logradouro;
        data["bairro"] = this.bairro;
        data["complemento"] = this.complemento;
        data["numero"] = this.numero;
        data["cep"] = this.cep;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["microrregiaoId"] = this.microrregiaoId;
        data["id"] = this.id;
        return data;
    }

    clone(): EnderecoDto {
        const json = this.toJSON();
        let result = new EnderecoDto();
        result.init(json);
        return result;
    }
}

export interface IEnderecoDto {
    logradouro: string | undefined;
    bairro: string | undefined;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    microrregiaoId: string;
    id: string;
}

export class CurriculoDadoPessoalDto implements ICurriculoDadoPessoalDto {
    candidatoId: string;
    nome: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    genero: Genero;
    readonly generoString: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    telefone: string | undefined;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    fotoUrl: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    corRaca: CorRacaEnum;
    readonly corRacaString: string | undefined;
    comunidadeId: string | undefined;
    comunidade: ComunidadeDto;
    endereco: EnderecoDto;
    naoPossuiEmail: boolean;
    id: string;

    constructor(data?: ICurriculoDadoPessoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.rg = _data["rg"];
            this.genero = _data["genero"];
            (<any>this).generoString = _data["generoString"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.fotoNome = _data["fotoNome"];
            this.fotoExtensao = _data["fotoExtensao"];
            this.fotoUrl = _data["fotoUrl"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.corRaca = _data["corRaca"];
            (<any>this).corRacaString = _data["corRacaString"];
            this.comunidadeId = _data["comunidadeId"];
            this.comunidade = _data["comunidade"] ? ComunidadeDto.fromJS(_data["comunidade"]) : <any>undefined;
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.naoPossuiEmail = _data["naoPossuiEmail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoDadoPessoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoDadoPessoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["rg"] = this.rg;
        data["genero"] = this.genero;
        data["generoString"] = this.generoString;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["fotoNome"] = this.fotoNome;
        data["fotoExtensao"] = this.fotoExtensao;
        data["fotoUrl"] = this.fotoUrl;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["corRaca"] = this.corRaca;
        data["corRacaString"] = this.corRacaString;
        data["comunidadeId"] = this.comunidadeId;
        data["comunidade"] = this.comunidade ? this.comunidade.toJSON() : <any>undefined;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoDadoPessoalDto {
        const json = this.toJSON();
        let result = new CurriculoDadoPessoalDto();
        result.init(json);
        return result;
    }
}

export interface ICurriculoDadoPessoalDto {
    candidatoId: string;
    nome: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    genero: Genero;
    generoString: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    telefone: string | undefined;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    fotoUrl: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    corRaca: CorRacaEnum;
    corRacaString: string | undefined;
    comunidadeId: string | undefined;
    comunidade: ComunidadeDto;
    endereco: EnderecoDto;
    naoPossuiEmail: boolean;
    id: string;
}

export class CurriculoDadoPessoalAnexoDto implements ICurriculoDadoPessoalAnexoDto {
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    id: string;

    constructor(data?: ICurriculoDadoPessoalAnexoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoDadoPessoalAnexoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoDadoPessoalAnexoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoDadoPessoalAnexoDto {
        const json = this.toJSON();
        let result = new CurriculoDadoPessoalAnexoDto();
        result.init(json);
        return result;
    }
}

export interface ICurriculoDadoPessoalAnexoDto {
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    id: string;
}

export enum RendaBrutaFamiliarEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
}

export class IdiomaDto implements IIdiomaDto {
    nome: string | undefined;
    id: string;

    constructor(data?: IIdiomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdiomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdiomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): IdiomaDto {
        const json = this.toJSON();
        let result = new IdiomaDto();
        result.init(json);
        return result;
    }
}

export interface IIdiomaDto {
    nome: string | undefined;
    id: string;
}

export enum NivelIdioma {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CandidatoIdiomaDto implements ICandidatoIdiomaDto {
    candidatoId: string;
    idiomaId: string;
    idioma: IdiomaDto;
    nivelIdioma: NivelIdioma;
    readonly nivelIdiomaString: string | undefined;
    id: string;

    constructor(data?: ICandidatoIdiomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.idiomaId = _data["idiomaId"];
            this.idioma = _data["idioma"] ? IdiomaDto.fromJS(_data["idioma"]) : <any>undefined;
            this.nivelIdioma = _data["nivelIdioma"];
            (<any>this).nivelIdiomaString = _data["nivelIdiomaString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoIdiomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoIdiomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["idiomaId"] = this.idiomaId;
        data["idioma"] = this.idioma ? this.idioma.toJSON() : <any>undefined;
        data["nivelIdioma"] = this.nivelIdioma;
        data["nivelIdiomaString"] = this.nivelIdiomaString;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoIdiomaDto {
        const json = this.toJSON();
        let result = new CandidatoIdiomaDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoIdiomaDto {
    candidatoId: string;
    idiomaId: string;
    idioma: IdiomaDto;
    nivelIdioma: NivelIdioma;
    nivelIdiomaString: string | undefined;
    id: string;
}

export enum TipoEmprego {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export enum ModeloTrabalho {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CurriculoExperienciaDto implements ICurriculoExperienciaDto {
    candidatoId: string;
    titulo: string | undefined;
    tipoEmprego: TipoEmprego;
    regimeTrabalho: ModeloTrabalho;
    readonly tipoEmpregoString: string | undefined;
    nomeEmpresa: string | undefined;
    cidade: string | undefined;
    uf: string | undefined;
    descricao: string | undefined;
    trabalhaAtualmente: boolean;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    naoLembraData: boolean;
    id: string;

    constructor(data?: ICurriculoExperienciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.titulo = _data["titulo"];
            this.tipoEmprego = _data["tipoEmprego"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            (<any>this).tipoEmpregoString = _data["tipoEmpregoString"];
            this.nomeEmpresa = _data["nomeEmpresa"];
            this.cidade = _data["cidade"];
            this.uf = _data["uf"];
            this.descricao = _data["descricao"];
            this.trabalhaAtualmente = _data["trabalhaAtualmente"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.naoLembraData = _data["naoLembraData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoExperienciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoExperienciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["titulo"] = this.titulo;
        data["tipoEmprego"] = this.tipoEmprego;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["tipoEmpregoString"] = this.tipoEmpregoString;
        data["nomeEmpresa"] = this.nomeEmpresa;
        data["cidade"] = this.cidade;
        data["uf"] = this.uf;
        data["descricao"] = this.descricao;
        data["trabalhaAtualmente"] = this.trabalhaAtualmente;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["naoLembraData"] = this.naoLembraData;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoExperienciaDto {
        const json = this.toJSON();
        let result = new CurriculoExperienciaDto();
        result.init(json);
        return result;
    }
}

export interface ICurriculoExperienciaDto {
    candidatoId: string;
    titulo: string | undefined;
    tipoEmprego: TipoEmprego;
    regimeTrabalho: ModeloTrabalho;
    tipoEmpregoString: string | undefined;
    nomeEmpresa: string | undefined;
    cidade: string | undefined;
    uf: string | undefined;
    descricao: string | undefined;
    trabalhaAtualmente: boolean;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    naoLembraData: boolean;
    id: string;
}

export class CompetenciaDto implements ICompetenciaDto {
    nome: string | undefined;
    id: string;

    constructor(data?: ICompetenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompetenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): CompetenciaDto {
        const json = this.toJSON();
        let result = new CompetenciaDto();
        result.init(json);
        return result;
    }
}

export interface ICompetenciaDto {
    nome: string | undefined;
    id: string;
}

export enum NivelCompetencia {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CurriculoCompetenciaDto implements ICurriculoCompetenciaDto {
    candidatoId: string;
    competencia: CompetenciaDto;
    competenciaId: string;
    nivelCompetencia: NivelCompetencia;
    readonly nivelCompetenciaString: string | undefined;
    id: string;

    constructor(data?: ICurriculoCompetenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.competencia = _data["competencia"] ? CompetenciaDto.fromJS(_data["competencia"]) : <any>undefined;
            this.competenciaId = _data["competenciaId"];
            this.nivelCompetencia = _data["nivelCompetencia"];
            (<any>this).nivelCompetenciaString = _data["nivelCompetenciaString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoCompetenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoCompetenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["competencia"] = this.competencia ? this.competencia.toJSON() : <any>undefined;
        data["competenciaId"] = this.competenciaId;
        data["nivelCompetencia"] = this.nivelCompetencia;
        data["nivelCompetenciaString"] = this.nivelCompetenciaString;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoCompetenciaDto {
        const json = this.toJSON();
        let result = new CurriculoCompetenciaDto();
        result.init(json);
        return result;
    }
}

export interface ICurriculoCompetenciaDto {
    candidatoId: string;
    competencia: CompetenciaDto;
    competenciaId: string;
    nivelCompetencia: NivelCompetencia;
    nivelCompetenciaString: string | undefined;
    id: string;
}

export class CandidatoFormacaoAcademicaDto implements ICandidatoFormacaoAcademicaDto {
    candidatoId: string;
    nomeInstituicao: string | undefined;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;
    id: string;

    constructor(data?: ICandidatoFormacaoAcademicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.nomeInstituicao = _data["nomeInstituicao"];
            this.nomeCurso = _data["nomeCurso"];
            this.grau = _data["grau"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.naoLembraData = _data["naoLembraData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoFormacaoAcademicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoFormacaoAcademicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["nomeInstituicao"] = this.nomeInstituicao;
        data["nomeCurso"] = this.nomeCurso;
        data["grau"] = this.grau;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["naoLembraData"] = this.naoLembraData;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoFormacaoAcademicaDto {
        const json = this.toJSON();
        let result = new CandidatoFormacaoAcademicaDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoFormacaoAcademicaDto {
    candidatoId: string;
    nomeInstituicao: string | undefined;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;
    id: string;
}

export class SkillConectaDto implements ISkillConectaDto {
    nome: string | undefined;
    id: string;

    constructor(data?: ISkillConectaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SkillConectaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkillConectaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): SkillConectaDto {
        const json = this.toJSON();
        let result = new SkillConectaDto();
        result.init(json);
        return result;
    }
}

export interface ISkillConectaDto {
    nome: string | undefined;
    id: string;
}

export class CurriculoSkillConectaDto implements ICurriculoSkillConectaDto {
    candidatoId: string;
    skillConecta: SkillConectaDto;
    skillConectaId: string;
    id: string;

    constructor(data?: ICurriculoSkillConectaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.skillConecta = _data["skillConecta"] ? SkillConectaDto.fromJS(_data["skillConecta"]) : <any>undefined;
            this.skillConectaId = _data["skillConectaId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoSkillConectaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoSkillConectaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["skillConecta"] = this.skillConecta ? this.skillConecta.toJSON() : <any>undefined;
        data["skillConectaId"] = this.skillConectaId;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoSkillConectaDto {
        const json = this.toJSON();
        let result = new CurriculoSkillConectaDto();
        result.init(json);
        return result;
    }
}

export interface ICurriculoSkillConectaDto {
    candidatoId: string;
    skillConecta: SkillConectaDto;
    skillConectaId: string;
    id: string;
}

export class ResponsavelDto implements IResponsavelDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;

    constructor(data?: IResponsavelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
        }
    }

    static fromJS(data: any): ResponsavelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsavelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        return data;
    }

    clone(): ResponsavelDto {
        const json = this.toJSON();
        let result = new ResponsavelDto();
        result.init(json);
        return result;
    }
}

export interface IResponsavelDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
}

export class EmpresaDto implements IEmpresaDto {
    razaoSocial: string | undefined;
    nome: string | undefined;
    cnpj: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    responsavel: ResponsavelDto;
    endereco: EnderecoDto;
    urlFotoPerfil: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    creationTime: moment.Moment;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;
    readonly areaAtuacaoEmpresaString: string | undefined;
    enviarEmailNovoInscrito: boolean;
    empresaEspecial: boolean;
    nomeUsuario: string | undefined;
    deleterUserId: number | undefined;
    totalVagas: number;
    id: string;

    constructor(data?: IEmpresaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.razaoSocial = _data["razaoSocial"];
            this.nome = _data["nome"];
            this.cnpj = _data["cnpj"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.responsavel = _data["responsavel"] ? ResponsavelDto.fromJS(_data["responsavel"]) : <any>undefined;
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.urlFotoPerfil = _data["urlFotoPerfil"];
            this.urlFotoPerfilDesbloqueado = _data["urlFotoPerfilDesbloqueado"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.prestadoraServicoSuzano = _data["prestadoraServicoSuzano"];
            this.areaAtuacaoEmpresaEnum = _data["areaAtuacaoEmpresaEnum"];
            (<any>this).areaAtuacaoEmpresaString = _data["areaAtuacaoEmpresaString"];
            this.enviarEmailNovoInscrito = _data["enviarEmailNovoInscrito"];
            this.empresaEspecial = _data["empresaEspecial"];
            this.nomeUsuario = _data["nomeUsuario"];
            this.deleterUserId = _data["deleterUserId"];
            this.totalVagas = _data["totalVagas"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmpresaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpresaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["razaoSocial"] = this.razaoSocial;
        data["nome"] = this.nome;
        data["cnpj"] = this.cnpj;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["responsavel"] = this.responsavel ? this.responsavel.toJSON() : <any>undefined;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        data["urlFotoPerfilDesbloqueado"] = this.urlFotoPerfilDesbloqueado;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["prestadoraServicoSuzano"] = this.prestadoraServicoSuzano;
        data["areaAtuacaoEmpresaEnum"] = this.areaAtuacaoEmpresaEnum;
        data["areaAtuacaoEmpresaString"] = this.areaAtuacaoEmpresaString;
        data["enviarEmailNovoInscrito"] = this.enviarEmailNovoInscrito;
        data["empresaEspecial"] = this.empresaEspecial;
        data["nomeUsuario"] = this.nomeUsuario;
        data["deleterUserId"] = this.deleterUserId;
        data["totalVagas"] = this.totalVagas;
        data["id"] = this.id;
        return data;
    }

    clone(): EmpresaDto {
        const json = this.toJSON();
        let result = new EmpresaDto();
        result.init(json);
        return result;
    }
}

export interface IEmpresaDto {
    razaoSocial: string | undefined;
    nome: string | undefined;
    cnpj: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    responsavel: ResponsavelDto;
    endereco: EnderecoDto;
    urlFotoPerfil: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    creationTime: moment.Moment;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;
    areaAtuacaoEmpresaString: string | undefined;
    enviarEmailNovoInscrito: boolean;
    empresaEspecial: boolean;
    nomeUsuario: string | undefined;
    deleterUserId: number | undefined;
    totalVagas: number;
    id: string;
}

export enum RegimeTrabalho {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class CargoDto implements ICargoDto {
    nome: string | undefined;
    id: string;

    constructor(data?: ICargoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CargoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CargoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): CargoDto {
        const json = this.toJSON();
        let result = new CargoDto();
        result.init(json);
        return result;
    }
}

export interface ICargoDto {
    nome: string | undefined;
    id: string;
}

export enum StatusVaga {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class VagaDto implements IVagaDto {
    empresa: EmpresaDto;
    empresaId: string;
    tituloVaga: string | undefined;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    readonly regimeTrabalhoString: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargo: CargoDto;
    cargoId: string | undefined;
    readonly modeloTrabalhoString: string | undefined;
    modeloTrabalho: ModeloTrabalho;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    motivoEncerramento: string | undefined;
    emailEncerramento: boolean;
    creationTime: moment.Moment;
    totalInscritos: number;
    contratados: number;
    selecionados: number;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    pcd: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: AvaliacaoRequisitoVagaDto[] | undefined;
    urlVaga: string | undefined;
    vagaEspecial: boolean;
    emailEnviado: boolean;
    statusVaga: StatusVaga;
    readonly statusVagaString: string | undefined;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
    id: string;

    constructor(data?: IVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresa = _data["empresa"] ? EmpresaDto.fromJS(_data["empresa"]) : <any>undefined;
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            (<any>this).regimeTrabalhoString = _data["regimeTrabalhoString"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargo = _data["cargo"] ? CargoDto.fromJS(_data["cargo"]) : <any>undefined;
            this.cargoId = _data["cargoId"];
            (<any>this).modeloTrabalhoString = _data["modeloTrabalhoString"];
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.encerrada = _data["encerrada"];
            this.motivoEncerramento = _data["motivoEncerramento"];
            this.emailEncerramento = _data["emailEncerramento"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.totalInscritos = _data["totalInscritos"];
            this.contratados = _data["contratados"];
            this.selecionados = _data["selecionados"];
            this.exibirVagas = _data["exibirVagas"];
            this.exibirSalario = _data["exibirSalario"];
            this.pcd = _data["pcd"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            if (Array.isArray(_data["avaliacoesRequisitosVaga"])) {
                this.avaliacoesRequisitosVaga = [] as any;
                for (let item of _data["avaliacoesRequisitosVaga"])
                    this.avaliacoesRequisitosVaga.push(AvaliacaoRequisitoVagaDto.fromJS(item));
            }
            this.urlVaga = _data["urlVaga"];
            this.vagaEspecial = _data["vagaEspecial"];
            this.emailEnviado = _data["emailEnviado"];
            this.statusVaga = _data["statusVaga"];
            (<any>this).statusVagaString = _data["statusVagaString"];
            this.statusVagaUltimaAtualizacao = _data["statusVagaUltimaAtualizacao"] ? moment(_data["statusVagaUltimaAtualizacao"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new VagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresa"] = this.empresa ? this.empresa.toJSON() : <any>undefined;
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalhoString"] = this.regimeTrabalhoString;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["cargoId"] = this.cargoId;
        data["modeloTrabalhoString"] = this.modeloTrabalhoString;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["encerrada"] = this.encerrada;
        data["motivoEncerramento"] = this.motivoEncerramento;
        data["emailEncerramento"] = this.emailEncerramento;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["totalInscritos"] = this.totalInscritos;
        data["contratados"] = this.contratados;
        data["selecionados"] = this.selecionados;
        data["exibirVagas"] = this.exibirVagas;
        data["exibirSalario"] = this.exibirSalario;
        data["pcd"] = this.pcd;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        if (Array.isArray(this.avaliacoesRequisitosVaga)) {
            data["avaliacoesRequisitosVaga"] = [];
            for (let item of this.avaliacoesRequisitosVaga)
                data["avaliacoesRequisitosVaga"].push(item.toJSON());
        }
        data["urlVaga"] = this.urlVaga;
        data["vagaEspecial"] = this.vagaEspecial;
        data["emailEnviado"] = this.emailEnviado;
        data["statusVaga"] = this.statusVaga;
        data["statusVagaString"] = this.statusVagaString;
        data["statusVagaUltimaAtualizacao"] = this.statusVagaUltimaAtualizacao ? this.statusVagaUltimaAtualizacao.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): VagaDto {
        const json = this.toJSON();
        let result = new VagaDto();
        result.init(json);
        return result;
    }
}

export interface IVagaDto {
    empresa: EmpresaDto;
    empresaId: string;
    tituloVaga: string | undefined;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalhoString: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargo: CargoDto;
    cargoId: string | undefined;
    modeloTrabalhoString: string | undefined;
    modeloTrabalho: ModeloTrabalho;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    motivoEncerramento: string | undefined;
    emailEncerramento: boolean;
    creationTime: moment.Moment;
    totalInscritos: number;
    contratados: number;
    selecionados: number;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    pcd: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: AvaliacaoRequisitoVagaDto[] | undefined;
    urlVaga: string | undefined;
    vagaEspecial: boolean;
    emailEnviado: boolean;
    statusVaga: StatusVaga;
    statusVagaString: string | undefined;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
    id: string;
}

export class LaudoMedicoDto implements ILaudoMedicoDto {
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    id: string;

    constructor(data?: ILaudoMedicoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaudoMedicoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaudoMedicoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["id"] = this.id;
        return data;
    }

    clone(): LaudoMedicoDto {
        const json = this.toJSON();
        let result = new LaudoMedicoDto();
        result.init(json);
        return result;
    }
}

export interface ILaudoMedicoDto {
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    id: string;
}

export enum EstagioTriagem {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class CandidaturaVagaDto implements ICandidaturaVagaDto {
    estagioTriagem: EstagioTriagem;
    candidatoId: string;
    vagaId: string;
    vaga: VagaDto;
    creationTime: moment.Moment;
    readonly estagioTriagemString: string | undefined;
    id: string;

    constructor(data?: ICandidaturaVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estagioTriagem = _data["estagioTriagem"];
            this.candidatoId = _data["candidatoId"];
            this.vagaId = _data["vagaId"];
            this.vaga = _data["vaga"] ? VagaDto.fromJS(_data["vaga"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidaturaVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidaturaVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estagioTriagem"] = this.estagioTriagem;
        data["candidatoId"] = this.candidatoId;
        data["vagaId"] = this.vagaId;
        data["vaga"] = this.vaga ? this.vaga.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidaturaVagaDto {
        const json = this.toJSON();
        let result = new CandidaturaVagaDto();
        result.init(json);
        return result;
    }
}

export interface ICandidaturaVagaDto {
    estagioTriagem: EstagioTriagem;
    candidatoId: string;
    vagaId: string;
    vaga: VagaDto;
    creationTime: moment.Moment;
    estagioTriagemString: string | undefined;
    id: string;
}

export class OnboardingCandidatoDto implements IOnboardingCandidatoDto {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;
    id: string;

    constructor(data?: IOnboardingCandidatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temSalarioOuRenda = _data["temSalarioOuRenda"];
            this.valorSalario = _data["valorSalario"];
            this.temBeneficioGoverno = _data["temBeneficioGoverno"];
            this.valorBeneficio = _data["valorBeneficio"];
            this.valorRendaFamiliar = _data["valorRendaFamiliar"];
            this.candidatoId = _data["candidatoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OnboardingCandidatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingCandidatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temSalarioOuRenda"] = this.temSalarioOuRenda;
        data["valorSalario"] = this.valorSalario;
        data["temBeneficioGoverno"] = this.temBeneficioGoverno;
        data["valorBeneficio"] = this.valorBeneficio;
        data["valorRendaFamiliar"] = this.valorRendaFamiliar;
        data["candidatoId"] = this.candidatoId;
        data["id"] = this.id;
        return data;
    }

    clone(): OnboardingCandidatoDto {
        const json = this.toJSON();
        let result = new OnboardingCandidatoDto();
        result.init(json);
        return result;
    }
}

export interface IOnboardingCandidatoDto {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;
    id: string;
}

export class CandidatoDto implements ICandidatoDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    userId: number;
    urlFotoPerfilDesbloqueado: string | undefined;
    curriculoDadoPessoal: CurriculoDadoPessoalDto;
    curriculoDadoPessoalAnexo: CurriculoDadoPessoalAnexoDto;
    creationTime: moment.Moment;
    quantidadePessoaFamilia: number;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    readonly rendaBrutaFamiliarString: string | undefined;
    beneficiarioSuzano: boolean;
    candidatosIdiomas: CandidatoIdiomaDto[] | undefined;
    curriculosExperiencias: CurriculoExperienciaDto[] | undefined;
    curriculosCompetencias: CurriculoCompetenciaDto[] | undefined;
    candidatosFormacoesAcademicas: CandidatoFormacaoAcademicaDto[] | undefined;
    curriculosSkillsConecta: CurriculoSkillConectaDto[] | undefined;
    tentativaCandidatarVaga: VagaDto;
    tentativaCandidatarVagaId: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    laudoMedico: LaudoMedicoDto;
    pcd: boolean;
    receberEmailNovaVaga: boolean;
    status: string[] | undefined;
    candidatosVagas: CandidaturaVagaDto[] | undefined;
    onboardingCandidato: OnboardingCandidatoDto;
    totalInscricoes: number;
    cadastradoPeloAdmin: boolean;
    naoPossuiEmail: boolean;
    id: string;

    constructor(data?: ICandidatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.urlFotoPerfilDesbloqueado = _data["urlFotoPerfilDesbloqueado"];
            this.curriculoDadoPessoal = _data["curriculoDadoPessoal"] ? CurriculoDadoPessoalDto.fromJS(_data["curriculoDadoPessoal"]) : <any>undefined;
            this.curriculoDadoPessoalAnexo = _data["curriculoDadoPessoalAnexo"] ? CurriculoDadoPessoalAnexoDto.fromJS(_data["curriculoDadoPessoalAnexo"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.quantidadePessoaFamilia = _data["quantidadePessoaFamilia"];
            this.rendaBrutaFamiliarEnum = _data["rendaBrutaFamiliarEnum"];
            (<any>this).rendaBrutaFamiliarString = _data["rendaBrutaFamiliarString"];
            this.beneficiarioSuzano = _data["beneficiarioSuzano"];
            if (Array.isArray(_data["candidatosIdiomas"])) {
                this.candidatosIdiomas = [] as any;
                for (let item of _data["candidatosIdiomas"])
                    this.candidatosIdiomas.push(CandidatoIdiomaDto.fromJS(item));
            }
            if (Array.isArray(_data["curriculosExperiencias"])) {
                this.curriculosExperiencias = [] as any;
                for (let item of _data["curriculosExperiencias"])
                    this.curriculosExperiencias.push(CurriculoExperienciaDto.fromJS(item));
            }
            if (Array.isArray(_data["curriculosCompetencias"])) {
                this.curriculosCompetencias = [] as any;
                for (let item of _data["curriculosCompetencias"])
                    this.curriculosCompetencias.push(CurriculoCompetenciaDto.fromJS(item));
            }
            if (Array.isArray(_data["candidatosFormacoesAcademicas"])) {
                this.candidatosFormacoesAcademicas = [] as any;
                for (let item of _data["candidatosFormacoesAcademicas"])
                    this.candidatosFormacoesAcademicas.push(CandidatoFormacaoAcademicaDto.fromJS(item));
            }
            if (Array.isArray(_data["curriculosSkillsConecta"])) {
                this.curriculosSkillsConecta = [] as any;
                for (let item of _data["curriculosSkillsConecta"])
                    this.curriculosSkillsConecta.push(CurriculoSkillConectaDto.fromJS(item));
            }
            this.tentativaCandidatarVaga = _data["tentativaCandidatarVaga"] ? VagaDto.fromJS(_data["tentativaCandidatarVaga"]) : <any>undefined;
            this.tentativaCandidatarVagaId = _data["tentativaCandidatarVagaId"];
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.laudoMedico = _data["laudoMedico"] ? LaudoMedicoDto.fromJS(_data["laudoMedico"]) : <any>undefined;
            this.pcd = _data["pcd"];
            this.receberEmailNovaVaga = _data["receberEmailNovaVaga"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status.push(item);
            }
            if (Array.isArray(_data["candidatosVagas"])) {
                this.candidatosVagas = [] as any;
                for (let item of _data["candidatosVagas"])
                    this.candidatosVagas.push(CandidaturaVagaDto.fromJS(item));
            }
            this.onboardingCandidato = _data["onboardingCandidato"] ? OnboardingCandidatoDto.fromJS(_data["onboardingCandidato"]) : <any>undefined;
            this.totalInscricoes = _data["totalInscricoes"];
            this.cadastradoPeloAdmin = _data["cadastradoPeloAdmin"];
            this.naoPossuiEmail = _data["naoPossuiEmail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["urlFotoPerfilDesbloqueado"] = this.urlFotoPerfilDesbloqueado;
        data["curriculoDadoPessoal"] = this.curriculoDadoPessoal ? this.curriculoDadoPessoal.toJSON() : <any>undefined;
        data["curriculoDadoPessoalAnexo"] = this.curriculoDadoPessoalAnexo ? this.curriculoDadoPessoalAnexo.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["quantidadePessoaFamilia"] = this.quantidadePessoaFamilia;
        data["rendaBrutaFamiliarEnum"] = this.rendaBrutaFamiliarEnum;
        data["rendaBrutaFamiliarString"] = this.rendaBrutaFamiliarString;
        data["beneficiarioSuzano"] = this.beneficiarioSuzano;
        if (Array.isArray(this.candidatosIdiomas)) {
            data["candidatosIdiomas"] = [];
            for (let item of this.candidatosIdiomas)
                data["candidatosIdiomas"].push(item.toJSON());
        }
        if (Array.isArray(this.curriculosExperiencias)) {
            data["curriculosExperiencias"] = [];
            for (let item of this.curriculosExperiencias)
                data["curriculosExperiencias"].push(item.toJSON());
        }
        if (Array.isArray(this.curriculosCompetencias)) {
            data["curriculosCompetencias"] = [];
            for (let item of this.curriculosCompetencias)
                data["curriculosCompetencias"].push(item.toJSON());
        }
        if (Array.isArray(this.candidatosFormacoesAcademicas)) {
            data["candidatosFormacoesAcademicas"] = [];
            for (let item of this.candidatosFormacoesAcademicas)
                data["candidatosFormacoesAcademicas"].push(item.toJSON());
        }
        if (Array.isArray(this.curriculosSkillsConecta)) {
            data["curriculosSkillsConecta"] = [];
            for (let item of this.curriculosSkillsConecta)
                data["curriculosSkillsConecta"].push(item.toJSON());
        }
        data["tentativaCandidatarVaga"] = this.tentativaCandidatarVaga ? this.tentativaCandidatarVaga.toJSON() : <any>undefined;
        data["tentativaCandidatarVagaId"] = this.tentativaCandidatarVagaId;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["laudoMedico"] = this.laudoMedico ? this.laudoMedico.toJSON() : <any>undefined;
        data["pcd"] = this.pcd;
        data["receberEmailNovaVaga"] = this.receberEmailNovaVaga;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.candidatosVagas)) {
            data["candidatosVagas"] = [];
            for (let item of this.candidatosVagas)
                data["candidatosVagas"].push(item.toJSON());
        }
        data["onboardingCandidato"] = this.onboardingCandidato ? this.onboardingCandidato.toJSON() : <any>undefined;
        data["totalInscricoes"] = this.totalInscricoes;
        data["cadastradoPeloAdmin"] = this.cadastradoPeloAdmin;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoDto {
        const json = this.toJSON();
        let result = new CandidatoDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    userId: number;
    urlFotoPerfilDesbloqueado: string | undefined;
    curriculoDadoPessoal: CurriculoDadoPessoalDto;
    curriculoDadoPessoalAnexo: CurriculoDadoPessoalAnexoDto;
    creationTime: moment.Moment;
    quantidadePessoaFamilia: number;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    rendaBrutaFamiliarString: string | undefined;
    beneficiarioSuzano: boolean;
    candidatosIdiomas: CandidatoIdiomaDto[] | undefined;
    curriculosExperiencias: CurriculoExperienciaDto[] | undefined;
    curriculosCompetencias: CurriculoCompetenciaDto[] | undefined;
    candidatosFormacoesAcademicas: CandidatoFormacaoAcademicaDto[] | undefined;
    curriculosSkillsConecta: CurriculoSkillConectaDto[] | undefined;
    tentativaCandidatarVaga: VagaDto;
    tentativaCandidatarVagaId: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    laudoMedico: LaudoMedicoDto;
    pcd: boolean;
    receberEmailNovaVaga: boolean;
    status: string[] | undefined;
    candidatosVagas: CandidaturaVagaDto[] | undefined;
    onboardingCandidato: OnboardingCandidatoDto;
    totalInscricoes: number;
    cadastradoPeloAdmin: boolean;
    naoPossuiEmail: boolean;
    id: string;
}

export class CreateCandidatoDto implements ICreateCandidatoDto {
    nome: string;
    cpf: string;
    email: string | undefined;
    telefone: string;
    senha: string;
    aceitouTermos: boolean;
    quantidadePessoaFamilia: number;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    beneficiarioSuzano: boolean;
    pcd: boolean;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    curriculoDadoPessoal: CurriculoDadoPessoalDto;
    naoPossuiEmail: boolean;

    constructor(data?: ICreateCandidatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.senha = _data["senha"];
            this.aceitouTermos = _data["aceitouTermos"];
            this.quantidadePessoaFamilia = _data["quantidadePessoaFamilia"];
            this.rendaBrutaFamiliarEnum = _data["rendaBrutaFamiliarEnum"];
            this.beneficiarioSuzano = _data["beneficiarioSuzano"];
            this.pcd = _data["pcd"];
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.curriculoDadoPessoal = _data["curriculoDadoPessoal"] ? CurriculoDadoPessoalDto.fromJS(_data["curriculoDadoPessoal"]) : <any>undefined;
            this.naoPossuiEmail = _data["naoPossuiEmail"];
        }
    }

    static fromJS(data: any): CreateCandidatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCandidatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["senha"] = this.senha;
        data["aceitouTermos"] = this.aceitouTermos;
        data["quantidadePessoaFamilia"] = this.quantidadePessoaFamilia;
        data["rendaBrutaFamiliarEnum"] = this.rendaBrutaFamiliarEnum;
        data["beneficiarioSuzano"] = this.beneficiarioSuzano;
        data["pcd"] = this.pcd;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["curriculoDadoPessoal"] = this.curriculoDadoPessoal ? this.curriculoDadoPessoal.toJSON() : <any>undefined;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        return data;
    }

    clone(): CreateCandidatoDto {
        const json = this.toJSON();
        let result = new CreateCandidatoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCandidatoDto {
    nome: string;
    cpf: string;
    email: string | undefined;
    telefone: string;
    senha: string;
    aceitouTermos: boolean;
    quantidadePessoaFamilia: number;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    beneficiarioSuzano: boolean;
    pcd: boolean;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    curriculoDadoPessoal: CurriculoDadoPessoalDto;
    naoPossuiEmail: boolean;
}

export class CreateCandidatoAdminDto implements ICreateCandidatoAdminDto {
    nome: string;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    senha: string | undefined;
    microrregiaoId: string;

    constructor(data?: ICreateCandidatoAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.senha = _data["senha"];
            this.microrregiaoId = _data["microrregiaoId"];
        }
    }

    static fromJS(data: any): CreateCandidatoAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCandidatoAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["senha"] = this.senha;
        data["microrregiaoId"] = this.microrregiaoId;
        return data;
    }

    clone(): CreateCandidatoAdminDto {
        const json = this.toJSON();
        let result = new CreateCandidatoAdminDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCandidatoAdminDto {
    nome: string;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    senha: string | undefined;
    microrregiaoId: string;
}

export class CandidatoDtoPagedResultDto implements ICandidatoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoDto[] | undefined;

    constructor(data?: ICandidatoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoDto[] | undefined;
}

export class UpdateLaudoMedicoDto implements IUpdateLaudoMedicoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;

    constructor(data?: IUpdateLaudoMedicoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.arquivoTipo = _data["arquivoTipo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateLaudoMedicoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLaudoMedicoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoBase64"] = this.arquivoBase64;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["arquivoTipo"] = this.arquivoTipo;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateLaudoMedicoDto {
        const json = this.toJSON();
        let result = new UpdateLaudoMedicoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateLaudoMedicoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;
}

export class UpdateCandidatoDto implements IUpdateCandidatoDto {
    nome: string;
    cpf: string;
    email: string | undefined;
    telefone: string;
    quantidadePessoaFamilia: number;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    beneficiarioSuzano: boolean;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    laudoMedico: UpdateLaudoMedicoDto;
    pcd: boolean;
    receberEmailNovaVaga: boolean;
    onboardingCandidato: OnboardingCandidatoDto;
    naoPossuiEmail: boolean;
    id: string;

    constructor(data?: IUpdateCandidatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.quantidadePessoaFamilia = _data["quantidadePessoaFamilia"];
            this.rendaBrutaFamiliarEnum = _data["rendaBrutaFamiliarEnum"];
            this.beneficiarioSuzano = _data["beneficiarioSuzano"];
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.laudoMedico = _data["laudoMedico"] ? UpdateLaudoMedicoDto.fromJS(_data["laudoMedico"]) : <any>undefined;
            this.pcd = _data["pcd"];
            this.receberEmailNovaVaga = _data["receberEmailNovaVaga"];
            this.onboardingCandidato = _data["onboardingCandidato"] ? OnboardingCandidatoDto.fromJS(_data["onboardingCandidato"]) : <any>undefined;
            this.naoPossuiEmail = _data["naoPossuiEmail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCandidatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCandidatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["quantidadePessoaFamilia"] = this.quantidadePessoaFamilia;
        data["rendaBrutaFamiliarEnum"] = this.rendaBrutaFamiliarEnum;
        data["beneficiarioSuzano"] = this.beneficiarioSuzano;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["laudoMedico"] = this.laudoMedico ? this.laudoMedico.toJSON() : <any>undefined;
        data["pcd"] = this.pcd;
        data["receberEmailNovaVaga"] = this.receberEmailNovaVaga;
        data["onboardingCandidato"] = this.onboardingCandidato ? this.onboardingCandidato.toJSON() : <any>undefined;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCandidatoDto {
        const json = this.toJSON();
        let result = new UpdateCandidatoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCandidatoDto {
    nome: string;
    cpf: string;
    email: string | undefined;
    telefone: string;
    quantidadePessoaFamilia: number;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    beneficiarioSuzano: boolean;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    laudoMedico: UpdateLaudoMedicoDto;
    pcd: boolean;
    receberEmailNovaVaga: boolean;
    onboardingCandidato: OnboardingCandidatoDto;
    naoPossuiEmail: boolean;
    id: string;
}

export class Endereco implements IEndereco {
    logradouro: string | undefined;
    bairro: string | undefined;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string;
    estado: string;
    microrregiaoId: string | undefined;
    curriculoId: string | undefined;
    valorEmpresaId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEndereco) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logradouro = _data["logradouro"];
            this.bairro = _data["bairro"];
            this.complemento = _data["complemento"];
            this.numero = _data["numero"];
            this.cep = _data["cep"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.curriculoId = _data["curriculoId"];
            this.valorEmpresaId = _data["valorEmpresaId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Endereco {
        data = typeof data === 'object' ? data : {};
        let result = new Endereco();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradouro"] = this.logradouro;
        data["bairro"] = this.bairro;
        data["complemento"] = this.complemento;
        data["numero"] = this.numero;
        data["cep"] = this.cep;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["microrregiaoId"] = this.microrregiaoId;
        data["curriculoId"] = this.curriculoId;
        data["valorEmpresaId"] = this.valorEmpresaId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Endereco {
        const json = this.toJSON();
        let result = new Endereco();
        result.init(json);
        return result;
    }
}

export interface IEndereco {
    logradouro: string | undefined;
    bairro: string | undefined;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string;
    estado: string;
    microrregiaoId: string | undefined;
    curriculoId: string | undefined;
    valorEmpresaId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Responsavel implements IResponsavel {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IResponsavel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Responsavel {
        data = typeof data === 'object' ? data : {};
        let result = new Responsavel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Responsavel {
        const json = this.toJSON();
        let result = new Responsavel();
        result.init(json);
        return result;
    }
}

export interface IResponsavel {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Cargo implements ICargo {
    nome: string;
    vagas: Vaga[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICargo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            if (Array.isArray(_data["vagas"])) {
                this.vagas = [] as any;
                for (let item of _data["vagas"])
                    this.vagas.push(Vaga.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Cargo {
        data = typeof data === 'object' ? data : {};
        let result = new Cargo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        if (Array.isArray(this.vagas)) {
            data["vagas"] = [];
            for (let item of this.vagas)
                data["vagas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Cargo {
        const json = this.toJSON();
        let result = new Cargo();
        result.init(json);
        return result;
    }
}

export interface ICargo {
    nome: string;
    vagas: Vaga[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CurriculoCompetencia implements ICurriculoCompetencia {
    candidato: Candidato;
    candidatoId: string;
    competencia: Competencia;
    competenciaId: string;
    nivelCompetencia: NivelCompetencia;
    readonly nivelCompetenciaString: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICurriculoCompetencia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.competencia = _data["competencia"] ? Competencia.fromJS(_data["competencia"]) : <any>undefined;
            this.competenciaId = _data["competenciaId"];
            this.nivelCompetencia = _data["nivelCompetencia"];
            (<any>this).nivelCompetenciaString = _data["nivelCompetenciaString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoCompetencia {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoCompetencia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["competencia"] = this.competencia ? this.competencia.toJSON() : <any>undefined;
        data["competenciaId"] = this.competenciaId;
        data["nivelCompetencia"] = this.nivelCompetencia;
        data["nivelCompetenciaString"] = this.nivelCompetenciaString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoCompetencia {
        const json = this.toJSON();
        let result = new CurriculoCompetencia();
        result.init(json);
        return result;
    }
}

export interface ICurriculoCompetencia {
    candidato: Candidato;
    candidatoId: string;
    competencia: Competencia;
    competenciaId: string;
    nivelCompetencia: NivelCompetencia;
    nivelCompetenciaString: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Competencia implements ICompetencia {
    nome: string;
    competenciasVagas: CompetenciaVaga[] | undefined;
    curriculosCompetencias: CurriculoCompetencia[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICompetencia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            if (Array.isArray(_data["competenciasVagas"])) {
                this.competenciasVagas = [] as any;
                for (let item of _data["competenciasVagas"])
                    this.competenciasVagas.push(CompetenciaVaga.fromJS(item));
            }
            if (Array.isArray(_data["curriculosCompetencias"])) {
                this.curriculosCompetencias = [] as any;
                for (let item of _data["curriculosCompetencias"])
                    this.curriculosCompetencias.push(CurriculoCompetencia.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Competencia {
        data = typeof data === 'object' ? data : {};
        let result = new Competencia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        if (Array.isArray(this.competenciasVagas)) {
            data["competenciasVagas"] = [];
            for (let item of this.competenciasVagas)
                data["competenciasVagas"].push(item.toJSON());
        }
        if (Array.isArray(this.curriculosCompetencias)) {
            data["curriculosCompetencias"] = [];
            for (let item of this.curriculosCompetencias)
                data["curriculosCompetencias"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Competencia {
        const json = this.toJSON();
        let result = new Competencia();
        result.init(json);
        return result;
    }
}

export interface ICompetencia {
    nome: string;
    competenciasVagas: CompetenciaVaga[] | undefined;
    curriculosCompetencias: CurriculoCompetencia[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CompetenciaVaga implements ICompetenciaVaga {
    vaga: Vaga;
    vagaId: string;
    competencia: Competencia;
    competenciaId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICompetenciaVaga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaga = _data["vaga"] ? Vaga.fromJS(_data["vaga"]) : <any>undefined;
            this.vagaId = _data["vagaId"];
            this.competencia = _data["competencia"] ? Competencia.fromJS(_data["competencia"]) : <any>undefined;
            this.competenciaId = _data["competenciaId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompetenciaVaga {
        data = typeof data === 'object' ? data : {};
        let result = new CompetenciaVaga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaga"] = this.vaga ? this.vaga.toJSON() : <any>undefined;
        data["vagaId"] = this.vagaId;
        data["competencia"] = this.competencia ? this.competencia.toJSON() : <any>undefined;
        data["competenciaId"] = this.competenciaId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CompetenciaVaga {
        const json = this.toJSON();
        let result = new CompetenciaVaga();
        result.init(json);
        return result;
    }
}

export interface ICompetenciaVaga {
    vaga: Vaga;
    vagaId: string;
    competencia: Competencia;
    competenciaId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CandidatoVagaAnotacao implements ICandidatoVagaAnotacao {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    texto: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICandidatoVagaAnotacao) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVaga = _data["candidatoVaga"] ? CandidatoVaga.fromJS(_data["candidatoVaga"]) : <any>undefined;
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.texto = _data["texto"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaAnotacao {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAnotacao();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVaga"] = this.candidatoVaga ? this.candidatoVaga.toJSON() : <any>undefined;
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["texto"] = this.texto;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaAnotacao {
        const json = this.toJSON();
        let result = new CandidatoVagaAnotacao();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAnotacao {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    texto: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CandidatoVagaAnexo implements ICandidatoVagaAnexo {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    documentoNome: string;
    arquivoNome: string;
    arquivoExtensao: string;
    arquivoUrl: string | undefined;
    arquivoUrlDesbloqueado: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICandidatoVagaAnexo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVaga = _data["candidatoVaga"] ? CandidatoVaga.fromJS(_data["candidatoVaga"]) : <any>undefined;
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.documentoNome = _data["documentoNome"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoUrlDesbloqueado = _data["arquivoUrlDesbloqueado"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaAnexo {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAnexo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVaga"] = this.candidatoVaga ? this.candidatoVaga.toJSON() : <any>undefined;
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["documentoNome"] = this.documentoNome;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoUrlDesbloqueado"] = this.arquivoUrlDesbloqueado;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaAnexo {
        const json = this.toJSON();
        let result = new CandidatoVagaAnexo();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAnexo {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    documentoNome: string;
    arquivoNome: string;
    arquivoExtensao: string;
    arquivoUrl: string | undefined;
    arquivoUrlDesbloqueado: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class HistoricoCandidatoVaga implements IHistoricoCandidatoVaga {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    estagioTriagem: EstagioTriagem;
    readonly estagioTriagemString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IHistoricoCandidatoVaga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVaga = _data["candidatoVaga"] ? CandidatoVaga.fromJS(_data["candidatoVaga"]) : <any>undefined;
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.estagioTriagem = _data["estagioTriagem"];
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HistoricoCandidatoVaga {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricoCandidatoVaga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVaga"] = this.candidatoVaga ? this.candidatoVaga.toJSON() : <any>undefined;
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["estagioTriagem"] = this.estagioTriagem;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): HistoricoCandidatoVaga {
        const json = this.toJSON();
        let result = new HistoricoCandidatoVaga();
        result.init(json);
        return result;
    }
}

export interface IHistoricoCandidatoVaga {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    estagioTriagem: EstagioTriagem;
    estagioTriagemString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RespostaAvaliacaoRequisito implements IRespostaAvaliacaoRequisito {
    resposta: string | undefined;
    avaliacaoRequisitoVaga: AvaliacaoRequisitoVaga;
    avaliacaoRequisitoVagaId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRespostaAvaliacaoRequisito) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resposta = _data["resposta"];
            this.avaliacaoRequisitoVaga = _data["avaliacaoRequisitoVaga"] ? AvaliacaoRequisitoVaga.fromJS(_data["avaliacaoRequisitoVaga"]) : <any>undefined;
            this.avaliacaoRequisitoVagaId = _data["avaliacaoRequisitoVagaId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RespostaAvaliacaoRequisito {
        data = typeof data === 'object' ? data : {};
        let result = new RespostaAvaliacaoRequisito();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resposta"] = this.resposta;
        data["avaliacaoRequisitoVaga"] = this.avaliacaoRequisitoVaga ? this.avaliacaoRequisitoVaga.toJSON() : <any>undefined;
        data["avaliacaoRequisitoVagaId"] = this.avaliacaoRequisitoVagaId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RespostaAvaliacaoRequisito {
        const json = this.toJSON();
        let result = new RespostaAvaliacaoRequisito();
        result.init(json);
        return result;
    }
}

export interface IRespostaAvaliacaoRequisito {
    resposta: string | undefined;
    avaliacaoRequisitoVaga: AvaliacaoRequisitoVaga;
    avaliacaoRequisitoVagaId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class AvaliacaoRequisitoVaga implements IAvaliacaoRequisitoVaga {
    vaga: Vaga;
    vagaId: string;
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisito[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAvaliacaoRequisitoVaga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaga = _data["vaga"] ? Vaga.fromJS(_data["vaga"]) : <any>undefined;
            this.vagaId = _data["vagaId"];
            this.avaliacao = _data["avaliacao"];
            if (Array.isArray(_data["possiveisRespostasAvaliacaoRequisito"])) {
                this.possiveisRespostasAvaliacaoRequisito = [] as any;
                for (let item of _data["possiveisRespostasAvaliacaoRequisito"])
                    this.possiveisRespostasAvaliacaoRequisito.push(RespostaAvaliacaoRequisito.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AvaliacaoRequisitoVaga {
        data = typeof data === 'object' ? data : {};
        let result = new AvaliacaoRequisitoVaga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaga"] = this.vaga ? this.vaga.toJSON() : <any>undefined;
        data["vagaId"] = this.vagaId;
        data["avaliacao"] = this.avaliacao;
        if (Array.isArray(this.possiveisRespostasAvaliacaoRequisito)) {
            data["possiveisRespostasAvaliacaoRequisito"] = [];
            for (let item of this.possiveisRespostasAvaliacaoRequisito)
                data["possiveisRespostasAvaliacaoRequisito"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): AvaliacaoRequisitoVaga {
        const json = this.toJSON();
        let result = new AvaliacaoRequisitoVaga();
        result.init(json);
        return result;
    }
}

export interface IAvaliacaoRequisitoVaga {
    vaga: Vaga;
    vagaId: string;
    avaliacao: string | undefined;
    possiveisRespostasAvaliacaoRequisito: RespostaAvaliacaoRequisito[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CandidatoVagaAvaliacaoRequisito implements ICandidatoVagaAvaliacaoRequisito {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    avaliacaoRequisitoVaga: AvaliacaoRequisitoVaga;
    avaliacaoRequisitoVagaId: string;
    respostaAvaliacaoRequisito: RespostaAvaliacaoRequisito;
    respostaAvaliacaoRequisitoId: string;
    id: string;

    constructor(data?: ICandidatoVagaAvaliacaoRequisito) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVaga = _data["candidatoVaga"] ? CandidatoVaga.fromJS(_data["candidatoVaga"]) : <any>undefined;
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.avaliacaoRequisitoVaga = _data["avaliacaoRequisitoVaga"] ? AvaliacaoRequisitoVaga.fromJS(_data["avaliacaoRequisitoVaga"]) : <any>undefined;
            this.avaliacaoRequisitoVagaId = _data["avaliacaoRequisitoVagaId"];
            this.respostaAvaliacaoRequisito = _data["respostaAvaliacaoRequisito"] ? RespostaAvaliacaoRequisito.fromJS(_data["respostaAvaliacaoRequisito"]) : <any>undefined;
            this.respostaAvaliacaoRequisitoId = _data["respostaAvaliacaoRequisitoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaAvaliacaoRequisito {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAvaliacaoRequisito();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVaga"] = this.candidatoVaga ? this.candidatoVaga.toJSON() : <any>undefined;
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["avaliacaoRequisitoVaga"] = this.avaliacaoRequisitoVaga ? this.avaliacaoRequisitoVaga.toJSON() : <any>undefined;
        data["avaliacaoRequisitoVagaId"] = this.avaliacaoRequisitoVagaId;
        data["respostaAvaliacaoRequisito"] = this.respostaAvaliacaoRequisito ? this.respostaAvaliacaoRequisito.toJSON() : <any>undefined;
        data["respostaAvaliacaoRequisitoId"] = this.respostaAvaliacaoRequisitoId;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaAvaliacaoRequisito {
        const json = this.toJSON();
        let result = new CandidatoVagaAvaliacaoRequisito();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAvaliacaoRequisito {
    candidatoVaga: CandidatoVaga;
    candidatoVagaId: string;
    avaliacaoRequisitoVaga: AvaliacaoRequisitoVaga;
    avaliacaoRequisitoVagaId: string;
    respostaAvaliacaoRequisito: RespostaAvaliacaoRequisito;
    respostaAvaliacaoRequisitoId: string;
    id: string;
}

export class CandidatoVaga implements ICandidatoVaga {
    vaga: Vaga;
    vagaId: string;
    candidato: Candidato;
    candidatoId: string;
    emailEntrevista: boolean;
    alertGestor: boolean;
    emailEncerramento: boolean;
    readonly estagioTriagemString: string | undefined;
    estagioTriagem: EstagioTriagem;
    selecionado: boolean;
    contratado: boolean;
    visualizado: boolean;
    favorito: boolean;
    candidatoVagaAnotacao: CandidatoVagaAnotacao;
    candidatoVagaAnexos: CandidatoVagaAnexo[] | undefined;
    historicoCandidatoVagas: HistoricoCandidatoVaga[] | undefined;
    candidatoVagaAvaliacoesRequisitos: CandidatoVagaAvaliacaoRequisito[] | undefined;
    estagioTriagemUltimaAtualizacao: moment.Moment | undefined;
    candidatoInformouContratacao: boolean;
    contratadoPeloAdmin: boolean;
    dataSelecaoCandidato: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICandidatoVaga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaga = _data["vaga"] ? Vaga.fromJS(_data["vaga"]) : <any>undefined;
            this.vagaId = _data["vagaId"];
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.emailEntrevista = _data["emailEntrevista"];
            this.alertGestor = _data["alertGestor"];
            this.emailEncerramento = _data["emailEncerramento"];
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.estagioTriagem = _data["estagioTriagem"];
            this.selecionado = _data["selecionado"];
            this.contratado = _data["contratado"];
            this.visualizado = _data["visualizado"];
            this.favorito = _data["favorito"];
            this.candidatoVagaAnotacao = _data["candidatoVagaAnotacao"] ? CandidatoVagaAnotacao.fromJS(_data["candidatoVagaAnotacao"]) : <any>undefined;
            if (Array.isArray(_data["candidatoVagaAnexos"])) {
                this.candidatoVagaAnexos = [] as any;
                for (let item of _data["candidatoVagaAnexos"])
                    this.candidatoVagaAnexos.push(CandidatoVagaAnexo.fromJS(item));
            }
            if (Array.isArray(_data["historicoCandidatoVagas"])) {
                this.historicoCandidatoVagas = [] as any;
                for (let item of _data["historicoCandidatoVagas"])
                    this.historicoCandidatoVagas.push(HistoricoCandidatoVaga.fromJS(item));
            }
            if (Array.isArray(_data["candidatoVagaAvaliacoesRequisitos"])) {
                this.candidatoVagaAvaliacoesRequisitos = [] as any;
                for (let item of _data["candidatoVagaAvaliacoesRequisitos"])
                    this.candidatoVagaAvaliacoesRequisitos.push(CandidatoVagaAvaliacaoRequisito.fromJS(item));
            }
            this.estagioTriagemUltimaAtualizacao = _data["estagioTriagemUltimaAtualizacao"] ? moment(_data["estagioTriagemUltimaAtualizacao"].toString()) : <any>undefined;
            this.candidatoInformouContratacao = _data["candidatoInformouContratacao"];
            this.contratadoPeloAdmin = _data["contratadoPeloAdmin"];
            this.dataSelecaoCandidato = _data["dataSelecaoCandidato"] ? moment(_data["dataSelecaoCandidato"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVaga {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVaga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaga"] = this.vaga ? this.vaga.toJSON() : <any>undefined;
        data["vagaId"] = this.vagaId;
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["emailEntrevista"] = this.emailEntrevista;
        data["alertGestor"] = this.alertGestor;
        data["emailEncerramento"] = this.emailEncerramento;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["estagioTriagem"] = this.estagioTriagem;
        data["selecionado"] = this.selecionado;
        data["contratado"] = this.contratado;
        data["visualizado"] = this.visualizado;
        data["favorito"] = this.favorito;
        data["candidatoVagaAnotacao"] = this.candidatoVagaAnotacao ? this.candidatoVagaAnotacao.toJSON() : <any>undefined;
        if (Array.isArray(this.candidatoVagaAnexos)) {
            data["candidatoVagaAnexos"] = [];
            for (let item of this.candidatoVagaAnexos)
                data["candidatoVagaAnexos"].push(item.toJSON());
        }
        if (Array.isArray(this.historicoCandidatoVagas)) {
            data["historicoCandidatoVagas"] = [];
            for (let item of this.historicoCandidatoVagas)
                data["historicoCandidatoVagas"].push(item.toJSON());
        }
        if (Array.isArray(this.candidatoVagaAvaliacoesRequisitos)) {
            data["candidatoVagaAvaliacoesRequisitos"] = [];
            for (let item of this.candidatoVagaAvaliacoesRequisitos)
                data["candidatoVagaAvaliacoesRequisitos"].push(item.toJSON());
        }
        data["estagioTriagemUltimaAtualizacao"] = this.estagioTriagemUltimaAtualizacao ? this.estagioTriagemUltimaAtualizacao.toISOString() : <any>undefined;
        data["candidatoInformouContratacao"] = this.candidatoInformouContratacao;
        data["contratadoPeloAdmin"] = this.contratadoPeloAdmin;
        data["dataSelecaoCandidato"] = this.dataSelecaoCandidato ? this.dataSelecaoCandidato.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVaga {
        const json = this.toJSON();
        let result = new CandidatoVaga();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVaga {
    vaga: Vaga;
    vagaId: string;
    candidato: Candidato;
    candidatoId: string;
    emailEntrevista: boolean;
    alertGestor: boolean;
    emailEncerramento: boolean;
    estagioTriagemString: string | undefined;
    estagioTriagem: EstagioTriagem;
    selecionado: boolean;
    contratado: boolean;
    visualizado: boolean;
    favorito: boolean;
    candidatoVagaAnotacao: CandidatoVagaAnotacao;
    candidatoVagaAnexos: CandidatoVagaAnexo[] | undefined;
    historicoCandidatoVagas: HistoricoCandidatoVaga[] | undefined;
    candidatoVagaAvaliacoesRequisitos: CandidatoVagaAvaliacaoRequisito[] | undefined;
    estagioTriagemUltimaAtualizacao: moment.Moment | undefined;
    candidatoInformouContratacao: boolean;
    contratadoPeloAdmin: boolean;
    dataSelecaoCandidato: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Vaga implements IVaga {
    empresa: Empresa;
    empresaId: string;
    tituloVaga: string | undefined;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    readonly regimeTrabalhoString: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargo: Cargo;
    cargoId: string | undefined;
    readonly modeloTrabalhoString: string | undefined;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    dataReabertura: moment.Moment | undefined;
    encerrada: boolean;
    motivoEncerramento: string | undefined;
    emailEncerramento: boolean;
    pcd: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasVagas: CompetenciaVaga[] | undefined;
    candidatosVagas: CandidatoVaga[] | undefined;
    emailEnviado: boolean;
    exibirSalario: boolean | undefined;
    urlVaga: string | undefined;
    vagaEspecial: boolean;
    statusVaga: StatusVaga;
    avaliacoesRequisitosVaga: AvaliacaoRequisitoVaga[] | undefined;
    readonly statusVagaString: string | undefined;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IVaga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresa = _data["empresa"] ? Empresa.fromJS(_data["empresa"]) : <any>undefined;
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            (<any>this).regimeTrabalhoString = _data["regimeTrabalhoString"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargo = _data["cargo"] ? Cargo.fromJS(_data["cargo"]) : <any>undefined;
            this.cargoId = _data["cargoId"];
            (<any>this).modeloTrabalhoString = _data["modeloTrabalhoString"];
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.exibirVagas = _data["exibirVagas"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.dataReabertura = _data["dataReabertura"] ? moment(_data["dataReabertura"].toString()) : <any>undefined;
            this.encerrada = _data["encerrada"];
            this.motivoEncerramento = _data["motivoEncerramento"];
            this.emailEncerramento = _data["emailEncerramento"];
            this.pcd = _data["pcd"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            if (Array.isArray(_data["competenciasVagas"])) {
                this.competenciasVagas = [] as any;
                for (let item of _data["competenciasVagas"])
                    this.competenciasVagas.push(CompetenciaVaga.fromJS(item));
            }
            if (Array.isArray(_data["candidatosVagas"])) {
                this.candidatosVagas = [] as any;
                for (let item of _data["candidatosVagas"])
                    this.candidatosVagas.push(CandidatoVaga.fromJS(item));
            }
            this.emailEnviado = _data["emailEnviado"];
            this.exibirSalario = _data["exibirSalario"];
            this.urlVaga = _data["urlVaga"];
            this.vagaEspecial = _data["vagaEspecial"];
            this.statusVaga = _data["statusVaga"];
            if (Array.isArray(_data["avaliacoesRequisitosVaga"])) {
                this.avaliacoesRequisitosVaga = [] as any;
                for (let item of _data["avaliacoesRequisitosVaga"])
                    this.avaliacoesRequisitosVaga.push(AvaliacaoRequisitoVaga.fromJS(item));
            }
            (<any>this).statusVagaString = _data["statusVagaString"];
            this.statusVagaUltimaAtualizacao = _data["statusVagaUltimaAtualizacao"] ? moment(_data["statusVagaUltimaAtualizacao"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Vaga {
        data = typeof data === 'object' ? data : {};
        let result = new Vaga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresa"] = this.empresa ? this.empresa.toJSON() : <any>undefined;
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalhoString"] = this.regimeTrabalhoString;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["cargoId"] = this.cargoId;
        data["modeloTrabalhoString"] = this.modeloTrabalhoString;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["exibirVagas"] = this.exibirVagas;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["dataReabertura"] = this.dataReabertura ? this.dataReabertura.toISOString() : <any>undefined;
        data["encerrada"] = this.encerrada;
        data["motivoEncerramento"] = this.motivoEncerramento;
        data["emailEncerramento"] = this.emailEncerramento;
        data["pcd"] = this.pcd;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        if (Array.isArray(this.competenciasVagas)) {
            data["competenciasVagas"] = [];
            for (let item of this.competenciasVagas)
                data["competenciasVagas"].push(item.toJSON());
        }
        if (Array.isArray(this.candidatosVagas)) {
            data["candidatosVagas"] = [];
            for (let item of this.candidatosVagas)
                data["candidatosVagas"].push(item.toJSON());
        }
        data["emailEnviado"] = this.emailEnviado;
        data["exibirSalario"] = this.exibirSalario;
        data["urlVaga"] = this.urlVaga;
        data["vagaEspecial"] = this.vagaEspecial;
        data["statusVaga"] = this.statusVaga;
        if (Array.isArray(this.avaliacoesRequisitosVaga)) {
            data["avaliacoesRequisitosVaga"] = [];
            for (let item of this.avaliacoesRequisitosVaga)
                data["avaliacoesRequisitosVaga"].push(item.toJSON());
        }
        data["statusVagaString"] = this.statusVagaString;
        data["statusVagaUltimaAtualizacao"] = this.statusVagaUltimaAtualizacao ? this.statusVagaUltimaAtualizacao.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Vaga {
        const json = this.toJSON();
        let result = new Vaga();
        result.init(json);
        return result;
    }
}

export interface IVaga {
    empresa: Empresa;
    empresaId: string;
    tituloVaga: string | undefined;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalhoString: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargo: Cargo;
    cargoId: string | undefined;
    modeloTrabalhoString: string | undefined;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    dataReabertura: moment.Moment | undefined;
    encerrada: boolean;
    motivoEncerramento: string | undefined;
    emailEncerramento: boolean;
    pcd: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasVagas: CompetenciaVaga[] | undefined;
    candidatosVagas: CandidatoVaga[] | undefined;
    emailEnviado: boolean;
    exibirSalario: boolean | undefined;
    urlVaga: string | undefined;
    vagaEspecial: boolean;
    statusVaga: StatusVaga;
    avaliacoesRequisitosVaga: AvaliacaoRequisitoVaga[] | undefined;
    statusVagaString: string | undefined;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Empresa implements IEmpresa {
    user: User;
    userId: number;
    enderecoId: string | undefined;
    endereco: Endereco;
    idResponsavel: string | undefined;
    responsavel: Responsavel;
    razaoSocial: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    nome: string | undefined;
    cnpj: string | undefined;
    urlFotoPerfil: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;
    readonly areaAtuacaoEmpresaString: string | undefined;
    vagas: Vaga[] | undefined;
    enviarEmailNovoInscrito: boolean;
    empresaEspecial: boolean;
    nomeUsuario: string | undefined;
    dataUltimaExibicaoLembreteVagasInativas: moment.Moment | undefined;
    dataUltimoEmailVagasInativas: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEmpresa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.enderecoId = _data["enderecoId"];
            this.endereco = _data["endereco"] ? Endereco.fromJS(_data["endereco"]) : <any>undefined;
            this.idResponsavel = _data["idResponsavel"];
            this.responsavel = _data["responsavel"] ? Responsavel.fromJS(_data["responsavel"]) : <any>undefined;
            this.razaoSocial = _data["razaoSocial"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.nome = _data["nome"];
            this.cnpj = _data["cnpj"];
            this.urlFotoPerfil = _data["urlFotoPerfil"];
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.prestadoraServicoSuzano = _data["prestadoraServicoSuzano"];
            this.areaAtuacaoEmpresaEnum = _data["areaAtuacaoEmpresaEnum"];
            (<any>this).areaAtuacaoEmpresaString = _data["areaAtuacaoEmpresaString"];
            if (Array.isArray(_data["vagas"])) {
                this.vagas = [] as any;
                for (let item of _data["vagas"])
                    this.vagas.push(Vaga.fromJS(item));
            }
            this.enviarEmailNovoInscrito = _data["enviarEmailNovoInscrito"];
            this.empresaEspecial = _data["empresaEspecial"];
            this.nomeUsuario = _data["nomeUsuario"];
            this.dataUltimaExibicaoLembreteVagasInativas = _data["dataUltimaExibicaoLembreteVagasInativas"] ? moment(_data["dataUltimaExibicaoLembreteVagasInativas"].toString()) : <any>undefined;
            this.dataUltimoEmailVagasInativas = _data["dataUltimoEmailVagasInativas"] ? moment(_data["dataUltimoEmailVagasInativas"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Empresa {
        data = typeof data === 'object' ? data : {};
        let result = new Empresa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["enderecoId"] = this.enderecoId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["idResponsavel"] = this.idResponsavel;
        data["responsavel"] = this.responsavel ? this.responsavel.toJSON() : <any>undefined;
        data["razaoSocial"] = this.razaoSocial;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["nome"] = this.nome;
        data["cnpj"] = this.cnpj;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["prestadoraServicoSuzano"] = this.prestadoraServicoSuzano;
        data["areaAtuacaoEmpresaEnum"] = this.areaAtuacaoEmpresaEnum;
        data["areaAtuacaoEmpresaString"] = this.areaAtuacaoEmpresaString;
        if (Array.isArray(this.vagas)) {
            data["vagas"] = [];
            for (let item of this.vagas)
                data["vagas"].push(item.toJSON());
        }
        data["enviarEmailNovoInscrito"] = this.enviarEmailNovoInscrito;
        data["empresaEspecial"] = this.empresaEspecial;
        data["nomeUsuario"] = this.nomeUsuario;
        data["dataUltimaExibicaoLembreteVagasInativas"] = this.dataUltimaExibicaoLembreteVagasInativas ? this.dataUltimaExibicaoLembreteVagasInativas.toISOString() : <any>undefined;
        data["dataUltimoEmailVagasInativas"] = this.dataUltimoEmailVagasInativas ? this.dataUltimoEmailVagasInativas.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Empresa {
        const json = this.toJSON();
        let result = new Empresa();
        result.init(json);
        return result;
    }
}

export interface IEmpresa {
    user: User;
    userId: number;
    enderecoId: string | undefined;
    endereco: Endereco;
    idResponsavel: string | undefined;
    responsavel: Responsavel;
    razaoSocial: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    nome: string | undefined;
    cnpj: string | undefined;
    urlFotoPerfil: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;
    areaAtuacaoEmpresaString: string | undefined;
    vagas: Vaga[] | undefined;
    enviarEmailNovoInscrito: boolean;
    empresaEspecial: boolean;
    nomeUsuario: string | undefined;
    dataUltimaExibicaoLembreteVagasInativas: moment.Moment | undefined;
    dataUltimoEmailVagasInativas: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    empresa: Empresa;
    candidato: Candidato;
    passwordResetCodeExpireDate: moment.Moment | undefined;
    name: string;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresa = _data["empresa"] ? Empresa.fromJS(_data["empresa"]) : <any>undefined;
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.passwordResetCodeExpireDate = _data["passwordResetCodeExpireDate"] ? moment(_data["passwordResetCodeExpireDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresa"] = this.empresa ? this.empresa.toJSON() : <any>undefined;
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["passwordResetCodeExpireDate"] = this.passwordResetCodeExpireDate ? this.passwordResetCodeExpireDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    empresa: Empresa;
    candidato: Candidato;
    passwordResetCodeExpireDate: moment.Moment | undefined;
    name: string;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CurriculoDadoPessoalAnexo implements ICurriculoDadoPessoalAnexo {
    candidato: Candidato;
    candidatoId: string;
    arquivoNome: string;
    arquivoExtensao: string;
    arquivoUrl: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICurriculoDadoPessoalAnexo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoDadoPessoalAnexo {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoDadoPessoalAnexo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoDadoPessoalAnexo {
        const json = this.toJSON();
        let result = new CurriculoDadoPessoalAnexo();
        result.init(json);
        return result;
    }
}

export interface ICurriculoDadoPessoalAnexo {
    candidato: Candidato;
    candidatoId: string;
    arquivoNome: string;
    arquivoExtensao: string;
    arquivoUrl: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CurriculoExperiencia implements ICurriculoExperiencia {
    candidato: Candidato;
    candidatoId: string;
    titulo: string;
    tipoEmprego: TipoEmprego;
    readonly tipoEmpregoString: string;
    nomeEmpresa: string;
    cidade: string;
    uf: string;
    descricao: string | undefined;
    trabalhaAtualmente: boolean;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    naoLembraData: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICurriculoExperiencia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.titulo = _data["titulo"];
            this.tipoEmprego = _data["tipoEmprego"];
            (<any>this).tipoEmpregoString = _data["tipoEmpregoString"];
            this.nomeEmpresa = _data["nomeEmpresa"];
            this.cidade = _data["cidade"];
            this.uf = _data["uf"];
            this.descricao = _data["descricao"];
            this.trabalhaAtualmente = _data["trabalhaAtualmente"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.naoLembraData = _data["naoLembraData"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoExperiencia {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoExperiencia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["titulo"] = this.titulo;
        data["tipoEmprego"] = this.tipoEmprego;
        data["tipoEmpregoString"] = this.tipoEmpregoString;
        data["nomeEmpresa"] = this.nomeEmpresa;
        data["cidade"] = this.cidade;
        data["uf"] = this.uf;
        data["descricao"] = this.descricao;
        data["trabalhaAtualmente"] = this.trabalhaAtualmente;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["naoLembraData"] = this.naoLembraData;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoExperiencia {
        const json = this.toJSON();
        let result = new CurriculoExperiencia();
        result.init(json);
        return result;
    }
}

export interface ICurriculoExperiencia {
    candidato: Candidato;
    candidatoId: string;
    titulo: string;
    tipoEmprego: TipoEmprego;
    tipoEmpregoString: string;
    nomeEmpresa: string;
    cidade: string;
    uf: string;
    descricao: string | undefined;
    trabalhaAtualmente: boolean;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    naoLembraData: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Idioma implements IIdioma {
    nome: string;
    candidatosIdiomas: CandidatoIdioma[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IIdioma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            if (Array.isArray(_data["candidatosIdiomas"])) {
                this.candidatosIdiomas = [] as any;
                for (let item of _data["candidatosIdiomas"])
                    this.candidatosIdiomas.push(CandidatoIdioma.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Idioma {
        data = typeof data === 'object' ? data : {};
        let result = new Idioma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        if (Array.isArray(this.candidatosIdiomas)) {
            data["candidatosIdiomas"] = [];
            for (let item of this.candidatosIdiomas)
                data["candidatosIdiomas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Idioma {
        const json = this.toJSON();
        let result = new Idioma();
        result.init(json);
        return result;
    }
}

export interface IIdioma {
    nome: string;
    candidatosIdiomas: CandidatoIdioma[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CandidatoIdioma implements ICandidatoIdioma {
    candidato: Candidato;
    candidatoId: string;
    idioma: Idioma;
    idiomaId: string;
    nivelIdioma: NivelIdioma;
    readonly nivelIdiomaString: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICandidatoIdioma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.idioma = _data["idioma"] ? Idioma.fromJS(_data["idioma"]) : <any>undefined;
            this.idiomaId = _data["idiomaId"];
            this.nivelIdioma = _data["nivelIdioma"];
            (<any>this).nivelIdiomaString = _data["nivelIdiomaString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoIdioma {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoIdioma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["idioma"] = this.idioma ? this.idioma.toJSON() : <any>undefined;
        data["idiomaId"] = this.idiomaId;
        data["nivelIdioma"] = this.nivelIdioma;
        data["nivelIdiomaString"] = this.nivelIdiomaString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoIdioma {
        const json = this.toJSON();
        let result = new CandidatoIdioma();
        result.init(json);
        return result;
    }
}

export interface ICandidatoIdioma {
    candidato: Candidato;
    candidatoId: string;
    idioma: Idioma;
    idiomaId: string;
    nivelIdioma: NivelIdioma;
    nivelIdiomaString: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CandidatoFormacaoAcademica implements ICandidatoFormacaoAcademica {
    candidato: Candidato;
    candidatoId: string;
    nomeInstituicao: string;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICandidatoFormacaoAcademica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.nomeInstituicao = _data["nomeInstituicao"];
            this.nomeCurso = _data["nomeCurso"];
            this.grau = _data["grau"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.naoLembraData = _data["naoLembraData"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoFormacaoAcademica {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoFormacaoAcademica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["nomeInstituicao"] = this.nomeInstituicao;
        data["nomeCurso"] = this.nomeCurso;
        data["grau"] = this.grau;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["naoLembraData"] = this.naoLembraData;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoFormacaoAcademica {
        const json = this.toJSON();
        let result = new CandidatoFormacaoAcademica();
        result.init(json);
        return result;
    }
}

export interface ICandidatoFormacaoAcademica {
    candidato: Candidato;
    candidatoId: string;
    nomeInstituicao: string;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class SkillConecta implements ISkillConecta {
    nome: string;
    curriculosSkillsConecta: CurriculoSkillConecta[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ISkillConecta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            if (Array.isArray(_data["curriculosSkillsConecta"])) {
                this.curriculosSkillsConecta = [] as any;
                for (let item of _data["curriculosSkillsConecta"])
                    this.curriculosSkillsConecta.push(CurriculoSkillConecta.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SkillConecta {
        data = typeof data === 'object' ? data : {};
        let result = new SkillConecta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        if (Array.isArray(this.curriculosSkillsConecta)) {
            data["curriculosSkillsConecta"] = [];
            for (let item of this.curriculosSkillsConecta)
                data["curriculosSkillsConecta"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): SkillConecta {
        const json = this.toJSON();
        let result = new SkillConecta();
        result.init(json);
        return result;
    }
}

export interface ISkillConecta {
    nome: string;
    curriculosSkillsConecta: CurriculoSkillConecta[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CurriculoSkillConecta implements ICurriculoSkillConecta {
    candidato: Candidato;
    candidatoId: string;
    skillConecta: SkillConecta;
    skillConectaId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICurriculoSkillConecta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.skillConecta = _data["skillConecta"] ? SkillConecta.fromJS(_data["skillConecta"]) : <any>undefined;
            this.skillConectaId = _data["skillConectaId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoSkillConecta {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoSkillConecta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["skillConecta"] = this.skillConecta ? this.skillConecta.toJSON() : <any>undefined;
        data["skillConectaId"] = this.skillConectaId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoSkillConecta {
        const json = this.toJSON();
        let result = new CurriculoSkillConecta();
        result.init(json);
        return result;
    }
}

export interface ICurriculoSkillConecta {
    candidato: Candidato;
    candidatoId: string;
    skillConecta: SkillConecta;
    skillConectaId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class LaudoMedico implements ILaudoMedico {
    candidato: Candidato;
    candidatoId: string;
    arquivoNome: string;
    arquivoExtensao: string;
    arquivoUrl: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ILaudoMedico) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaudoMedico {
        data = typeof data === 'object' ? data : {};
        let result = new LaudoMedico();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): LaudoMedico {
        const json = this.toJSON();
        let result = new LaudoMedico();
        result.init(json);
        return result;
    }
}

export interface ILaudoMedico {
    candidato: Candidato;
    candidatoId: string;
    arquivoNome: string;
    arquivoExtensao: string;
    arquivoUrl: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class OnboardingCandidato implements IOnboardingCandidato {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;
    candidato: Candidato;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IOnboardingCandidato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temSalarioOuRenda = _data["temSalarioOuRenda"];
            this.valorSalario = _data["valorSalario"];
            this.temBeneficioGoverno = _data["temBeneficioGoverno"];
            this.valorBeneficio = _data["valorBeneficio"];
            this.valorRendaFamiliar = _data["valorRendaFamiliar"];
            this.candidatoId = _data["candidatoId"];
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OnboardingCandidato {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingCandidato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temSalarioOuRenda"] = this.temSalarioOuRenda;
        data["valorSalario"] = this.valorSalario;
        data["temBeneficioGoverno"] = this.temBeneficioGoverno;
        data["valorBeneficio"] = this.valorBeneficio;
        data["valorRendaFamiliar"] = this.valorRendaFamiliar;
        data["candidatoId"] = this.candidatoId;
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): OnboardingCandidato {
        const json = this.toJSON();
        let result = new OnboardingCandidato();
        result.init(json);
        return result;
    }
}

export interface IOnboardingCandidato {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;
    candidato: Candidato;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Candidato implements ICandidato {
    user: User;
    userId: number;
    nome: string;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    quantidadePessoaFamilia: number | undefined;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    readonly rendaBrutaFamiliarString: string | undefined;
    beneficiarioSuzano: boolean;
    candidatosVagas: CandidatoVaga[] | undefined;
    curriculoDadoPessoal: CurriculoDadoPessoal;
    curriculoDadoPessoalAnexo: CurriculoDadoPessoalAnexo;
    curriculosExperiencias: CurriculoExperiencia[] | undefined;
    curriculosCompetencias: CurriculoCompetencia[] | undefined;
    candidatosIdiomas: CandidatoIdioma[] | undefined;
    candidatosFormacoesAcademicas: CandidatoFormacaoAcademica[] | undefined;
    curriculosSkillsConecta: CurriculoSkillConecta[] | undefined;
    tentativaCandidatarVaga: Vaga;
    tentativaCandidatarVagaId: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    laudoMedico: LaudoMedico;
    pcd: boolean;
    receberEmailNovaVaga: boolean;
    onboardingCandidato: OnboardingCandidato;
    dataUltimaExibicaoLembreteVagasInativas: moment.Moment | undefined;
    dataUltimaEmailLembreteVagasInativas: moment.Moment | undefined;
    readonly totalInscricoes: number;
    cadastradoPeloAdmin: boolean;
    naoPossuiEmail: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICandidato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.quantidadePessoaFamilia = _data["quantidadePessoaFamilia"];
            this.rendaBrutaFamiliarEnum = _data["rendaBrutaFamiliarEnum"];
            (<any>this).rendaBrutaFamiliarString = _data["rendaBrutaFamiliarString"];
            this.beneficiarioSuzano = _data["beneficiarioSuzano"];
            if (Array.isArray(_data["candidatosVagas"])) {
                this.candidatosVagas = [] as any;
                for (let item of _data["candidatosVagas"])
                    this.candidatosVagas.push(CandidatoVaga.fromJS(item));
            }
            this.curriculoDadoPessoal = _data["curriculoDadoPessoal"] ? CurriculoDadoPessoal.fromJS(_data["curriculoDadoPessoal"]) : <any>undefined;
            this.curriculoDadoPessoalAnexo = _data["curriculoDadoPessoalAnexo"] ? CurriculoDadoPessoalAnexo.fromJS(_data["curriculoDadoPessoalAnexo"]) : <any>undefined;
            if (Array.isArray(_data["curriculosExperiencias"])) {
                this.curriculosExperiencias = [] as any;
                for (let item of _data["curriculosExperiencias"])
                    this.curriculosExperiencias.push(CurriculoExperiencia.fromJS(item));
            }
            if (Array.isArray(_data["curriculosCompetencias"])) {
                this.curriculosCompetencias = [] as any;
                for (let item of _data["curriculosCompetencias"])
                    this.curriculosCompetencias.push(CurriculoCompetencia.fromJS(item));
            }
            if (Array.isArray(_data["candidatosIdiomas"])) {
                this.candidatosIdiomas = [] as any;
                for (let item of _data["candidatosIdiomas"])
                    this.candidatosIdiomas.push(CandidatoIdioma.fromJS(item));
            }
            if (Array.isArray(_data["candidatosFormacoesAcademicas"])) {
                this.candidatosFormacoesAcademicas = [] as any;
                for (let item of _data["candidatosFormacoesAcademicas"])
                    this.candidatosFormacoesAcademicas.push(CandidatoFormacaoAcademica.fromJS(item));
            }
            if (Array.isArray(_data["curriculosSkillsConecta"])) {
                this.curriculosSkillsConecta = [] as any;
                for (let item of _data["curriculosSkillsConecta"])
                    this.curriculosSkillsConecta.push(CurriculoSkillConecta.fromJS(item));
            }
            this.tentativaCandidatarVaga = _data["tentativaCandidatarVaga"] ? Vaga.fromJS(_data["tentativaCandidatarVaga"]) : <any>undefined;
            this.tentativaCandidatarVagaId = _data["tentativaCandidatarVagaId"];
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.laudoMedico = _data["laudoMedico"] ? LaudoMedico.fromJS(_data["laudoMedico"]) : <any>undefined;
            this.pcd = _data["pcd"];
            this.receberEmailNovaVaga = _data["receberEmailNovaVaga"];
            this.onboardingCandidato = _data["onboardingCandidato"] ? OnboardingCandidato.fromJS(_data["onboardingCandidato"]) : <any>undefined;
            this.dataUltimaExibicaoLembreteVagasInativas = _data["dataUltimaExibicaoLembreteVagasInativas"] ? moment(_data["dataUltimaExibicaoLembreteVagasInativas"].toString()) : <any>undefined;
            this.dataUltimaEmailLembreteVagasInativas = _data["dataUltimaEmailLembreteVagasInativas"] ? moment(_data["dataUltimaEmailLembreteVagasInativas"].toString()) : <any>undefined;
            (<any>this).totalInscricoes = _data["totalInscricoes"];
            this.cadastradoPeloAdmin = _data["cadastradoPeloAdmin"];
            this.naoPossuiEmail = _data["naoPossuiEmail"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Candidato {
        data = typeof data === 'object' ? data : {};
        let result = new Candidato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["quantidadePessoaFamilia"] = this.quantidadePessoaFamilia;
        data["rendaBrutaFamiliarEnum"] = this.rendaBrutaFamiliarEnum;
        data["rendaBrutaFamiliarString"] = this.rendaBrutaFamiliarString;
        data["beneficiarioSuzano"] = this.beneficiarioSuzano;
        if (Array.isArray(this.candidatosVagas)) {
            data["candidatosVagas"] = [];
            for (let item of this.candidatosVagas)
                data["candidatosVagas"].push(item.toJSON());
        }
        data["curriculoDadoPessoal"] = this.curriculoDadoPessoal ? this.curriculoDadoPessoal.toJSON() : <any>undefined;
        data["curriculoDadoPessoalAnexo"] = this.curriculoDadoPessoalAnexo ? this.curriculoDadoPessoalAnexo.toJSON() : <any>undefined;
        if (Array.isArray(this.curriculosExperiencias)) {
            data["curriculosExperiencias"] = [];
            for (let item of this.curriculosExperiencias)
                data["curriculosExperiencias"].push(item.toJSON());
        }
        if (Array.isArray(this.curriculosCompetencias)) {
            data["curriculosCompetencias"] = [];
            for (let item of this.curriculosCompetencias)
                data["curriculosCompetencias"].push(item.toJSON());
        }
        if (Array.isArray(this.candidatosIdiomas)) {
            data["candidatosIdiomas"] = [];
            for (let item of this.candidatosIdiomas)
                data["candidatosIdiomas"].push(item.toJSON());
        }
        if (Array.isArray(this.candidatosFormacoesAcademicas)) {
            data["candidatosFormacoesAcademicas"] = [];
            for (let item of this.candidatosFormacoesAcademicas)
                data["candidatosFormacoesAcademicas"].push(item.toJSON());
        }
        if (Array.isArray(this.curriculosSkillsConecta)) {
            data["curriculosSkillsConecta"] = [];
            for (let item of this.curriculosSkillsConecta)
                data["curriculosSkillsConecta"].push(item.toJSON());
        }
        data["tentativaCandidatarVaga"] = this.tentativaCandidatarVaga ? this.tentativaCandidatarVaga.toJSON() : <any>undefined;
        data["tentativaCandidatarVagaId"] = this.tentativaCandidatarVagaId;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["laudoMedico"] = this.laudoMedico ? this.laudoMedico.toJSON() : <any>undefined;
        data["pcd"] = this.pcd;
        data["receberEmailNovaVaga"] = this.receberEmailNovaVaga;
        data["onboardingCandidato"] = this.onboardingCandidato ? this.onboardingCandidato.toJSON() : <any>undefined;
        data["dataUltimaExibicaoLembreteVagasInativas"] = this.dataUltimaExibicaoLembreteVagasInativas ? this.dataUltimaExibicaoLembreteVagasInativas.toISOString() : <any>undefined;
        data["dataUltimaEmailLembreteVagasInativas"] = this.dataUltimaEmailLembreteVagasInativas ? this.dataUltimaEmailLembreteVagasInativas.toISOString() : <any>undefined;
        data["totalInscricoes"] = this.totalInscricoes;
        data["cadastradoPeloAdmin"] = this.cadastradoPeloAdmin;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Candidato {
        const json = this.toJSON();
        let result = new Candidato();
        result.init(json);
        return result;
    }
}

export interface ICandidato {
    user: User;
    userId: number;
    nome: string;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    quantidadePessoaFamilia: number | undefined;
    rendaBrutaFamiliarEnum: RendaBrutaFamiliarEnum;
    rendaBrutaFamiliarString: string | undefined;
    beneficiarioSuzano: boolean;
    candidatosVagas: CandidatoVaga[] | undefined;
    curriculoDadoPessoal: CurriculoDadoPessoal;
    curriculoDadoPessoalAnexo: CurriculoDadoPessoalAnexo;
    curriculosExperiencias: CurriculoExperiencia[] | undefined;
    curriculosCompetencias: CurriculoCompetencia[] | undefined;
    candidatosIdiomas: CandidatoIdioma[] | undefined;
    candidatosFormacoesAcademicas: CandidatoFormacaoAcademica[] | undefined;
    curriculosSkillsConecta: CurriculoSkillConecta[] | undefined;
    tentativaCandidatarVaga: Vaga;
    tentativaCandidatarVagaId: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    laudoMedico: LaudoMedico;
    pcd: boolean;
    receberEmailNovaVaga: boolean;
    onboardingCandidato: OnboardingCandidato;
    dataUltimaExibicaoLembreteVagasInativas: moment.Moment | undefined;
    dataUltimaEmailLembreteVagasInativas: moment.Moment | undefined;
    totalInscricoes: number;
    cadastradoPeloAdmin: boolean;
    naoPossuiEmail: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Comunidade implements IComunidade {
    nome: string;
    candidatosCurriculoDadoPessoais: CurriculoDadoPessoal[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IComunidade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            if (Array.isArray(_data["candidatosCurriculoDadoPessoais"])) {
                this.candidatosCurriculoDadoPessoais = [] as any;
                for (let item of _data["candidatosCurriculoDadoPessoais"])
                    this.candidatosCurriculoDadoPessoais.push(CurriculoDadoPessoal.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Comunidade {
        data = typeof data === 'object' ? data : {};
        let result = new Comunidade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        if (Array.isArray(this.candidatosCurriculoDadoPessoais)) {
            data["candidatosCurriculoDadoPessoais"] = [];
            for (let item of this.candidatosCurriculoDadoPessoais)
                data["candidatosCurriculoDadoPessoais"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Comunidade {
        const json = this.toJSON();
        let result = new Comunidade();
        result.init(json);
        return result;
    }
}

export interface IComunidade {
    nome: string;
    candidatosCurriculoDadoPessoais: CurriculoDadoPessoal[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CurriculoDadoPessoal implements ICurriculoDadoPessoal {
    candidato: Candidato;
    candidatoId: string;
    nome: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    genero: Genero;
    readonly generoString: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    telefone: string | undefined;
    enderecoId: string | undefined;
    endereco: Endereco;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    comunidadeId: string | undefined;
    comunidade: Comunidade;
    corRaca: CorRacaEnum;
    readonly corRacaString: string | undefined;
    naoPossuiEmail: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICurriculoDadoPessoal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidato = _data["candidato"] ? Candidato.fromJS(_data["candidato"]) : <any>undefined;
            this.candidatoId = _data["candidatoId"];
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.rg = _data["rg"];
            this.genero = _data["genero"];
            (<any>this).generoString = _data["generoString"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.enderecoId = _data["enderecoId"];
            this.endereco = _data["endereco"] ? Endereco.fromJS(_data["endereco"]) : <any>undefined;
            this.fotoNome = _data["fotoNome"];
            this.fotoExtensao = _data["fotoExtensao"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.comunidadeId = _data["comunidadeId"];
            this.comunidade = _data["comunidade"] ? Comunidade.fromJS(_data["comunidade"]) : <any>undefined;
            this.corRaca = _data["corRaca"];
            (<any>this).corRacaString = _data["corRacaString"];
            this.naoPossuiEmail = _data["naoPossuiEmail"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurriculoDadoPessoal {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoDadoPessoal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["candidatoId"] = this.candidatoId;
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["rg"] = this.rg;
        data["genero"] = this.genero;
        data["generoString"] = this.generoString;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["enderecoId"] = this.enderecoId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["fotoNome"] = this.fotoNome;
        data["fotoExtensao"] = this.fotoExtensao;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["comunidadeId"] = this.comunidadeId;
        data["comunidade"] = this.comunidade ? this.comunidade.toJSON() : <any>undefined;
        data["corRaca"] = this.corRaca;
        data["corRacaString"] = this.corRacaString;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CurriculoDadoPessoal {
        const json = this.toJSON();
        let result = new CurriculoDadoPessoal();
        result.init(json);
        return result;
    }
}

export interface ICurriculoDadoPessoal {
    candidato: Candidato;
    candidatoId: string;
    nome: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    genero: Genero;
    generoString: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    telefone: string | undefined;
    enderecoId: string | undefined;
    endereco: Endereco;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    comunidadeId: string | undefined;
    comunidade: Comunidade;
    corRaca: CorRacaEnum;
    corRacaString: string | undefined;
    naoPossuiEmail: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CandidatoVagaEspecialDto implements ICandidatoVagaEspecialDto {
    nome: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    cpf: string | undefined;
    favorito: boolean;
    inscricaoId: string | undefined;
    creationTime: moment.Moment;
    estagioTriagem: EstagioTriagem;
    readonly estagioTriagemString: string | undefined;
    id: string;

    constructor(data?: ICandidatoVagaEspecialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.cpf = _data["cpf"];
            this.favorito = _data["favorito"];
            this.inscricaoId = _data["inscricaoId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.estagioTriagem = _data["estagioTriagem"];
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaEspecialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaEspecialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["cpf"] = this.cpf;
        data["favorito"] = this.favorito;
        data["inscricaoId"] = this.inscricaoId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["estagioTriagem"] = this.estagioTriagem;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaEspecialDto {
        const json = this.toJSON();
        let result = new CandidatoVagaEspecialDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaEspecialDto {
    nome: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    cpf: string | undefined;
    favorito: boolean;
    inscricaoId: string | undefined;
    creationTime: moment.Moment;
    estagioTriagem: EstagioTriagem;
    estagioTriagemString: string | undefined;
    id: string;
}

export class CandidatoVagaEspecialDtoPagedResultDto implements ICandidatoVagaEspecialDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaEspecialDto[] | undefined;

    constructor(data?: ICandidatoVagaEspecialDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoVagaEspecialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoVagaEspecialDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaEspecialDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoVagaEspecialDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoVagaEspecialDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaEspecialDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaEspecialDto[] | undefined;
}

export enum TipoRelatorio {
    _0 = 0,
    _1 = 1,
}

export class FiltroRelatorioCandidatosCadastradosDto implements IFiltroRelatorioCandidatosCadastradosDto {
    cpf: string | undefined;
    nome: string | undefined;
    dataCadastroInicial: string | undefined;
    dataCadastroFinal: string | undefined;
    empresaId: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    pcd: boolean;
    tipoRelatorio: TipoRelatorio;
    microrregioes: string[] | undefined;
    status: number | undefined;
    dataContratacaoInicial: string | undefined;
    dataContratacaoFinal: string | undefined;
    tituloVaga: string | undefined;
    candidatoExcluido: boolean;

    constructor(data?: IFiltroRelatorioCandidatosCadastradosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpf = _data["cpf"];
            this.nome = _data["nome"];
            this.dataCadastroInicial = _data["dataCadastroInicial"];
            this.dataCadastroFinal = _data["dataCadastroFinal"];
            this.empresaId = _data["empresaId"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.pcd = _data["pcd"];
            this.tipoRelatorio = _data["tipoRelatorio"];
            if (Array.isArray(_data["microrregioes"])) {
                this.microrregioes = [] as any;
                for (let item of _data["microrregioes"])
                    this.microrregioes.push(item);
            }
            this.status = _data["status"];
            this.dataContratacaoInicial = _data["dataContratacaoInicial"];
            this.dataContratacaoFinal = _data["dataContratacaoFinal"];
            this.tituloVaga = _data["tituloVaga"];
            this.candidatoExcluido = _data["candidatoExcluido"];
        }
    }

    static fromJS(data: any): FiltroRelatorioCandidatosCadastradosDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiltroRelatorioCandidatosCadastradosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["nome"] = this.nome;
        data["dataCadastroInicial"] = this.dataCadastroInicial;
        data["dataCadastroFinal"] = this.dataCadastroFinal;
        data["empresaId"] = this.empresaId;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["pcd"] = this.pcd;
        data["tipoRelatorio"] = this.tipoRelatorio;
        if (Array.isArray(this.microrregioes)) {
            data["microrregioes"] = [];
            for (let item of this.microrregioes)
                data["microrregioes"].push(item);
        }
        data["status"] = this.status;
        data["dataContratacaoInicial"] = this.dataContratacaoInicial;
        data["dataContratacaoFinal"] = this.dataContratacaoFinal;
        data["tituloVaga"] = this.tituloVaga;
        data["candidatoExcluido"] = this.candidatoExcluido;
        return data;
    }

    clone(): FiltroRelatorioCandidatosCadastradosDto {
        const json = this.toJSON();
        let result = new FiltroRelatorioCandidatosCadastradosDto();
        result.init(json);
        return result;
    }
}

export interface IFiltroRelatorioCandidatosCadastradosDto {
    cpf: string | undefined;
    nome: string | undefined;
    dataCadastroInicial: string | undefined;
    dataCadastroFinal: string | undefined;
    empresaId: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    pcd: boolean;
    tipoRelatorio: TipoRelatorio;
    microrregioes: string[] | undefined;
    status: number | undefined;
    dataContratacaoInicial: string | undefined;
    dataContratacaoFinal: string | undefined;
    tituloVaga: string | undefined;
    candidatoExcluido: boolean;
}

export class ReportCurriculoDto implements IReportCurriculoDto {
    candidatoNome: string | undefined;
    candidatoCpf: string | undefined;
    candidatoCurriculo: string | undefined;

    constructor(data?: IReportCurriculoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoNome = _data["candidatoNome"];
            this.candidatoCpf = _data["candidatoCpf"];
            this.candidatoCurriculo = _data["candidatoCurriculo"];
        }
    }

    static fromJS(data: any): ReportCurriculoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportCurriculoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoNome"] = this.candidatoNome;
        data["candidatoCpf"] = this.candidatoCpf;
        data["candidatoCurriculo"] = this.candidatoCurriculo;
        return data;
    }

    clone(): ReportCurriculoDto {
        const json = this.toJSON();
        let result = new ReportCurriculoDto();
        result.init(json);
        return result;
    }
}

export interface IReportCurriculoDto {
    candidatoNome: string | undefined;
    candidatoCpf: string | undefined;
    candidatoCurriculo: string | undefined;
}

export class ImportTableDto implements IImportTableDto {
    base64: string | undefined;

    constructor(data?: IImportTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): ImportTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }

    clone(): ImportTableDto {
        const json = this.toJSON();
        let result = new ImportTableDto();
        result.init(json);
        return result;
    }
}

export interface IImportTableDto {
    base64: string | undefined;
}

export class CreateCandidatoFormacaoAcademicaDto implements ICreateCandidatoFormacaoAcademicaDto {
    candidatoId: string;
    nomeInstituicao: string;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;

    constructor(data?: ICreateCandidatoFormacaoAcademicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.nomeInstituicao = _data["nomeInstituicao"];
            this.nomeCurso = _data["nomeCurso"];
            this.grau = _data["grau"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.naoLembraData = _data["naoLembraData"];
        }
    }

    static fromJS(data: any): CreateCandidatoFormacaoAcademicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCandidatoFormacaoAcademicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["nomeInstituicao"] = this.nomeInstituicao;
        data["nomeCurso"] = this.nomeCurso;
        data["grau"] = this.grau;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["naoLembraData"] = this.naoLembraData;
        return data;
    }

    clone(): CreateCandidatoFormacaoAcademicaDto {
        const json = this.toJSON();
        let result = new CreateCandidatoFormacaoAcademicaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCandidatoFormacaoAcademicaDto {
    candidatoId: string;
    nomeInstituicao: string;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;
}

export class CandidatoFormacaoAcademicaDtoPagedResultDto implements ICandidatoFormacaoAcademicaDtoPagedResultDto {
    totalCount: number;
    items: CandidatoFormacaoAcademicaDto[] | undefined;

    constructor(data?: ICandidatoFormacaoAcademicaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoFormacaoAcademicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoFormacaoAcademicaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoFormacaoAcademicaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoFormacaoAcademicaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoFormacaoAcademicaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoFormacaoAcademicaDtoPagedResultDto {
    totalCount: number;
    items: CandidatoFormacaoAcademicaDto[] | undefined;
}

export class UpdateCandidatoFormacaoAcademicaDto implements IUpdateCandidatoFormacaoAcademicaDto {
    candidatoId: string;
    nomeInstituicao: string;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;
    id: string;

    constructor(data?: IUpdateCandidatoFormacaoAcademicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.nomeInstituicao = _data["nomeInstituicao"];
            this.nomeCurso = _data["nomeCurso"];
            this.grau = _data["grau"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.naoLembraData = _data["naoLembraData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCandidatoFormacaoAcademicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCandidatoFormacaoAcademicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["nomeInstituicao"] = this.nomeInstituicao;
        data["nomeCurso"] = this.nomeCurso;
        data["grau"] = this.grau;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["naoLembraData"] = this.naoLembraData;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCandidatoFormacaoAcademicaDto {
        const json = this.toJSON();
        let result = new UpdateCandidatoFormacaoAcademicaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCandidatoFormacaoAcademicaDto {
    candidatoId: string;
    nomeInstituicao: string;
    nomeCurso: string | undefined;
    grau: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    naoLembraData: boolean;
    id: string;
}

export class CreateCandidatoIdiomaDto implements ICreateCandidatoIdiomaDto {
    candidatoId: string;
    idiomaId: string;
    nivelIdioma: NivelIdioma;

    constructor(data?: ICreateCandidatoIdiomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.idiomaId = _data["idiomaId"];
            this.nivelIdioma = _data["nivelIdioma"];
        }
    }

    static fromJS(data: any): CreateCandidatoIdiomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCandidatoIdiomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["idiomaId"] = this.idiomaId;
        data["nivelIdioma"] = this.nivelIdioma;
        return data;
    }

    clone(): CreateCandidatoIdiomaDto {
        const json = this.toJSON();
        let result = new CreateCandidatoIdiomaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCandidatoIdiomaDto {
    candidatoId: string;
    idiomaId: string;
    nivelIdioma: NivelIdioma;
}

export class UpdateCandidatoIdiomaDto implements IUpdateCandidatoIdiomaDto {
    nivelIdioma: NivelIdioma;
    id: string;

    constructor(data?: IUpdateCandidatoIdiomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nivelIdioma = _data["nivelIdioma"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCandidatoIdiomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCandidatoIdiomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nivelIdioma"] = this.nivelIdioma;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCandidatoIdiomaDto {
        const json = this.toJSON();
        let result = new UpdateCandidatoIdiomaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCandidatoIdiomaDto {
    nivelIdioma: NivelIdioma;
    id: string;
}

export class CandidatoIdiomaDtoPagedResultDto implements ICandidatoIdiomaDtoPagedResultDto {
    totalCount: number;
    items: CandidatoIdiomaDto[] | undefined;

    constructor(data?: ICandidatoIdiomaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoIdiomaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoIdiomaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoIdiomaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoIdiomaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoIdiomaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoIdiomaDtoPagedResultDto {
    totalCount: number;
    items: CandidatoIdiomaDto[] | undefined;
}

export class CreateCandidatoVagaAvaliacaoRequisitoDto implements ICreateCandidatoVagaAvaliacaoRequisitoDto {
    candidatoVagaId: string;
    avaliacaoRequisitoVagaId: string;
    respostaAvaliacaoRequisitoId: string;
    id: string;

    constructor(data?: ICreateCandidatoVagaAvaliacaoRequisitoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.avaliacaoRequisitoVagaId = _data["avaliacaoRequisitoVagaId"];
            this.respostaAvaliacaoRequisitoId = _data["respostaAvaliacaoRequisitoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCandidatoVagaAvaliacaoRequisitoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCandidatoVagaAvaliacaoRequisitoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["avaliacaoRequisitoVagaId"] = this.avaliacaoRequisitoVagaId;
        data["respostaAvaliacaoRequisitoId"] = this.respostaAvaliacaoRequisitoId;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateCandidatoVagaAvaliacaoRequisitoDto {
        const json = this.toJSON();
        let result = new CreateCandidatoVagaAvaliacaoRequisitoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCandidatoVagaAvaliacaoRequisitoDto {
    candidatoVagaId: string;
    avaliacaoRequisitoVagaId: string;
    respostaAvaliacaoRequisitoId: string;
    id: string;
}

export class CreateCandidatoVagaDto implements ICreateCandidatoVagaDto {
    candidatoId: string;
    vagaId: string;
    candidatoVagaAvaliacoesRequisitos: CreateCandidatoVagaAvaliacaoRequisitoDto[] | undefined;

    constructor(data?: ICreateCandidatoVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.vagaId = _data["vagaId"];
            if (Array.isArray(_data["candidatoVagaAvaliacoesRequisitos"])) {
                this.candidatoVagaAvaliacoesRequisitos = [] as any;
                for (let item of _data["candidatoVagaAvaliacoesRequisitos"])
                    this.candidatoVagaAvaliacoesRequisitos.push(CreateCandidatoVagaAvaliacaoRequisitoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCandidatoVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCandidatoVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["vagaId"] = this.vagaId;
        if (Array.isArray(this.candidatoVagaAvaliacoesRequisitos)) {
            data["candidatoVagaAvaliacoesRequisitos"] = [];
            for (let item of this.candidatoVagaAvaliacoesRequisitos)
                data["candidatoVagaAvaliacoesRequisitos"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateCandidatoVagaDto {
        const json = this.toJSON();
        let result = new CreateCandidatoVagaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCandidatoVagaDto {
    candidatoId: string;
    vagaId: string;
    candidatoVagaAvaliacoesRequisitos: CreateCandidatoVagaAvaliacaoRequisitoDto[] | undefined;
}

export class CandidatoVagaAnotacaoDto implements ICandidatoVagaAnotacaoDto {
    candidatoVagaId: string;
    texto: string | undefined;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ICandidatoVagaAnotacaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.texto = _data["texto"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaAnotacaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAnotacaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["texto"] = this.texto;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaAnotacaoDto {
        const json = this.toJSON();
        let result = new CandidatoVagaAnotacaoDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAnotacaoDto {
    candidatoVagaId: string;
    texto: string | undefined;
    creationTime: moment.Moment;
    id: string;
}

export class CandidatoVagaAnexoDto implements ICandidatoVagaAnexoDto {
    documentoNome: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoUrlDesbloqueado: string | undefined;
    arquivoTamanho: number;
    id: string;

    constructor(data?: ICandidatoVagaAnexoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoNome = _data["documentoNome"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoUrlDesbloqueado = _data["arquivoUrlDesbloqueado"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaAnexoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAnexoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoNome"] = this.documentoNome;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoUrlDesbloqueado"] = this.arquivoUrlDesbloqueado;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaAnexoDto {
        const json = this.toJSON();
        let result = new CandidatoVagaAnexoDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAnexoDto {
    documentoNome: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoUrlDesbloqueado: string | undefined;
    arquivoTamanho: number;
    id: string;
}

export class CandidatoVagaAvaliacaoRequisitoDto implements ICandidatoVagaAvaliacaoRequisitoDto {
    candidatoVagaId: string;
    avaliacaoRequisitoVagaId: string;
    respostaAvaliacaoRequisitoId: string;
    id: string;

    constructor(data?: ICandidatoVagaAvaliacaoRequisitoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.avaliacaoRequisitoVagaId = _data["avaliacaoRequisitoVagaId"];
            this.respostaAvaliacaoRequisitoId = _data["respostaAvaliacaoRequisitoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaAvaliacaoRequisitoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAvaliacaoRequisitoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["avaliacaoRequisitoVagaId"] = this.avaliacaoRequisitoVagaId;
        data["respostaAvaliacaoRequisitoId"] = this.respostaAvaliacaoRequisitoId;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaAvaliacaoRequisitoDto {
        const json = this.toJSON();
        let result = new CandidatoVagaAvaliacaoRequisitoDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAvaliacaoRequisitoDto {
    candidatoVagaId: string;
    avaliacaoRequisitoVagaId: string;
    respostaAvaliacaoRequisitoId: string;
    id: string;
}

export class CandidatoVagaDto implements ICandidatoVagaDto {
    candidatoId: string;
    candidato: CandidatoDto;
    vagaId: string;
    vaga: VagaDto;
    creationTime: moment.Moment;
    emailEntrevista: boolean;
    alertGestor: boolean;
    emailEncerramento: boolean;
    readonly estagioTriagemString: string | undefined;
    estagioTriagem: EstagioTriagem;
    selecionado: boolean;
    contratado: boolean;
    visualizado: boolean;
    favorito: boolean;
    candidatoVagaAnotacao: CandidatoVagaAnotacaoDto;
    candidatoVagaAnexos: CandidatoVagaAnexoDto[] | undefined;
    candidatoVagaAvaliacoesRequisitos: CandidatoVagaAvaliacaoRequisitoDto[] | undefined;
    estagioTriagemUltimaAtualizacao: moment.Moment | undefined;
    candidatoInformouContratacao: boolean;
    dataSelecaoCandidato: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: string;

    constructor(data?: ICandidatoVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.candidato = _data["candidato"] ? CandidatoDto.fromJS(_data["candidato"]) : <any>undefined;
            this.vagaId = _data["vagaId"];
            this.vaga = _data["vaga"] ? VagaDto.fromJS(_data["vaga"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.emailEntrevista = _data["emailEntrevista"];
            this.alertGestor = _data["alertGestor"];
            this.emailEncerramento = _data["emailEncerramento"];
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.estagioTriagem = _data["estagioTriagem"];
            this.selecionado = _data["selecionado"];
            this.contratado = _data["contratado"];
            this.visualizado = _data["visualizado"];
            this.favorito = _data["favorito"];
            this.candidatoVagaAnotacao = _data["candidatoVagaAnotacao"] ? CandidatoVagaAnotacaoDto.fromJS(_data["candidatoVagaAnotacao"]) : <any>undefined;
            if (Array.isArray(_data["candidatoVagaAnexos"])) {
                this.candidatoVagaAnexos = [] as any;
                for (let item of _data["candidatoVagaAnexos"])
                    this.candidatoVagaAnexos.push(CandidatoVagaAnexoDto.fromJS(item));
            }
            if (Array.isArray(_data["candidatoVagaAvaliacoesRequisitos"])) {
                this.candidatoVagaAvaliacoesRequisitos = [] as any;
                for (let item of _data["candidatoVagaAvaliacoesRequisitos"])
                    this.candidatoVagaAvaliacoesRequisitos.push(CandidatoVagaAvaliacaoRequisitoDto.fromJS(item));
            }
            this.estagioTriagemUltimaAtualizacao = _data["estagioTriagemUltimaAtualizacao"] ? moment(_data["estagioTriagemUltimaAtualizacao"].toString()) : <any>undefined;
            this.candidatoInformouContratacao = _data["candidatoInformouContratacao"];
            this.dataSelecaoCandidato = _data["dataSelecaoCandidato"] ? moment(_data["dataSelecaoCandidato"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["vagaId"] = this.vagaId;
        data["vaga"] = this.vaga ? this.vaga.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["emailEntrevista"] = this.emailEntrevista;
        data["alertGestor"] = this.alertGestor;
        data["emailEncerramento"] = this.emailEncerramento;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["estagioTriagem"] = this.estagioTriagem;
        data["selecionado"] = this.selecionado;
        data["contratado"] = this.contratado;
        data["visualizado"] = this.visualizado;
        data["favorito"] = this.favorito;
        data["candidatoVagaAnotacao"] = this.candidatoVagaAnotacao ? this.candidatoVagaAnotacao.toJSON() : <any>undefined;
        if (Array.isArray(this.candidatoVagaAnexos)) {
            data["candidatoVagaAnexos"] = [];
            for (let item of this.candidatoVagaAnexos)
                data["candidatoVagaAnexos"].push(item.toJSON());
        }
        if (Array.isArray(this.candidatoVagaAvaliacoesRequisitos)) {
            data["candidatoVagaAvaliacoesRequisitos"] = [];
            for (let item of this.candidatoVagaAvaliacoesRequisitos)
                data["candidatoVagaAvaliacoesRequisitos"].push(item.toJSON());
        }
        data["estagioTriagemUltimaAtualizacao"] = this.estagioTriagemUltimaAtualizacao ? this.estagioTriagemUltimaAtualizacao.toISOString() : <any>undefined;
        data["candidatoInformouContratacao"] = this.candidatoInformouContratacao;
        data["dataSelecaoCandidato"] = this.dataSelecaoCandidato ? this.dataSelecaoCandidato.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaDto {
        const json = this.toJSON();
        let result = new CandidatoVagaDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaDto {
    candidatoId: string;
    candidato: CandidatoDto;
    vagaId: string;
    vaga: VagaDto;
    creationTime: moment.Moment;
    emailEntrevista: boolean;
    alertGestor: boolean;
    emailEncerramento: boolean;
    estagioTriagemString: string | undefined;
    estagioTriagem: EstagioTriagem;
    selecionado: boolean;
    contratado: boolean;
    visualizado: boolean;
    favorito: boolean;
    candidatoVagaAnotacao: CandidatoVagaAnotacaoDto;
    candidatoVagaAnexos: CandidatoVagaAnexoDto[] | undefined;
    candidatoVagaAvaliacoesRequisitos: CandidatoVagaAvaliacaoRequisitoDto[] | undefined;
    estagioTriagemUltimaAtualizacao: moment.Moment | undefined;
    candidatoInformouContratacao: boolean;
    dataSelecaoCandidato: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: string;
}

export class CandidatoVagaDtoPagedResultDto implements ICandidatoVagaDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaDto[] | undefined;

    constructor(data?: ICandidatoVagaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoVagaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoVagaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoVagaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoVagaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaDto[] | undefined;
}

export class CandidatoVagaKanbanDto implements ICandidatoVagaKanbanDto {
    candidatoId: string;
    vagaId: string;
    nome: string | undefined;
    readonly iniciaisNome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    pcd: boolean;
    beneficiarioSuzano: boolean;
    possuiCurriculosSkillsConecta: boolean;
    emailEntrevista: boolean;
    alertGestor: boolean;
    visualizado: boolean;
    favorito: boolean;
    estagioTriagem: EstagioTriagem;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ICandidatoVagaKanbanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.vagaId = _data["vagaId"];
            this.nome = _data["nome"];
            (<any>this).iniciaisNome = _data["iniciaisNome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.urlFotoPerfilDesbloqueado = _data["urlFotoPerfilDesbloqueado"];
            this.pcd = _data["pcd"];
            this.beneficiarioSuzano = _data["beneficiarioSuzano"];
            this.possuiCurriculosSkillsConecta = _data["possuiCurriculosSkillsConecta"];
            this.emailEntrevista = _data["emailEntrevista"];
            this.alertGestor = _data["alertGestor"];
            this.visualizado = _data["visualizado"];
            this.favorito = _data["favorito"];
            this.estagioTriagem = _data["estagioTriagem"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaKanbanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaKanbanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["vagaId"] = this.vagaId;
        data["nome"] = this.nome;
        data["iniciaisNome"] = this.iniciaisNome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["urlFotoPerfilDesbloqueado"] = this.urlFotoPerfilDesbloqueado;
        data["pcd"] = this.pcd;
        data["beneficiarioSuzano"] = this.beneficiarioSuzano;
        data["possuiCurriculosSkillsConecta"] = this.possuiCurriculosSkillsConecta;
        data["emailEntrevista"] = this.emailEntrevista;
        data["alertGestor"] = this.alertGestor;
        data["visualizado"] = this.visualizado;
        data["favorito"] = this.favorito;
        data["estagioTriagem"] = this.estagioTriagem;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaKanbanDto {
        const json = this.toJSON();
        let result = new CandidatoVagaKanbanDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaKanbanDto {
    candidatoId: string;
    vagaId: string;
    nome: string | undefined;
    iniciaisNome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    pcd: boolean;
    beneficiarioSuzano: boolean;
    possuiCurriculosSkillsConecta: boolean;
    emailEntrevista: boolean;
    alertGestor: boolean;
    visualizado: boolean;
    favorito: boolean;
    estagioTriagem: EstagioTriagem;
    creationTime: moment.Moment;
    id: string;
}

export class CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple implements ICandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple {
    item1: CandidatoVagaDtoPagedResultDto;
    item2: TotalPeriodoDescricaoResponseDto;

    constructor(data?: ICandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? CandidatoVagaDtoPagedResultDto.fromJS(_data["item1"]) : <any>undefined;
            this.item2 = _data["item2"] ? TotalPeriodoDescricaoResponseDto.fromJS(_data["item2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }

    clone(): CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple {
        const json = this.toJSON();
        let result = new CandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaDtoPagedResultDtoTotalPeriodoDescricaoResponseDtoTuple {
    item1: CandidatoVagaDtoPagedResultDto;
    item2: TotalPeriodoDescricaoResponseDto;
}

export class FiltroRelatorioCandidatosContratadosDto implements IFiltroRelatorioCandidatosContratadosDto {
    cpf: string | undefined;
    nome: string | undefined;
    dataCadastroInicial: string | undefined;
    dataCadastroFinal: string | undefined;
    empresaId: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    pcd: boolean;
    tipoRelatorio: TipoRelatorio;
    microrregioes: string[] | undefined;
    dataContratacaoInicial: string | undefined;
    dataContratacaoFinal: string | undefined;
    tituloVaga: string | undefined;

    constructor(data?: IFiltroRelatorioCandidatosContratadosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpf = _data["cpf"];
            this.nome = _data["nome"];
            this.dataCadastroInicial = _data["dataCadastroInicial"];
            this.dataCadastroFinal = _data["dataCadastroFinal"];
            this.empresaId = _data["empresaId"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.pcd = _data["pcd"];
            this.tipoRelatorio = _data["tipoRelatorio"];
            if (Array.isArray(_data["microrregioes"])) {
                this.microrregioes = [] as any;
                for (let item of _data["microrregioes"])
                    this.microrregioes.push(item);
            }
            this.dataContratacaoInicial = _data["dataContratacaoInicial"];
            this.dataContratacaoFinal = _data["dataContratacaoFinal"];
            this.tituloVaga = _data["tituloVaga"];
        }
    }

    static fromJS(data: any): FiltroRelatorioCandidatosContratadosDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiltroRelatorioCandidatosContratadosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["nome"] = this.nome;
        data["dataCadastroInicial"] = this.dataCadastroInicial;
        data["dataCadastroFinal"] = this.dataCadastroFinal;
        data["empresaId"] = this.empresaId;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["pcd"] = this.pcd;
        data["tipoRelatorio"] = this.tipoRelatorio;
        if (Array.isArray(this.microrregioes)) {
            data["microrregioes"] = [];
            for (let item of this.microrregioes)
                data["microrregioes"].push(item);
        }
        data["dataContratacaoInicial"] = this.dataContratacaoInicial;
        data["dataContratacaoFinal"] = this.dataContratacaoFinal;
        data["tituloVaga"] = this.tituloVaga;
        return data;
    }

    clone(): FiltroRelatorioCandidatosContratadosDto {
        const json = this.toJSON();
        let result = new FiltroRelatorioCandidatosContratadosDto();
        result.init(json);
        return result;
    }
}

export interface IFiltroRelatorioCandidatosContratadosDto {
    cpf: string | undefined;
    nome: string | undefined;
    dataCadastroInicial: string | undefined;
    dataCadastroFinal: string | undefined;
    empresaId: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    pcd: boolean;
    tipoRelatorio: TipoRelatorio;
    microrregioes: string[] | undefined;
    dataContratacaoInicial: string | undefined;
    dataContratacaoFinal: string | undefined;
    tituloVaga: string | undefined;
}

export class InscricaoCandidatoDto implements IInscricaoCandidatoDto {
    tituloVaga: string | undefined;
    creationTime: moment.Moment;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    encerrada: boolean;
    estagioTriagem: EstagioTriagem;
    readonly estagioTriagemString: string | undefined;
    id: string;

    constructor(data?: IInscricaoCandidatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tituloVaga = _data["tituloVaga"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.encerrada = _data["encerrada"];
            this.estagioTriagem = _data["estagioTriagem"];
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InscricaoCandidatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new InscricaoCandidatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tituloVaga"] = this.tituloVaga;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["encerrada"] = this.encerrada;
        data["estagioTriagem"] = this.estagioTriagem;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["id"] = this.id;
        return data;
    }

    clone(): InscricaoCandidatoDto {
        const json = this.toJSON();
        let result = new InscricaoCandidatoDto();
        result.init(json);
        return result;
    }
}

export interface IInscricaoCandidatoDto {
    tituloVaga: string | undefined;
    creationTime: moment.Moment;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    encerrada: boolean;
    estagioTriagem: EstagioTriagem;
    estagioTriagemString: string | undefined;
    id: string;
}

export class InscricaoCandidatoDtoPagedResultDto implements IInscricaoCandidatoDtoPagedResultDto {
    totalCount: number;
    items: InscricaoCandidatoDto[] | undefined;

    constructor(data?: IInscricaoCandidatoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InscricaoCandidatoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InscricaoCandidatoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InscricaoCandidatoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): InscricaoCandidatoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InscricaoCandidatoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInscricaoCandidatoDtoPagedResultDto {
    totalCount: number;
    items: InscricaoCandidatoDto[] | undefined;
}

export class SelecionarCandidatoVagaRequestDto implements ISelecionarCandidatoVagaRequestDto {
    vagaId: string;
    candidatosId: string[] | undefined;

    constructor(data?: ISelecionarCandidatoVagaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vagaId = _data["vagaId"];
            if (Array.isArray(_data["candidatosId"])) {
                this.candidatosId = [] as any;
                for (let item of _data["candidatosId"])
                    this.candidatosId.push(item);
            }
        }
    }

    static fromJS(data: any): SelecionarCandidatoVagaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelecionarCandidatoVagaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vagaId"] = this.vagaId;
        if (Array.isArray(this.candidatosId)) {
            data["candidatosId"] = [];
            for (let item of this.candidatosId)
                data["candidatosId"].push(item);
        }
        return data;
    }

    clone(): SelecionarCandidatoVagaRequestDto {
        const json = this.toJSON();
        let result = new SelecionarCandidatoVagaRequestDto();
        result.init(json);
        return result;
    }
}

export interface ISelecionarCandidatoVagaRequestDto {
    vagaId: string;
    candidatosId: string[] | undefined;
}

export class CandidatoVagaResultDto implements ICandidatoVagaResultDto {
    id: string;
    empresa: string | undefined;
    titulo: string | undefined;
    cargo: string | undefined;
    contratado: boolean;

    constructor(data?: ICandidatoVagaResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empresa = _data["empresa"];
            this.titulo = _data["titulo"];
            this.cargo = _data["cargo"];
            this.contratado = _data["contratado"];
        }
    }

    static fromJS(data: any): CandidatoVagaResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empresa"] = this.empresa;
        data["titulo"] = this.titulo;
        data["cargo"] = this.cargo;
        data["contratado"] = this.contratado;
        return data;
    }

    clone(): CandidatoVagaResultDto {
        const json = this.toJSON();
        let result = new CandidatoVagaResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaResultDto {
    id: string;
    empresa: string | undefined;
    titulo: string | undefined;
    cargo: string | undefined;
    contratado: boolean;
}

export class CandidatoVagaResultDtoPagedResultDto implements ICandidatoVagaResultDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaResultDto[] | undefined;

    constructor(data?: ICandidatoVagaResultDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoVagaResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoVagaResultDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaResultDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoVagaResultDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoVagaResultDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaResultDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaResultDto[] | undefined;
}

export class CreateCandidatoVagaAnexoDto implements ICreateCandidatoVagaAnexoDto {
    candidatoVagaId: string;
    documentoNome: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoUrlDesbloqueado: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;

    constructor(data?: ICreateCandidatoVagaAnexoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.documentoNome = _data["documentoNome"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoUrlDesbloqueado = _data["arquivoUrlDesbloqueado"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.arquivoTipo = _data["arquivoTipo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCandidatoVagaAnexoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCandidatoVagaAnexoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["documentoNome"] = this.documentoNome;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoBase64"] = this.arquivoBase64;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoUrlDesbloqueado"] = this.arquivoUrlDesbloqueado;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["arquivoTipo"] = this.arquivoTipo;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateCandidatoVagaAnexoDto {
        const json = this.toJSON();
        let result = new CreateCandidatoVagaAnexoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCandidatoVagaAnexoDto {
    candidatoVagaId: string;
    documentoNome: string | undefined;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoUrlDesbloqueado: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;
}

export class UpdateCandidatoVagaDto implements IUpdateCandidatoVagaDto {
    estagioTriagem: EstagioTriagem;
    candidatoVagaAnexos: CreateCandidatoVagaAnexoDto[] | undefined;
    candidatoVagaAvaliacoesRequisitos: CreateCandidatoVagaAvaliacaoRequisitoDto[] | undefined;
    id: string;

    constructor(data?: IUpdateCandidatoVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estagioTriagem = _data["estagioTriagem"];
            if (Array.isArray(_data["candidatoVagaAnexos"])) {
                this.candidatoVagaAnexos = [] as any;
                for (let item of _data["candidatoVagaAnexos"])
                    this.candidatoVagaAnexos.push(CreateCandidatoVagaAnexoDto.fromJS(item));
            }
            if (Array.isArray(_data["candidatoVagaAvaliacoesRequisitos"])) {
                this.candidatoVagaAvaliacoesRequisitos = [] as any;
                for (let item of _data["candidatoVagaAvaliacoesRequisitos"])
                    this.candidatoVagaAvaliacoesRequisitos.push(CreateCandidatoVagaAvaliacaoRequisitoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCandidatoVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCandidatoVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estagioTriagem"] = this.estagioTriagem;
        if (Array.isArray(this.candidatoVagaAnexos)) {
            data["candidatoVagaAnexos"] = [];
            for (let item of this.candidatoVagaAnexos)
                data["candidatoVagaAnexos"].push(item.toJSON());
        }
        if (Array.isArray(this.candidatoVagaAvaliacoesRequisitos)) {
            data["candidatoVagaAvaliacoesRequisitos"] = [];
            for (let item of this.candidatoVagaAvaliacoesRequisitos)
                data["candidatoVagaAvaliacoesRequisitos"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCandidatoVagaDto {
        const json = this.toJSON();
        let result = new UpdateCandidatoVagaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCandidatoVagaDto {
    estagioTriagem: EstagioTriagem;
    candidatoVagaAnexos: CreateCandidatoVagaAnexoDto[] | undefined;
    candidatoVagaAvaliacoesRequisitos: CreateCandidatoVagaAvaliacaoRequisitoDto[] | undefined;
    id: string;
}

export class CandidatoResumoDto implements ICandidatoResumoDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    beneficiarioSuzano: boolean;
    pcd: boolean;
    id: string;

    constructor(data?: ICandidatoResumoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.beneficiarioSuzano = _data["beneficiarioSuzano"];
            this.pcd = _data["pcd"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoResumoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoResumoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["beneficiarioSuzano"] = this.beneficiarioSuzano;
        data["pcd"] = this.pcd;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoResumoDto {
        const json = this.toJSON();
        let result = new CandidatoResumoDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoResumoDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    user: UserDto;
    beneficiarioSuzano: boolean;
    pcd: boolean;
    id: string;
}

export class CandidatoVagaResumoDto implements ICandidatoVagaResumoDto {
    candidatoId: string;
    candidato: CandidatoResumoDto;
    selecionado: boolean;
    contratado: boolean;
    vagaId: string;
    vaga: VagaDto;
    readonly estagioTriagemString: string | undefined;
    estagioTriagem: EstagioTriagem;
    visualizado: boolean;
    favorito: boolean;
    id: string;

    constructor(data?: ICandidatoVagaResumoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.candidato = _data["candidato"] ? CandidatoResumoDto.fromJS(_data["candidato"]) : <any>undefined;
            this.selecionado = _data["selecionado"];
            this.contratado = _data["contratado"];
            this.vagaId = _data["vagaId"];
            this.vaga = _data["vaga"] ? VagaDto.fromJS(_data["vaga"]) : <any>undefined;
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.estagioTriagem = _data["estagioTriagem"];
            this.visualizado = _data["visualizado"];
            this.favorito = _data["favorito"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidatoVagaResumoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaResumoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["candidato"] = this.candidato ? this.candidato.toJSON() : <any>undefined;
        data["selecionado"] = this.selecionado;
        data["contratado"] = this.contratado;
        data["vagaId"] = this.vagaId;
        data["vaga"] = this.vaga ? this.vaga.toJSON() : <any>undefined;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["estagioTriagem"] = this.estagioTriagem;
        data["visualizado"] = this.visualizado;
        data["favorito"] = this.favorito;
        data["id"] = this.id;
        return data;
    }

    clone(): CandidatoVagaResumoDto {
        const json = this.toJSON();
        let result = new CandidatoVagaResumoDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaResumoDto {
    candidatoId: string;
    candidato: CandidatoResumoDto;
    selecionado: boolean;
    contratado: boolean;
    vagaId: string;
    vaga: VagaDto;
    estagioTriagemString: string | undefined;
    estagioTriagem: EstagioTriagem;
    visualizado: boolean;
    favorito: boolean;
    id: string;
}

export class CandidatoVagaResumoDtoPagedResultDto implements ICandidatoVagaResumoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaResumoDto[] | undefined;

    constructor(data?: ICandidatoVagaResumoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoVagaResumoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoVagaResumoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaResumoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoVagaResumoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoVagaResumoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaResumoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaResumoDto[] | undefined;
}

export class CandidatoVagaAnotacaoDtoPagedResultDto implements ICandidatoVagaAnotacaoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaAnotacaoDto[] | undefined;

    constructor(data?: ICandidatoVagaAnotacaoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoVagaAnotacaoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoVagaAnotacaoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAnotacaoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoVagaAnotacaoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoVagaAnotacaoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAnotacaoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaAnotacaoDto[] | undefined;
}

export class CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto implements ICandidatoVagaAvaliacaoRequisitoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaAvaliacaoRequisitoDto[] | undefined;

    constructor(data?: ICandidatoVagaAvaliacaoRequisitoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CandidatoVagaAvaliacaoRequisitoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CandidatoVagaAvaliacaoRequisitoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICandidatoVagaAvaliacaoRequisitoDtoPagedResultDto {
    totalCount: number;
    items: CandidatoVagaAvaliacaoRequisitoDto[] | undefined;
}

export class CreateCargoDto implements ICreateCargoDto {
    nome: string;

    constructor(data?: ICreateCargoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
        }
    }

    static fromJS(data: any): CreateCargoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCargoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        return data;
    }

    clone(): CreateCargoDto {
        const json = this.toJSON();
        let result = new CreateCargoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCargoDto {
    nome: string;
}

export class UpdateCargoDto implements IUpdateCargoDto {
    nome: string;
    id: string;

    constructor(data?: IUpdateCargoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCargoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCargoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCargoDto {
        const json = this.toJSON();
        let result = new UpdateCargoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCargoDto {
    nome: string;
    id: string;
}

export class CargoDtoPagedResultDto implements ICargoDtoPagedResultDto {
    totalCount: number;
    items: CargoDto[] | undefined;

    constructor(data?: ICargoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CargoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CargoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CargoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CargoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CargoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICargoDtoPagedResultDto {
    totalCount: number;
    items: CargoDto[] | undefined;
}

export class CidadeMicrorregiaoDto implements ICidadeMicrorregiaoDto {
    cidade: string | undefined;
    estado: string | undefined;
    ibgeId: string | undefined;
    microrregiaoId: string;
    id: string;

    constructor(data?: ICidadeMicrorregiaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.ibgeId = _data["ibgeId"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CidadeMicrorregiaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CidadeMicrorregiaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["ibgeId"] = this.ibgeId;
        data["microrregiaoId"] = this.microrregiaoId;
        data["id"] = this.id;
        return data;
    }

    clone(): CidadeMicrorregiaoDto {
        const json = this.toJSON();
        let result = new CidadeMicrorregiaoDto();
        result.init(json);
        return result;
    }
}

export interface ICidadeMicrorregiaoDto {
    cidade: string | undefined;
    estado: string | undefined;
    ibgeId: string | undefined;
    microrregiaoId: string;
    id: string;
}

export class CreateCompetenciaDto implements ICreateCompetenciaDto {
    nome: string;

    constructor(data?: ICreateCompetenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
        }
    }

    static fromJS(data: any): CreateCompetenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompetenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        return data;
    }

    clone(): CreateCompetenciaDto {
        const json = this.toJSON();
        let result = new CreateCompetenciaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCompetenciaDto {
    nome: string;
}

export class UpdateCompetenciaDto implements IUpdateCompetenciaDto {
    nome: string;
    id: string;

    constructor(data?: IUpdateCompetenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompetenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompetenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCompetenciaDto {
        const json = this.toJSON();
        let result = new UpdateCompetenciaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompetenciaDto {
    nome: string;
    id: string;
}

export class CompetenciaDtoPagedResultDto implements ICompetenciaDtoPagedResultDto {
    totalCount: number;
    items: CompetenciaDto[] | undefined;

    constructor(data?: ICompetenciaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompetenciaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetenciaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetenciaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CompetenciaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompetenciaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompetenciaDtoPagedResultDto {
    totalCount: number;
    items: CompetenciaDto[] | undefined;
}

export class CreateComunidadeDto implements ICreateComunidadeDto {
    nome: string;

    constructor(data?: ICreateComunidadeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
        }
    }

    static fromJS(data: any): CreateComunidadeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateComunidadeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        return data;
    }

    clone(): CreateComunidadeDto {
        const json = this.toJSON();
        let result = new CreateComunidadeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateComunidadeDto {
    nome: string;
}

export class ComunidadeDtoPagedResultDto implements IComunidadeDtoPagedResultDto {
    totalCount: number;
    items: ComunidadeDto[] | undefined;

    constructor(data?: IComunidadeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ComunidadeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComunidadeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComunidadeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ComunidadeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ComunidadeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IComunidadeDtoPagedResultDto {
    totalCount: number;
    items: ComunidadeDto[] | undefined;
}

export class UpdateComunidadeDto implements IUpdateComunidadeDto {
    nome: string;
    id: string;

    constructor(data?: IUpdateComunidadeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateComunidadeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComunidadeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateComunidadeDto {
        const json = this.toJSON();
        let result = new UpdateComunidadeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateComunidadeDto {
    nome: string;
    id: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class CurriculoCompetenciaDtoPagedResultDto implements ICurriculoCompetenciaDtoPagedResultDto {
    totalCount: number;
    items: CurriculoCompetenciaDto[] | undefined;

    constructor(data?: ICurriculoCompetenciaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CurriculoCompetenciaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurriculoCompetenciaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoCompetenciaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CurriculoCompetenciaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CurriculoCompetenciaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICurriculoCompetenciaDtoPagedResultDto {
    totalCount: number;
    items: CurriculoCompetenciaDto[] | undefined;
}

export class CreateCurriculoCompetenciaDto implements ICreateCurriculoCompetenciaDto {
    candidatoId: string;
    competenciaId: string;
    nivelCompetencia: NivelCompetencia;

    constructor(data?: ICreateCurriculoCompetenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.competenciaId = _data["competenciaId"];
            this.nivelCompetencia = _data["nivelCompetencia"];
        }
    }

    static fromJS(data: any): CreateCurriculoCompetenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCurriculoCompetenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["competenciaId"] = this.competenciaId;
        data["nivelCompetencia"] = this.nivelCompetencia;
        return data;
    }

    clone(): CreateCurriculoCompetenciaDto {
        const json = this.toJSON();
        let result = new CreateCurriculoCompetenciaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCurriculoCompetenciaDto {
    candidatoId: string;
    competenciaId: string;
    nivelCompetencia: NivelCompetencia;
}

export class UpdateCurriculoCompetenciaDto implements IUpdateCurriculoCompetenciaDto {
    nivelCompetencia: NivelCompetencia;
    id: string;

    constructor(data?: IUpdateCurriculoCompetenciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nivelCompetencia = _data["nivelCompetencia"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCurriculoCompetenciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurriculoCompetenciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nivelCompetencia"] = this.nivelCompetencia;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCurriculoCompetenciaDto {
        const json = this.toJSON();
        let result = new UpdateCurriculoCompetenciaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCurriculoCompetenciaDto {
    nivelCompetencia: NivelCompetencia;
    id: string;
}

export class CreateCurriculoDadoPessoalDto implements ICreateCurriculoDadoPessoalDto {
    candidatoId: string;
    nome: string;
    cpf: string;
    rg: string;
    genero: Genero;
    dataNascimento: moment.Moment;
    email: string | undefined;
    telefone: string;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    fotoUrl: string | undefined;
    fotoTipo: string | undefined;
    fotoBase64: string | undefined;
    fotoTamanho: number;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTipo: string | undefined;
    arquivoBase64: string | undefined;
    arquivoTamanho: number;
    corRaca: CorRacaEnum;
    comunidadeId: string | undefined;
    comunidade: ComunidadeDto;
    endereco: EnderecoDto;
    naoPossuiEmail: boolean;

    constructor(data?: ICreateCurriculoDadoPessoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.rg = _data["rg"];
            this.genero = _data["genero"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.fotoNome = _data["fotoNome"];
            this.fotoExtensao = _data["fotoExtensao"];
            this.fotoUrl = _data["fotoUrl"];
            this.fotoTipo = _data["fotoTipo"];
            this.fotoBase64 = _data["fotoBase64"];
            this.fotoTamanho = _data["fotoTamanho"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTipo = _data["arquivoTipo"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.corRaca = _data["corRaca"];
            this.comunidadeId = _data["comunidadeId"];
            this.comunidade = _data["comunidade"] ? ComunidadeDto.fromJS(_data["comunidade"]) : <any>undefined;
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.naoPossuiEmail = _data["naoPossuiEmail"];
        }
    }

    static fromJS(data: any): CreateCurriculoDadoPessoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCurriculoDadoPessoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["rg"] = this.rg;
        data["genero"] = this.genero;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["fotoNome"] = this.fotoNome;
        data["fotoExtensao"] = this.fotoExtensao;
        data["fotoUrl"] = this.fotoUrl;
        data["fotoTipo"] = this.fotoTipo;
        data["fotoBase64"] = this.fotoBase64;
        data["fotoTamanho"] = this.fotoTamanho;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTipo"] = this.arquivoTipo;
        data["arquivoBase64"] = this.arquivoBase64;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["corRaca"] = this.corRaca;
        data["comunidadeId"] = this.comunidadeId;
        data["comunidade"] = this.comunidade ? this.comunidade.toJSON() : <any>undefined;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        return data;
    }

    clone(): CreateCurriculoDadoPessoalDto {
        const json = this.toJSON();
        let result = new CreateCurriculoDadoPessoalDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCurriculoDadoPessoalDto {
    candidatoId: string;
    nome: string;
    cpf: string;
    rg: string;
    genero: Genero;
    dataNascimento: moment.Moment;
    email: string | undefined;
    telefone: string;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    fotoUrl: string | undefined;
    fotoTipo: string | undefined;
    fotoBase64: string | undefined;
    fotoTamanho: number;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTipo: string | undefined;
    arquivoBase64: string | undefined;
    arquivoTamanho: number;
    corRaca: CorRacaEnum;
    comunidadeId: string | undefined;
    comunidade: ComunidadeDto;
    endereco: EnderecoDto;
    naoPossuiEmail: boolean;
}

export class UpdateCurriculoDadoPessoalDto implements IUpdateCurriculoDadoPessoalDto {
    candidatoId: string;
    nome: string;
    cpf: string;
    rg: string;
    genero: Genero;
    dataNascimento: moment.Moment;
    email: string | undefined;
    telefone: string;
    numero: string | undefined;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    fotoUrl: string | undefined;
    fotoTipo: string | undefined;
    fotoBase64: string | undefined;
    fotoTamanho: number;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTipo: string | undefined;
    arquivoBase64: string | undefined;
    arquivoTamanho: number;
    corRaca: CorRacaEnum;
    comunidadeId: string | undefined;
    comunidade: ComunidadeDto;
    enderecoId: string | undefined;
    endereco: EnderecoDto;
    naoPossuiEmail: boolean;
    id: string;

    constructor(data?: IUpdateCurriculoDadoPessoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.rg = _data["rg"];
            this.genero = _data["genero"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.numero = _data["numero"];
            this.fotoNome = _data["fotoNome"];
            this.fotoExtensao = _data["fotoExtensao"];
            this.fotoUrl = _data["fotoUrl"];
            this.fotoTipo = _data["fotoTipo"];
            this.fotoBase64 = _data["fotoBase64"];
            this.fotoTamanho = _data["fotoTamanho"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTipo = _data["arquivoTipo"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.corRaca = _data["corRaca"];
            this.comunidadeId = _data["comunidadeId"];
            this.comunidade = _data["comunidade"] ? ComunidadeDto.fromJS(_data["comunidade"]) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.naoPossuiEmail = _data["naoPossuiEmail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCurriculoDadoPessoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurriculoDadoPessoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["rg"] = this.rg;
        data["genero"] = this.genero;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["numero"] = this.numero;
        data["fotoNome"] = this.fotoNome;
        data["fotoExtensao"] = this.fotoExtensao;
        data["fotoUrl"] = this.fotoUrl;
        data["fotoTipo"] = this.fotoTipo;
        data["fotoBase64"] = this.fotoBase64;
        data["fotoTamanho"] = this.fotoTamanho;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTipo"] = this.arquivoTipo;
        data["arquivoBase64"] = this.arquivoBase64;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["corRaca"] = this.corRaca;
        data["comunidadeId"] = this.comunidadeId;
        data["comunidade"] = this.comunidade ? this.comunidade.toJSON() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["naoPossuiEmail"] = this.naoPossuiEmail;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCurriculoDadoPessoalDto {
        const json = this.toJSON();
        let result = new UpdateCurriculoDadoPessoalDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCurriculoDadoPessoalDto {
    candidatoId: string;
    nome: string;
    cpf: string;
    rg: string;
    genero: Genero;
    dataNascimento: moment.Moment;
    email: string | undefined;
    telefone: string;
    numero: string | undefined;
    fotoNome: string | undefined;
    fotoExtensao: string | undefined;
    fotoUrl: string | undefined;
    fotoTipo: string | undefined;
    fotoBase64: string | undefined;
    fotoTamanho: number;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTipo: string | undefined;
    arquivoBase64: string | undefined;
    arquivoTamanho: number;
    corRaca: CorRacaEnum;
    comunidadeId: string | undefined;
    comunidade: ComunidadeDto;
    enderecoId: string | undefined;
    endereco: EnderecoDto;
    naoPossuiEmail: boolean;
    id: string;
}

export class CreateCurriculoDadoPessoalAnexoDto implements ICreateCurriculoDadoPessoalAnexoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;

    constructor(data?: ICreateCurriculoDadoPessoalAnexoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.arquivoTipo = _data["arquivoTipo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCurriculoDadoPessoalAnexoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCurriculoDadoPessoalAnexoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoBase64"] = this.arquivoBase64;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["arquivoTipo"] = this.arquivoTipo;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateCurriculoDadoPessoalAnexoDto {
        const json = this.toJSON();
        let result = new CreateCurriculoDadoPessoalAnexoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCurriculoDadoPessoalAnexoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;
}

export class UpdateCurriculoDadoPessoalAnexoDto implements IUpdateCurriculoDadoPessoalAnexoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;

    constructor(data?: IUpdateCurriculoDadoPessoalAnexoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.arquivoTipo = _data["arquivoTipo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCurriculoDadoPessoalAnexoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurriculoDadoPessoalAnexoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoBase64"] = this.arquivoBase64;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["arquivoTipo"] = this.arquivoTipo;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCurriculoDadoPessoalAnexoDto {
        const json = this.toJSON();
        let result = new UpdateCurriculoDadoPessoalAnexoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCurriculoDadoPessoalAnexoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;
}

export class UpdateCurriculoExperienciaDto implements IUpdateCurriculoExperienciaDto {
    candidatoId: string;
    titulo: string;
    tipoEmprego: TipoEmprego;
    regimeTrabalho: ModeloTrabalho;
    nomeEmpresa: string;
    cidade: string;
    uf: string;
    descricao: string | undefined;
    trabalhaAtualmente: boolean;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    id: string;

    constructor(data?: IUpdateCurriculoExperienciaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.titulo = _data["titulo"];
            this.tipoEmprego = _data["tipoEmprego"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.nomeEmpresa = _data["nomeEmpresa"];
            this.cidade = _data["cidade"];
            this.uf = _data["uf"];
            this.descricao = _data["descricao"];
            this.trabalhaAtualmente = _data["trabalhaAtualmente"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCurriculoExperienciaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurriculoExperienciaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["titulo"] = this.titulo;
        data["tipoEmprego"] = this.tipoEmprego;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["nomeEmpresa"] = this.nomeEmpresa;
        data["cidade"] = this.cidade;
        data["uf"] = this.uf;
        data["descricao"] = this.descricao;
        data["trabalhaAtualmente"] = this.trabalhaAtualmente;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCurriculoExperienciaDto {
        const json = this.toJSON();
        let result = new UpdateCurriculoExperienciaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCurriculoExperienciaDto {
    candidatoId: string;
    titulo: string;
    tipoEmprego: TipoEmprego;
    regimeTrabalho: ModeloTrabalho;
    nomeEmpresa: string;
    cidade: string;
    uf: string;
    descricao: string | undefined;
    trabalhaAtualmente: boolean;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    id: string;
}

export class CurriculoSkillConectaDtoPagedResultDto implements ICurriculoSkillConectaDtoPagedResultDto {
    totalCount: number;
    items: CurriculoSkillConectaDto[] | undefined;

    constructor(data?: ICurriculoSkillConectaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CurriculoSkillConectaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurriculoSkillConectaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculoSkillConectaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CurriculoSkillConectaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CurriculoSkillConectaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICurriculoSkillConectaDtoPagedResultDto {
    totalCount: number;
    items: CurriculoSkillConectaDto[] | undefined;
}

export class CreateCurriculoSkillConectaDto implements ICreateCurriculoSkillConectaDto {
    candidatoId: string;
    skillConectaId: string;

    constructor(data?: ICreateCurriculoSkillConectaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.skillConectaId = _data["skillConectaId"];
        }
    }

    static fromJS(data: any): CreateCurriculoSkillConectaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCurriculoSkillConectaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["skillConectaId"] = this.skillConectaId;
        return data;
    }

    clone(): CreateCurriculoSkillConectaDto {
        const json = this.toJSON();
        let result = new CreateCurriculoSkillConectaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCurriculoSkillConectaDto {
    candidatoId: string;
    skillConectaId: string;
}

export class CreateEmpresaDto implements ICreateEmpresaDto {
    razaoSocial: string;
    nome: string;
    cnpj: string;
    email: string;
    telefone: string;
    endereco: EnderecoDto;
    senha: string;
    aceitouTermos: boolean;
    comoConheceu: string;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;

    constructor(data?: ICreateEmpresaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.razaoSocial = _data["razaoSocial"];
            this.nome = _data["nome"];
            this.cnpj = _data["cnpj"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.senha = _data["senha"];
            this.aceitouTermos = _data["aceitouTermos"];
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.prestadoraServicoSuzano = _data["prestadoraServicoSuzano"];
            this.areaAtuacaoEmpresaEnum = _data["areaAtuacaoEmpresaEnum"];
        }
    }

    static fromJS(data: any): CreateEmpresaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmpresaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["razaoSocial"] = this.razaoSocial;
        data["nome"] = this.nome;
        data["cnpj"] = this.cnpj;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["senha"] = this.senha;
        data["aceitouTermos"] = this.aceitouTermos;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["prestadoraServicoSuzano"] = this.prestadoraServicoSuzano;
        data["areaAtuacaoEmpresaEnum"] = this.areaAtuacaoEmpresaEnum;
        return data;
    }

    clone(): CreateEmpresaDto {
        const json = this.toJSON();
        let result = new CreateEmpresaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmpresaDto {
    razaoSocial: string;
    nome: string;
    cnpj: string;
    email: string;
    telefone: string;
    endereco: EnderecoDto;
    senha: string;
    aceitouTermos: boolean;
    comoConheceu: string;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;
}

export class CreateEnderecoDto implements ICreateEnderecoDto {
    logradouro: string;
    bairro: string;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string | undefined;
    estado: string;
    microrregiaoId: string;

    constructor(data?: ICreateEnderecoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logradouro = _data["logradouro"];
            this.bairro = _data["bairro"];
            this.complemento = _data["complemento"];
            this.numero = _data["numero"];
            this.cep = _data["cep"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.microrregiaoId = _data["microrregiaoId"];
        }
    }

    static fromJS(data: any): CreateEnderecoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEnderecoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradouro"] = this.logradouro;
        data["bairro"] = this.bairro;
        data["complemento"] = this.complemento;
        data["numero"] = this.numero;
        data["cep"] = this.cep;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["microrregiaoId"] = this.microrregiaoId;
        return data;
    }

    clone(): CreateEnderecoDto {
        const json = this.toJSON();
        let result = new CreateEnderecoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEnderecoDto {
    logradouro: string;
    bairro: string;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string | undefined;
    estado: string;
    microrregiaoId: string;
}

export class CreateEmpresaEspecialDto implements ICreateEmpresaEspecialDto {
    nome: string;
    nomeUsuario: string;
    senha: string;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    endereco: CreateEnderecoDto;

    constructor(data?: ICreateEmpresaEspecialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeUsuario = _data["nomeUsuario"];
            this.senha = _data["senha"];
            this.nomeFotoPerfil = _data["nomeFotoPerfil"];
            this.extensaoFotoPerfil = _data["extensaoFotoPerfil"];
            this.base64FotoPerfil = _data["base64FotoPerfil"];
            this.endereco = _data["endereco"] ? CreateEnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEmpresaEspecialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmpresaEspecialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeUsuario"] = this.nomeUsuario;
        data["senha"] = this.senha;
        data["nomeFotoPerfil"] = this.nomeFotoPerfil;
        data["extensaoFotoPerfil"] = this.extensaoFotoPerfil;
        data["base64FotoPerfil"] = this.base64FotoPerfil;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateEmpresaEspecialDto {
        const json = this.toJSON();
        let result = new CreateEmpresaEspecialDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmpresaEspecialDto {
    nome: string;
    nomeUsuario: string;
    senha: string;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    endereco: CreateEnderecoDto;
}

export class EmpresaDtoPagedResultDto implements IEmpresaDtoPagedResultDto {
    totalCount: number;
    items: EmpresaDto[] | undefined;

    constructor(data?: IEmpresaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmpresaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmpresaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpresaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmpresaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmpresaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmpresaDtoPagedResultDto {
    totalCount: number;
    items: EmpresaDto[] | undefined;
}

export class UpdateEnderecoDto implements IUpdateEnderecoDto {
    logradouro: string;
    bairro: string;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string;
    estado: string;
    microrregiaoId: string;
    id: string;

    constructor(data?: IUpdateEnderecoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logradouro = _data["logradouro"];
            this.bairro = _data["bairro"];
            this.complemento = _data["complemento"];
            this.numero = _data["numero"];
            this.cep = _data["cep"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEnderecoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnderecoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradouro"] = this.logradouro;
        data["bairro"] = this.bairro;
        data["complemento"] = this.complemento;
        data["numero"] = this.numero;
        data["cep"] = this.cep;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["microrregiaoId"] = this.microrregiaoId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateEnderecoDto {
        const json = this.toJSON();
        let result = new UpdateEnderecoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEnderecoDto {
    logradouro: string;
    bairro: string;
    complemento: string | undefined;
    numero: string | undefined;
    cep: string | undefined;
    cidade: string;
    estado: string;
    microrregiaoId: string;
    id: string;
}

export class UpdateResponsavelDto implements IUpdateResponsavelDto {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;

    constructor(data?: IUpdateResponsavelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
        }
    }

    static fromJS(data: any): UpdateResponsavelDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponsavelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        return data;
    }

    clone(): UpdateResponsavelDto {
        const json = this.toJSON();
        let result = new UpdateResponsavelDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateResponsavelDto {
    nome: string;
    cpf: string;
    email: string;
    telefone: string;
}

export class UpdateEmpresaDto implements IUpdateEmpresaDto {
    razaoSocial: string;
    nome: string;
    cnpj: string;
    email: string;
    telefone: string;
    endereco: UpdateEnderecoDto;
    responsavel: UpdateResponsavelDto;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;
    enviarEmailNovoInscrito: boolean;
    id: string;

    constructor(data?: IUpdateEmpresaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.razaoSocial = _data["razaoSocial"];
            this.nome = _data["nome"];
            this.cnpj = _data["cnpj"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.endereco = _data["endereco"] ? UpdateEnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.responsavel = _data["responsavel"] ? UpdateResponsavelDto.fromJS(_data["responsavel"]) : <any>undefined;
            this.nomeFotoPerfil = _data["nomeFotoPerfil"];
            this.extensaoFotoPerfil = _data["extensaoFotoPerfil"];
            this.base64FotoPerfil = _data["base64FotoPerfil"];
            this.comoConheceu = _data["comoConheceu"];
            this.comoConheceuOutros = _data["comoConheceuOutros"];
            this.prestadoraServicoSuzano = _data["prestadoraServicoSuzano"];
            this.areaAtuacaoEmpresaEnum = _data["areaAtuacaoEmpresaEnum"];
            this.enviarEmailNovoInscrito = _data["enviarEmailNovoInscrito"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEmpresaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmpresaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["razaoSocial"] = this.razaoSocial;
        data["nome"] = this.nome;
        data["cnpj"] = this.cnpj;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["responsavel"] = this.responsavel ? this.responsavel.toJSON() : <any>undefined;
        data["nomeFotoPerfil"] = this.nomeFotoPerfil;
        data["extensaoFotoPerfil"] = this.extensaoFotoPerfil;
        data["base64FotoPerfil"] = this.base64FotoPerfil;
        data["comoConheceu"] = this.comoConheceu;
        data["comoConheceuOutros"] = this.comoConheceuOutros;
        data["prestadoraServicoSuzano"] = this.prestadoraServicoSuzano;
        data["areaAtuacaoEmpresaEnum"] = this.areaAtuacaoEmpresaEnum;
        data["enviarEmailNovoInscrito"] = this.enviarEmailNovoInscrito;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateEmpresaDto {
        const json = this.toJSON();
        let result = new UpdateEmpresaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmpresaDto {
    razaoSocial: string;
    nome: string;
    cnpj: string;
    email: string;
    telefone: string;
    endereco: UpdateEnderecoDto;
    responsavel: UpdateResponsavelDto;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    comoConheceu: string | undefined;
    comoConheceuOutros: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacaoEmpresaEnum: AreaAtuacaoEmpresaEnum;
    enviarEmailNovoInscrito: boolean;
    id: string;
}

export class UpdateEmpresaEspecialDto implements IUpdateEmpresaEspecialDto {
    nome: string;
    nomeUsuario: string;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    endereco: UpdateEnderecoDto;
    id: string;

    constructor(data?: IUpdateEmpresaEspecialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeUsuario = _data["nomeUsuario"];
            this.nomeFotoPerfil = _data["nomeFotoPerfil"];
            this.extensaoFotoPerfil = _data["extensaoFotoPerfil"];
            this.base64FotoPerfil = _data["base64FotoPerfil"];
            this.urlFotoPerfilDesbloqueado = _data["urlFotoPerfilDesbloqueado"];
            this.endereco = _data["endereco"] ? UpdateEnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEmpresaEspecialDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmpresaEspecialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeUsuario"] = this.nomeUsuario;
        data["nomeFotoPerfil"] = this.nomeFotoPerfil;
        data["extensaoFotoPerfil"] = this.extensaoFotoPerfil;
        data["base64FotoPerfil"] = this.base64FotoPerfil;
        data["urlFotoPerfilDesbloqueado"] = this.urlFotoPerfilDesbloqueado;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateEmpresaEspecialDto {
        const json = this.toJSON();
        let result = new UpdateEmpresaEspecialDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmpresaEspecialDto {
    nome: string;
    nomeUsuario: string;
    nomeFotoPerfil: string | undefined;
    extensaoFotoPerfil: string | undefined;
    base64FotoPerfil: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    endereco: UpdateEnderecoDto;
    id: string;
}

export class FiltroRelatorioEmpresasCadastradasDto implements IFiltroRelatorioEmpresasCadastradasDto {
    cnpj: string | undefined;
    razaoSocial: string | undefined;
    dataCadastroInicial: string | undefined;
    dataCadastroFinal: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacao: number | undefined;
    empresaEspecial: boolean;
    empresaExcluida: boolean;
    microrregioesId: string[] | undefined;

    constructor(data?: IFiltroRelatorioEmpresasCadastradasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cnpj = _data["cnpj"];
            this.razaoSocial = _data["razaoSocial"];
            this.dataCadastroInicial = _data["dataCadastroInicial"];
            this.dataCadastroFinal = _data["dataCadastroFinal"];
            this.prestadoraServicoSuzano = _data["prestadoraServicoSuzano"];
            this.areaAtuacao = _data["areaAtuacao"];
            this.empresaEspecial = _data["empresaEspecial"];
            this.empresaExcluida = _data["empresaExcluida"];
            if (Array.isArray(_data["microrregioesId"])) {
                this.microrregioesId = [] as any;
                for (let item of _data["microrregioesId"])
                    this.microrregioesId.push(item);
            }
        }
    }

    static fromJS(data: any): FiltroRelatorioEmpresasCadastradasDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiltroRelatorioEmpresasCadastradasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnpj"] = this.cnpj;
        data["razaoSocial"] = this.razaoSocial;
        data["dataCadastroInicial"] = this.dataCadastroInicial;
        data["dataCadastroFinal"] = this.dataCadastroFinal;
        data["prestadoraServicoSuzano"] = this.prestadoraServicoSuzano;
        data["areaAtuacao"] = this.areaAtuacao;
        data["empresaEspecial"] = this.empresaEspecial;
        data["empresaExcluida"] = this.empresaExcluida;
        if (Array.isArray(this.microrregioesId)) {
            data["microrregioesId"] = [];
            for (let item of this.microrregioesId)
                data["microrregioesId"].push(item);
        }
        return data;
    }

    clone(): FiltroRelatorioEmpresasCadastradasDto {
        const json = this.toJSON();
        let result = new FiltroRelatorioEmpresasCadastradasDto();
        result.init(json);
        return result;
    }
}

export interface IFiltroRelatorioEmpresasCadastradasDto {
    cnpj: string | undefined;
    razaoSocial: string | undefined;
    dataCadastroInicial: string | undefined;
    dataCadastroFinal: string | undefined;
    prestadoraServicoSuzano: boolean;
    areaAtuacao: number | undefined;
    empresaEspecial: boolean;
    empresaExcluida: boolean;
    microrregioesId: string[] | undefined;
}

export class EmpresaListDto implements IEmpresaListDto {
    nome: string | undefined;
    razaoSocial: string | undefined;
    cnpj: string | undefined;
    id: string;

    constructor(data?: IEmpresaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.razaoSocial = _data["razaoSocial"];
            this.cnpj = _data["cnpj"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmpresaListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpresaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["razaoSocial"] = this.razaoSocial;
        data["cnpj"] = this.cnpj;
        data["id"] = this.id;
        return data;
    }

    clone(): EmpresaListDto {
        const json = this.toJSON();
        let result = new EmpresaListDto();
        result.init(json);
        return result;
    }
}

export interface IEmpresaListDto {
    nome: string | undefined;
    razaoSocial: string | undefined;
    cnpj: string | undefined;
    id: string;
}

export class EnumDto implements IEnumDto {
    value: number;
    name: string | undefined;

    constructor(data?: IEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }

    clone(): EnumDto {
        const json = this.toJSON();
        let result = new EnumDto();
        result.init(json);
        return result;
    }
}

export interface IEnumDto {
    value: number;
    name: string | undefined;
}

export class EnumDtoListResultDto implements IEnumDtoListResultDto {
    items: EnumDto[] | undefined;

    constructor(data?: IEnumDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EnumDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnumDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): EnumDtoListResultDto {
        const json = this.toJSON();
        let result = new EnumDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IEnumDtoListResultDto {
    items: EnumDto[] | undefined;
}

export class HistoricoCandidatoVagaDto implements IHistoricoCandidatoVagaDto {
    candidatoVaga: CandidatoVagaDto;
    candidatoVagaId: string;
    estagioTriagem: EstagioTriagem;
    readonly estagioTriagemString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IHistoricoCandidatoVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoVaga = _data["candidatoVaga"] ? CandidatoVagaDto.fromJS(_data["candidatoVaga"]) : <any>undefined;
            this.candidatoVagaId = _data["candidatoVagaId"];
            this.estagioTriagem = _data["estagioTriagem"];
            (<any>this).estagioTriagemString = _data["estagioTriagemString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HistoricoCandidatoVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricoCandidatoVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoVaga"] = this.candidatoVaga ? this.candidatoVaga.toJSON() : <any>undefined;
        data["candidatoVagaId"] = this.candidatoVagaId;
        data["estagioTriagem"] = this.estagioTriagem;
        data["estagioTriagemString"] = this.estagioTriagemString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): HistoricoCandidatoVagaDto {
        const json = this.toJSON();
        let result = new HistoricoCandidatoVagaDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricoCandidatoVagaDto {
    candidatoVaga: CandidatoVagaDto;
    candidatoVagaId: string;
    estagioTriagem: EstagioTriagem;
    estagioTriagemString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateIdiomaDto implements ICreateIdiomaDto {
    nome: string;

    constructor(data?: ICreateIdiomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
        }
    }

    static fromJS(data: any): CreateIdiomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIdiomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        return data;
    }

    clone(): CreateIdiomaDto {
        const json = this.toJSON();
        let result = new CreateIdiomaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateIdiomaDto {
    nome: string;
}

export class UpdateIdiomaDto implements IUpdateIdiomaDto {
    nome: string;
    id: string;

    constructor(data?: IUpdateIdiomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateIdiomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIdiomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateIdiomaDto {
        const json = this.toJSON();
        let result = new UpdateIdiomaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateIdiomaDto {
    nome: string;
    id: string;
}

export class IdiomaDtoPagedResultDto implements IIdiomaDtoPagedResultDto {
    totalCount: number;
    items: IdiomaDto[] | undefined;

    constructor(data?: IIdiomaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IdiomaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdiomaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdiomaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): IdiomaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IdiomaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIdiomaDtoPagedResultDto {
    totalCount: number;
    items: IdiomaDto[] | undefined;
}

export class CreateLaudoMedicoDto implements ICreateLaudoMedicoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;

    constructor(data?: ICreateLaudoMedicoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidatoId = _data["candidatoId"];
            this.arquivoNome = _data["arquivoNome"];
            this.arquivoExtensao = _data["arquivoExtensao"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.arquivoUrl = _data["arquivoUrl"];
            this.arquivoTamanho = _data["arquivoTamanho"];
            this.arquivoTipo = _data["arquivoTipo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateLaudoMedicoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLaudoMedicoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidatoId"] = this.candidatoId;
        data["arquivoNome"] = this.arquivoNome;
        data["arquivoExtensao"] = this.arquivoExtensao;
        data["arquivoBase64"] = this.arquivoBase64;
        data["arquivoUrl"] = this.arquivoUrl;
        data["arquivoTamanho"] = this.arquivoTamanho;
        data["arquivoTipo"] = this.arquivoTipo;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateLaudoMedicoDto {
        const json = this.toJSON();
        let result = new CreateLaudoMedicoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLaudoMedicoDto {
    candidatoId: string;
    arquivoNome: string | undefined;
    arquivoExtensao: string | undefined;
    arquivoBase64: string | undefined;
    arquivoUrl: string | undefined;
    arquivoTamanho: number;
    arquivoTipo: string | undefined;
    id: string;
}

export class MicrorregiaoDto implements IMicrorregiaoDto {
    nome: string | undefined;
    cidades: CidadeMicrorregiaoDto[] | undefined;
    id: string;

    constructor(data?: IMicrorregiaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            if (Array.isArray(_data["cidades"])) {
                this.cidades = [] as any;
                for (let item of _data["cidades"])
                    this.cidades.push(CidadeMicrorregiaoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MicrorregiaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicrorregiaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        if (Array.isArray(this.cidades)) {
            data["cidades"] = [];
            for (let item of this.cidades)
                data["cidades"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): MicrorregiaoDto {
        const json = this.toJSON();
        let result = new MicrorregiaoDto();
        result.init(json);
        return result;
    }
}

export interface IMicrorregiaoDto {
    nome: string | undefined;
    cidades: CidadeMicrorregiaoDto[] | undefined;
    id: string;
}

export class CreateOnboardingCandidatoDto implements ICreateOnboardingCandidatoDto {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;

    constructor(data?: ICreateOnboardingCandidatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temSalarioOuRenda = _data["temSalarioOuRenda"];
            this.valorSalario = _data["valorSalario"];
            this.temBeneficioGoverno = _data["temBeneficioGoverno"];
            this.valorBeneficio = _data["valorBeneficio"];
            this.valorRendaFamiliar = _data["valorRendaFamiliar"];
            this.candidatoId = _data["candidatoId"];
        }
    }

    static fromJS(data: any): CreateOnboardingCandidatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOnboardingCandidatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temSalarioOuRenda"] = this.temSalarioOuRenda;
        data["valorSalario"] = this.valorSalario;
        data["temBeneficioGoverno"] = this.temBeneficioGoverno;
        data["valorBeneficio"] = this.valorBeneficio;
        data["valorRendaFamiliar"] = this.valorRendaFamiliar;
        data["candidatoId"] = this.candidatoId;
        return data;
    }

    clone(): CreateOnboardingCandidatoDto {
        const json = this.toJSON();
        let result = new CreateOnboardingCandidatoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOnboardingCandidatoDto {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;
}

export class UpdateOnboardingCandidatoDto implements IUpdateOnboardingCandidatoDto {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;

    constructor(data?: IUpdateOnboardingCandidatoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temSalarioOuRenda = _data["temSalarioOuRenda"];
            this.valorSalario = _data["valorSalario"];
            this.temBeneficioGoverno = _data["temBeneficioGoverno"];
            this.valorBeneficio = _data["valorBeneficio"];
            this.valorRendaFamiliar = _data["valorRendaFamiliar"];
            this.candidatoId = _data["candidatoId"];
        }
    }

    static fromJS(data: any): UpdateOnboardingCandidatoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOnboardingCandidatoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temSalarioOuRenda"] = this.temSalarioOuRenda;
        data["valorSalario"] = this.valorSalario;
        data["temBeneficioGoverno"] = this.temBeneficioGoverno;
        data["valorBeneficio"] = this.valorBeneficio;
        data["valorRendaFamiliar"] = this.valorRendaFamiliar;
        data["candidatoId"] = this.candidatoId;
        return data;
    }

    clone(): UpdateOnboardingCandidatoDto {
        const json = this.toJSON();
        let result = new UpdateOnboardingCandidatoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOnboardingCandidatoDto {
    temSalarioOuRenda: boolean;
    valorSalario: number | undefined;
    temBeneficioGoverno: boolean;
    valorBeneficio: number | undefined;
    valorRendaFamiliar: number;
    candidatoId: string;
}

export class RegiaoDto implements IRegiaoDto {
    nome: string | undefined;
    microrregioes: MicrorregiaoDto[] | undefined;
    id: string;

    constructor(data?: IRegiaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            if (Array.isArray(_data["microrregioes"])) {
                this.microrregioes = [] as any;
                for (let item of _data["microrregioes"])
                    this.microrregioes.push(MicrorregiaoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegiaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegiaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        if (Array.isArray(this.microrregioes)) {
            data["microrregioes"] = [];
            for (let item of this.microrregioes)
                data["microrregioes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): RegiaoDto {
        const json = this.toJSON();
        let result = new RegiaoDto();
        result.init(json);
        return result;
    }
}

export interface IRegiaoDto {
    nome: string | undefined;
    microrregioes: MicrorregiaoDto[] | undefined;
    id: string;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class CreateSkillConectaDto implements ICreateSkillConectaDto {
    nome: string;

    constructor(data?: ICreateSkillConectaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
        }
    }

    static fromJS(data: any): CreateSkillConectaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSkillConectaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        return data;
    }

    clone(): CreateSkillConectaDto {
        const json = this.toJSON();
        let result = new CreateSkillConectaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSkillConectaDto {
    nome: string;
}

export class UpdateSkillConectaDto implements IUpdateSkillConectaDto {
    nome: string;
    id: string;

    constructor(data?: IUpdateSkillConectaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateSkillConectaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSkillConectaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateSkillConectaDto {
        const json = this.toJSON();
        let result = new UpdateSkillConectaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSkillConectaDto {
    nome: string;
    id: string;
}

export class SkillConectaDtoPagedResultDto implements ISkillConectaDtoPagedResultDto {
    totalCount: number;
    items: SkillConectaDto[] | undefined;

    constructor(data?: ISkillConectaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SkillConectaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkillConectaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkillConectaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): SkillConectaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SkillConectaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISkillConectaDtoPagedResultDto {
    totalCount: number;
    items: SkillConectaDto[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;
}

export enum TipoTermoEnum {
    _0 = 0,
    _1 = 1,
}

export class CreateTermoDto implements ICreateTermoDto {
    tipo: TipoTermoEnum;
    texto: string;

    constructor(data?: ICreateTermoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"];
            this.texto = _data["texto"];
        }
    }

    static fromJS(data: any): CreateTermoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTermoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo;
        data["texto"] = this.texto;
        return data;
    }

    clone(): CreateTermoDto {
        const json = this.toJSON();
        let result = new CreateTermoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTermoDto {
    tipo: TipoTermoEnum;
    texto: string;
}

export class TermoDto implements ITermoDto {
    tipo: TipoTermoEnum;
    texto: string | undefined;
    versao: number;
    creationTime: moment.Moment;
    readonly tipoString: string | undefined;
    id: string;

    constructor(data?: ITermoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"];
            this.texto = _data["texto"];
            this.versao = _data["versao"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            (<any>this).tipoString = _data["tipoString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TermoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo;
        data["texto"] = this.texto;
        data["versao"] = this.versao;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["tipoString"] = this.tipoString;
        data["id"] = this.id;
        return data;
    }

    clone(): TermoDto {
        const json = this.toJSON();
        let result = new TermoDto();
        result.init(json);
        return result;
    }
}

export interface ITermoDto {
    tipo: TipoTermoEnum;
    texto: string | undefined;
    versao: number;
    creationTime: moment.Moment;
    tipoString: string | undefined;
    id: string;
}

export class TermoDtoPagedResultDto implements ITermoDtoPagedResultDto {
    totalCount: number;
    items: TermoDto[] | undefined;

    constructor(data?: ITermoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TermoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TermoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TermoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TermoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITermoDtoPagedResultDto {
    totalCount: number;
    items: TermoDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class PerfilUsuarioModel implements IPerfilUsuarioModel {
    isEmpresa: boolean;
    isCandidato: boolean;

    constructor(data?: IPerfilUsuarioModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmpresa = _data["isEmpresa"];
            this.isCandidato = _data["isCandidato"];
        }
    }

    static fromJS(data: any): PerfilUsuarioModel {
        data = typeof data === 'object' ? data : {};
        let result = new PerfilUsuarioModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmpresa"] = this.isEmpresa;
        data["isCandidato"] = this.isCandidato;
        return data;
    }

    clone(): PerfilUsuarioModel {
        const json = this.toJSON();
        let result = new PerfilUsuarioModel();
        result.init(json);
        return result;
    }
}

export interface IPerfilUsuarioModel {
    isEmpresa: boolean;
    isCandidato: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    perfilUsuario: PerfilUsuarioModel;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.perfilUsuario = _data["perfilUsuario"] ? PerfilUsuarioModel.fromJS(_data["perfilUsuario"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["perfilUsuario"] = this.perfilUsuario ? this.perfilUsuario.toJSON() : <any>undefined;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    perfilUsuario: PerfilUsuarioModel;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export class VagaDtoPagedResultDto implements IVagaDtoPagedResultDto {
    totalCount: number;
    items: VagaDto[] | undefined;

    constructor(data?: IVagaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VagaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VagaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VagaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): VagaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VagaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVagaDtoPagedResultDto {
    totalCount: number;
    items: VagaDto[] | undefined;
}

export class CreateVagaDto implements ICreateVagaDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    statusVaga: StatusVaga;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    emailEnviado: boolean;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;

    constructor(data?: ICreateVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargoId = _data["cargoId"];
            this.cargo = _data["cargo"] ? CargoDto.fromJS(_data["cargo"]) : <any>undefined;
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.exibirVagas = _data["exibirVagas"];
            this.exibirSalario = _data["exibirSalario"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.pcd = _data["pcd"];
            this.rascunho = _data["rascunho"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            this.statusVaga = _data["statusVaga"];
            if (Array.isArray(_data["competenciasId"])) {
                this.competenciasId = [] as any;
                for (let item of _data["competenciasId"])
                    this.competenciasId.push(item);
            }
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            if (Array.isArray(_data["avaliacoesRequisitosVaga"])) {
                this.avaliacoesRequisitosVaga = [] as any;
                for (let item of _data["avaliacoesRequisitosVaga"])
                    this.avaliacoesRequisitosVaga.push(CreateAvaliacaoRequisitoVagaDto.fromJS(item));
            }
            this.emailEnviado = _data["emailEnviado"];
            this.statusVagaUltimaAtualizacao = _data["statusVagaUltimaAtualizacao"] ? moment(_data["statusVagaUltimaAtualizacao"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargoId"] = this.cargoId;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["exibirVagas"] = this.exibirVagas;
        data["exibirSalario"] = this.exibirSalario;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["pcd"] = this.pcd;
        data["rascunho"] = this.rascunho;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        data["statusVaga"] = this.statusVaga;
        if (Array.isArray(this.competenciasId)) {
            data["competenciasId"] = [];
            for (let item of this.competenciasId)
                data["competenciasId"].push(item);
        }
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        if (Array.isArray(this.avaliacoesRequisitosVaga)) {
            data["avaliacoesRequisitosVaga"] = [];
            for (let item of this.avaliacoesRequisitosVaga)
                data["avaliacoesRequisitosVaga"].push(item.toJSON());
        }
        data["emailEnviado"] = this.emailEnviado;
        data["statusVagaUltimaAtualizacao"] = this.statusVagaUltimaAtualizacao ? this.statusVagaUltimaAtualizacao.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateVagaDto {
        const json = this.toJSON();
        let result = new CreateVagaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVagaDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    statusVaga: StatusVaga;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    emailEnviado: boolean;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
}

export class CreateRascunhoDto implements ICreateRascunhoDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    statusVaga: StatusVaga;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    emailEnviado: boolean;

    constructor(data?: ICreateRascunhoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargoId = _data["cargoId"];
            this.cargo = _data["cargo"] ? CargoDto.fromJS(_data["cargo"]) : <any>undefined;
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.exibirVagas = _data["exibirVagas"];
            this.exibirSalario = _data["exibirSalario"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.pcd = _data["pcd"];
            this.rascunho = _data["rascunho"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            this.statusVaga = _data["statusVaga"];
            this.statusVagaUltimaAtualizacao = _data["statusVagaUltimaAtualizacao"] ? moment(_data["statusVagaUltimaAtualizacao"].toString()) : <any>undefined;
            if (Array.isArray(_data["competenciasId"])) {
                this.competenciasId = [] as any;
                for (let item of _data["competenciasId"])
                    this.competenciasId.push(item);
            }
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            if (Array.isArray(_data["avaliacoesRequisitosVaga"])) {
                this.avaliacoesRequisitosVaga = [] as any;
                for (let item of _data["avaliacoesRequisitosVaga"])
                    this.avaliacoesRequisitosVaga.push(CreateAvaliacaoRequisitoVagaDto.fromJS(item));
            }
            this.emailEnviado = _data["emailEnviado"];
        }
    }

    static fromJS(data: any): CreateRascunhoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRascunhoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargoId"] = this.cargoId;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["exibirVagas"] = this.exibirVagas;
        data["exibirSalario"] = this.exibirSalario;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["pcd"] = this.pcd;
        data["rascunho"] = this.rascunho;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        data["statusVaga"] = this.statusVaga;
        data["statusVagaUltimaAtualizacao"] = this.statusVagaUltimaAtualizacao ? this.statusVagaUltimaAtualizacao.toISOString() : <any>undefined;
        if (Array.isArray(this.competenciasId)) {
            data["competenciasId"] = [];
            for (let item of this.competenciasId)
                data["competenciasId"].push(item);
        }
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        if (Array.isArray(this.avaliacoesRequisitosVaga)) {
            data["avaliacoesRequisitosVaga"] = [];
            for (let item of this.avaliacoesRequisitosVaga)
                data["avaliacoesRequisitosVaga"].push(item.toJSON());
        }
        data["emailEnviado"] = this.emailEnviado;
        return data;
    }

    clone(): CreateRascunhoDto {
        const json = this.toJSON();
        let result = new CreateRascunhoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRascunhoDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    statusVaga: StatusVaga;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    emailEnviado: boolean;
}

export class UpdateRascunhoDto implements IUpdateRascunhoDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    statusVaga: StatusVaga;
    id: string;

    constructor(data?: IUpdateRascunhoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargoId = _data["cargoId"];
            this.cargo = _data["cargo"] ? CargoDto.fromJS(_data["cargo"]) : <any>undefined;
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.exibirVagas = _data["exibirVagas"];
            this.exibirSalario = _data["exibirSalario"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.encerrada = _data["encerrada"];
            this.pcd = _data["pcd"];
            this.rascunho = _data["rascunho"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            if (Array.isArray(_data["competenciasId"])) {
                this.competenciasId = [] as any;
                for (let item of _data["competenciasId"])
                    this.competenciasId.push(item);
            }
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            if (Array.isArray(_data["avaliacoesRequisitosVaga"])) {
                this.avaliacoesRequisitosVaga = [] as any;
                for (let item of _data["avaliacoesRequisitosVaga"])
                    this.avaliacoesRequisitosVaga.push(CreateAvaliacaoRequisitoVagaDto.fromJS(item));
            }
            this.statusVaga = _data["statusVaga"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateRascunhoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRascunhoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargoId"] = this.cargoId;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["exibirVagas"] = this.exibirVagas;
        data["exibirSalario"] = this.exibirSalario;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["encerrada"] = this.encerrada;
        data["pcd"] = this.pcd;
        data["rascunho"] = this.rascunho;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        if (Array.isArray(this.competenciasId)) {
            data["competenciasId"] = [];
            for (let item of this.competenciasId)
                data["competenciasId"].push(item);
        }
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        if (Array.isArray(this.avaliacoesRequisitosVaga)) {
            data["avaliacoesRequisitosVaga"] = [];
            for (let item of this.avaliacoesRequisitosVaga)
                data["avaliacoesRequisitosVaga"].push(item.toJSON());
        }
        data["statusVaga"] = this.statusVaga;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateRascunhoDto {
        const json = this.toJSON();
        let result = new UpdateRascunhoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRascunhoDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    statusVaga: StatusVaga;
    id: string;
}

export class CreateVagaEspecialDto implements ICreateVagaEspecialDto {
    empresaId: string;
    tituloVaga: string;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargoId: string | undefined;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    pcd: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    rascunho: boolean;
    emailEnviado: boolean;
    urlVaga: string;
    vagaEspecial: boolean;
    statusVaga: StatusVaga;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;

    constructor(data?: ICreateVagaEspecialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargoId = _data["cargoId"];
            this.cargo = _data["cargo"] ? CargoDto.fromJS(_data["cargo"]) : <any>undefined;
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.exibirVagas = _data["exibirVagas"];
            this.exibirSalario = _data["exibirSalario"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.pcd = _data["pcd"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            if (Array.isArray(_data["competenciasId"])) {
                this.competenciasId = [] as any;
                for (let item of _data["competenciasId"])
                    this.competenciasId.push(item);
            }
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            this.rascunho = _data["rascunho"];
            this.emailEnviado = _data["emailEnviado"];
            this.urlVaga = _data["urlVaga"];
            this.vagaEspecial = _data["vagaEspecial"];
            this.statusVaga = _data["statusVaga"];
            this.statusVagaUltimaAtualizacao = _data["statusVagaUltimaAtualizacao"] ? moment(_data["statusVagaUltimaAtualizacao"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateVagaEspecialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVagaEspecialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargoId"] = this.cargoId;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["exibirVagas"] = this.exibirVagas;
        data["exibirSalario"] = this.exibirSalario;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["pcd"] = this.pcd;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        if (Array.isArray(this.competenciasId)) {
            data["competenciasId"] = [];
            for (let item of this.competenciasId)
                data["competenciasId"].push(item);
        }
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        data["rascunho"] = this.rascunho;
        data["emailEnviado"] = this.emailEnviado;
        data["urlVaga"] = this.urlVaga;
        data["vagaEspecial"] = this.vagaEspecial;
        data["statusVaga"] = this.statusVaga;
        data["statusVagaUltimaAtualizacao"] = this.statusVagaUltimaAtualizacao ? this.statusVagaUltimaAtualizacao.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateVagaEspecialDto {
        const json = this.toJSON();
        let result = new CreateVagaEspecialDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVagaEspecialDto {
    empresaId: string;
    tituloVaga: string;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargoId: string | undefined;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    pcd: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    rascunho: boolean;
    emailEnviado: boolean;
    urlVaga: string;
    vagaEspecial: boolean;
    statusVaga: StatusVaga;
    statusVagaUltimaAtualizacao: moment.Moment | undefined;
}

export class UpdateVagaDto implements IUpdateVagaDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    statusVaga: StatusVaga;
    id: string;

    constructor(data?: IUpdateVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargoId = _data["cargoId"];
            this.cargo = _data["cargo"] ? CargoDto.fromJS(_data["cargo"]) : <any>undefined;
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.exibirVagas = _data["exibirVagas"];
            this.exibirSalario = _data["exibirSalario"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.encerrada = _data["encerrada"];
            this.pcd = _data["pcd"];
            this.rascunho = _data["rascunho"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            if (Array.isArray(_data["competenciasId"])) {
                this.competenciasId = [] as any;
                for (let item of _data["competenciasId"])
                    this.competenciasId.push(item);
            }
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            if (Array.isArray(_data["avaliacoesRequisitosVaga"])) {
                this.avaliacoesRequisitosVaga = [] as any;
                for (let item of _data["avaliacoesRequisitosVaga"])
                    this.avaliacoesRequisitosVaga.push(CreateAvaliacaoRequisitoVagaDto.fromJS(item));
            }
            this.statusVaga = _data["statusVaga"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargoId"] = this.cargoId;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["exibirVagas"] = this.exibirVagas;
        data["exibirSalario"] = this.exibirSalario;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["encerrada"] = this.encerrada;
        data["pcd"] = this.pcd;
        data["rascunho"] = this.rascunho;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        if (Array.isArray(this.competenciasId)) {
            data["competenciasId"] = [];
            for (let item of this.competenciasId)
                data["competenciasId"].push(item);
        }
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        if (Array.isArray(this.avaliacoesRequisitosVaga)) {
            data["avaliacoesRequisitosVaga"] = [];
            for (let item of this.avaliacoesRequisitosVaga)
                data["avaliacoesRequisitosVaga"].push(item.toJSON());
        }
        data["statusVaga"] = this.statusVaga;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateVagaDto {
        const json = this.toJSON();
        let result = new UpdateVagaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVagaDto {
    empresaId: string;
    tituloVaga: string;
    estado: string;
    cidade: string;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string;
    cargoId: string;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    avaliacoesRequisitosVaga: CreateAvaliacaoRequisitoVagaDto[] | undefined;
    statusVaga: StatusVaga;
    id: string;
}

export class UpdateVagaEspecialDto implements IUpdateVagaEspecialDto {
    empresaId: string;
    tituloVaga: string;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargoId: string | undefined;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    urlVaga: string;
    vagaEspecial: boolean;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    statusVaga: StatusVaga;
    id: string;

    constructor(data?: IUpdateVagaEspecialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empresaId = _data["empresaId"];
            this.tituloVaga = _data["tituloVaga"];
            this.estado = _data["estado"];
            this.cidade = _data["cidade"];
            this.bairro = _data["bairro"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.regimeTrabalho = _data["regimeTrabalho"];
            this.salario = _data["salario"];
            this.horasSemanais = _data["horasSemanais"];
            this.cargoId = _data["cargoId"];
            this.cargo = _data["cargo"] ? CargoDto.fromJS(_data["cargo"]) : <any>undefined;
            this.modeloTrabalho = _data["modeloTrabalho"];
            this.exibirVagas = _data["exibirVagas"];
            this.exibirSalario = _data["exibirSalario"];
            this.quantidadeVagas = _data["quantidadeVagas"];
            this.descricao = _data["descricao"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
            this.encerrada = _data["encerrada"];
            this.pcd = _data["pcd"];
            this.rascunho = _data["rascunho"];
            this.confidencial = _data["confidencial"];
            this.emailGestor = _data["emailGestor"];
            this.urlVaga = _data["urlVaga"];
            this.vagaEspecial = _data["vagaEspecial"];
            if (Array.isArray(_data["competenciasId"])) {
                this.competenciasId = [] as any;
                for (let item of _data["competenciasId"])
                    this.competenciasId.push(item);
            }
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            this.statusVaga = _data["statusVaga"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateVagaEspecialDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVagaEspecialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empresaId"] = this.empresaId;
        data["tituloVaga"] = this.tituloVaga;
        data["estado"] = this.estado;
        data["cidade"] = this.cidade;
        data["bairro"] = this.bairro;
        data["microrregiaoId"] = this.microrregiaoId;
        data["regimeTrabalho"] = this.regimeTrabalho;
        data["salario"] = this.salario;
        data["horasSemanais"] = this.horasSemanais;
        data["cargoId"] = this.cargoId;
        data["cargo"] = this.cargo ? this.cargo.toJSON() : <any>undefined;
        data["modeloTrabalho"] = this.modeloTrabalho;
        data["exibirVagas"] = this.exibirVagas;
        data["exibirSalario"] = this.exibirSalario;
        data["quantidadeVagas"] = this.quantidadeVagas;
        data["descricao"] = this.descricao;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        data["encerrada"] = this.encerrada;
        data["pcd"] = this.pcd;
        data["rascunho"] = this.rascunho;
        data["confidencial"] = this.confidencial;
        data["emailGestor"] = this.emailGestor;
        data["urlVaga"] = this.urlVaga;
        data["vagaEspecial"] = this.vagaEspecial;
        if (Array.isArray(this.competenciasId)) {
            data["competenciasId"] = [];
            for (let item of this.competenciasId)
                data["competenciasId"].push(item);
        }
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        data["statusVaga"] = this.statusVaga;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateVagaEspecialDto {
        const json = this.toJSON();
        let result = new UpdateVagaEspecialDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVagaEspecialDto {
    empresaId: string;
    tituloVaga: string;
    estado: string | undefined;
    cidade: string | undefined;
    bairro: string | undefined;
    microrregiaoId: string | undefined;
    regimeTrabalho: RegimeTrabalho;
    salario: number | undefined;
    horasSemanais: string | undefined;
    cargoId: string | undefined;
    cargo: CargoDto;
    modeloTrabalho: ModeloTrabalho;
    exibirVagas: boolean;
    exibirSalario: boolean | undefined;
    quantidadeVagas: string | undefined;
    descricao: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
    encerrada: boolean;
    pcd: boolean;
    rascunho: boolean;
    confidencial: boolean;
    emailGestor: string | undefined;
    urlVaga: string;
    vagaEspecial: boolean;
    competenciasId: string[] | undefined;
    competencias: CompetenciaDto[] | undefined;
    statusVaga: StatusVaga;
    id: string;
}

export class VagaSimplificadaDto implements IVagaSimplificadaDto {
    confidencial: boolean;
    empresaNome: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    cargoNome: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    bairro: string | undefined;
    descricao: string | undefined;
    competencias: CompetenciaDto[] | undefined;
    modeloTrabalhoString: string | undefined;
    regimeTrabalhoString: string | undefined;
    salario: number | undefined;
    exibirSalario: boolean | undefined;
    pcd: boolean;
    microrregiaoId: string | undefined;
    horasSemanais: string | undefined;
    vagaEspecial: boolean;
    encerrada: boolean;
    urlVaga: string | undefined;
    avaliacoesRequisitosVaga: AvaliacaoRequisitoVaga[] | undefined;
    id: string;

    constructor(data?: IVagaSimplificadaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confidencial = _data["confidencial"];
            this.empresaNome = _data["empresaNome"];
            this.urlFotoPerfilDesbloqueado = _data["urlFotoPerfilDesbloqueado"];
            this.cargoNome = _data["cargoNome"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.bairro = _data["bairro"];
            this.descricao = _data["descricao"];
            if (Array.isArray(_data["competencias"])) {
                this.competencias = [] as any;
                for (let item of _data["competencias"])
                    this.competencias.push(CompetenciaDto.fromJS(item));
            }
            this.modeloTrabalhoString = _data["modeloTrabalhoString"];
            this.regimeTrabalhoString = _data["regimeTrabalhoString"];
            this.salario = _data["salario"];
            this.exibirSalario = _data["exibirSalario"];
            this.pcd = _data["pcd"];
            this.microrregiaoId = _data["microrregiaoId"];
            this.horasSemanais = _data["horasSemanais"];
            this.vagaEspecial = _data["vagaEspecial"];
            this.encerrada = _data["encerrada"];
            this.urlVaga = _data["urlVaga"];
            if (Array.isArray(_data["avaliacoesRequisitosVaga"])) {
                this.avaliacoesRequisitosVaga = [] as any;
                for (let item of _data["avaliacoesRequisitosVaga"])
                    this.avaliacoesRequisitosVaga.push(AvaliacaoRequisitoVaga.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VagaSimplificadaDto {
        data = typeof data === 'object' ? data : {};
        let result = new VagaSimplificadaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confidencial"] = this.confidencial;
        data["empresaNome"] = this.empresaNome;
        data["urlFotoPerfilDesbloqueado"] = this.urlFotoPerfilDesbloqueado;
        data["cargoNome"] = this.cargoNome;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["bairro"] = this.bairro;
        data["descricao"] = this.descricao;
        if (Array.isArray(this.competencias)) {
            data["competencias"] = [];
            for (let item of this.competencias)
                data["competencias"].push(item.toJSON());
        }
        data["modeloTrabalhoString"] = this.modeloTrabalhoString;
        data["regimeTrabalhoString"] = this.regimeTrabalhoString;
        data["salario"] = this.salario;
        data["exibirSalario"] = this.exibirSalario;
        data["pcd"] = this.pcd;
        data["microrregiaoId"] = this.microrregiaoId;
        data["horasSemanais"] = this.horasSemanais;
        data["vagaEspecial"] = this.vagaEspecial;
        data["encerrada"] = this.encerrada;
        data["urlVaga"] = this.urlVaga;
        if (Array.isArray(this.avaliacoesRequisitosVaga)) {
            data["avaliacoesRequisitosVaga"] = [];
            for (let item of this.avaliacoesRequisitosVaga)
                data["avaliacoesRequisitosVaga"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): VagaSimplificadaDto {
        const json = this.toJSON();
        let result = new VagaSimplificadaDto();
        result.init(json);
        return result;
    }
}

export interface IVagaSimplificadaDto {
    confidencial: boolean;
    empresaNome: string | undefined;
    urlFotoPerfilDesbloqueado: string | undefined;
    cargoNome: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    bairro: string | undefined;
    descricao: string | undefined;
    competencias: CompetenciaDto[] | undefined;
    modeloTrabalhoString: string | undefined;
    regimeTrabalhoString: string | undefined;
    salario: number | undefined;
    exibirSalario: boolean | undefined;
    pcd: boolean;
    microrregiaoId: string | undefined;
    horasSemanais: string | undefined;
    vagaEspecial: boolean;
    encerrada: boolean;
    urlVaga: string | undefined;
    avaliacoesRequisitosVaga: AvaliacaoRequisitoVaga[] | undefined;
    id: string;
}

export class VagasVitrineDto implements IVagasVitrineDto {
    vagasMicrorregiao: VagaSimplificadaDto[] | undefined;
    vagasGeral: VagaSimplificadaDto[] | undefined;
    total: number;

    constructor(data?: IVagasVitrineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vagasMicrorregiao"])) {
                this.vagasMicrorregiao = [] as any;
                for (let item of _data["vagasMicrorregiao"])
                    this.vagasMicrorregiao.push(VagaSimplificadaDto.fromJS(item));
            }
            if (Array.isArray(_data["vagasGeral"])) {
                this.vagasGeral = [] as any;
                for (let item of _data["vagasGeral"])
                    this.vagasGeral.push(VagaSimplificadaDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): VagasVitrineDto {
        data = typeof data === 'object' ? data : {};
        let result = new VagasVitrineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vagasMicrorregiao)) {
            data["vagasMicrorregiao"] = [];
            for (let item of this.vagasMicrorregiao)
                data["vagasMicrorregiao"].push(item.toJSON());
        }
        if (Array.isArray(this.vagasGeral)) {
            data["vagasGeral"] = [];
            for (let item of this.vagasGeral)
                data["vagasGeral"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }

    clone(): VagasVitrineDto {
        const json = this.toJSON();
        let result = new VagasVitrineDto();
        result.init(json);
        return result;
    }
}

export interface IVagasVitrineDto {
    vagasMicrorregiao: VagaSimplificadaDto[] | undefined;
    vagasGeral: VagaSimplificadaDto[] | undefined;
    total: number;
}

export class ReaberturaVagaDto implements IReaberturaVagaDto {
    vagaId: string;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;

    constructor(data?: IReaberturaVagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vagaId = _data["vagaId"];
            this.dataTermino = _data["dataTermino"] ? moment(_data["dataTermino"].toString()) : <any>undefined;
            this.dataTerminoInscricoes = _data["dataTerminoInscricoes"] ? moment(_data["dataTerminoInscricoes"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReaberturaVagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReaberturaVagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vagaId"] = this.vagaId;
        data["dataTermino"] = this.dataTermino ? this.dataTermino.toISOString() : <any>undefined;
        data["dataTerminoInscricoes"] = this.dataTerminoInscricoes ? this.dataTerminoInscricoes.toISOString() : <any>undefined;
        return data;
    }

    clone(): ReaberturaVagaDto {
        const json = this.toJSON();
        let result = new ReaberturaVagaDto();
        result.init(json);
        return result;
    }
}

export interface IReaberturaVagaDto {
    vagaId: string;
    dataTermino: moment.Moment | undefined;
    dataTerminoInscricoes: moment.Moment | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}